// GENERATED CODE -- DO NOT EDIT!
// To re-generate this file:
// start local dev server (w/ backend turned on)
// go run ./services/rewards/cmd/generate-translations
import {t} from "@lingui/core/macro";
import memoize from "lodash.memoize";

import type {BadgeInfo} from "../badge-translations.ts";

export const getContextNoneBadges: () => Record<string, BadgeInfo> = memoize(
    (): Record<string, BadgeInfo> => ({
        summerofscriptstudent: {
            description: t`Summer of Scripting Student (2015)`,
            extendedDescription: t`Enroll for the Summer of Scripting of 2015`,
        },
        satpracticetest1badge: {
            description: t`SAT Practice Test 1`,
            extendedDescription: t`Complete practice test 1`,
        },
        satpracticetest2badge: {
            description: t`SAT Practice Test 2`,
            extendedDescription: t`Complete practice test 2`,
        },
        satpracticetest3badge: {
            description: t`SAT Practice Test 3`,
            extendedDescription: t`Complete practice test 3`,
        },
        satpracticetest4badge: {
            description: t`SAT Practice Test 4`,
            extendedDescription: t`Complete practice test 4`,
        },
        satpracticetest5badge: {
            description: t`SAT Practice Test 5`,
            extendedDescription: t`Complete practice test 5`,
        },
        satpracticetest6badge: {
            description: t`SAT Practice Test 6`,
            extendedDescription: t`Complete practice test 6`,
        },
        satpracticetest7badge: {
            description: t`SAT Practice Test 7`,
            extendedDescription: t`Complete practice test 7`,
        },
        satpracticetest8badge: {
            description: t`SAT Practice Test 8`,
            extendedDescription: t`Complete practice test 8`,
        },
        satpracticetestdaybadge: {
            description: t`Official SAT Practice Test Day`,
            extendedDescription: t`Complete a practice test on an Official SAT Practice Test Day`,
        },
        sattrailblazerbadge: {
            description: t`SAT Trailblazer`,
            extendedDescription: t`Complete a practice SAT exam before our official launch`,
        },
        satmathlivebadge: {
            description: t`SAT Live Math Class`,
            extendedDescription: t`Attend the SAT Live Math Class`,
        },
        satreadinglivebadge: {
            description: t`SAT Live Reading Class`,
            extendedDescription: t`Attend the SAT Live Reading Class`,
        },
        satwritinglivebadge: {
            description: t`SAT Live Writing Class`,
            extendedDescription: t`Attend the SAT Live Writing Class`,
        },
        satcompleted: {
            description: t`SAT`,
            extendedDescription: t`Complete the SAT`,
        },
        psatnmsqtcompleted: {
            description: t`PSAT/NMSQT`,
            extendedDescription: t`Complete the PSAT/NMSQT`,
        },
        psat10completed: {
            description: t`PSAT 10`,
            extendedDescription: t`Complete the PSAT 10`,
        },
        psat89completed: {
            description: t`PSAT 8/9`,
            extendedDescription: t`Complete the PSAT 8/9`,
        },
        yearonebadge: {
            description: t`Cypress`,
            extendedDescription: t`Remain a member of Khan Academy for 1 year`,
        },
        yeartwobadge: {
            description: t`Redwood`,
            extendedDescription: t`Remain a member of Khan Academy for 2 years`,
        },
        yearthreebadge: {
            description: t`Sequoia`,
            extendedDescription: t`Remain a member of Khan Academy for 3 years`,
        },
        yearfourbadge: {
            description: t`Bristlecone`,
            extendedDescription: t`Remain a member of Khan Academy for 4 years`,
        },
        acceptclarificationbadge: {
            description: t`Fact Checker`,
            extendedDescription: t`Have a video clarification officially accepted`,
        },
        parentchecklistbadge: {
            description: t`Parent: Getting Started`,
            extendedDescription: t`Complete all items in the "Parent: Getting Started" checklist`,
        },
        coachchecklistbadge: {
            description: t`Coach: Getting Started`,
            extendedDescription: t`Complete all items in the "Coach: Getting Started" checklist`,
        },
        firstflagbadge: {
            description: t`Flag Duty`,
            extendedDescription: t`Flag your first discussion post on a video or program for a Guardian's attention`,
        },
        firstupvotebadge: {
            description: t`Thumbs Up`,
            extendedDescription: t`Cast your first up vote for a helpful discussion post or program`,
        },
        firstdownvotebadge: {
            description: t`Thumbs Down`,
            extendedDescription: t`Cast your first down vote for an unhelpful discussion post or program`,
        },
        giveprojectevalbadge: {
            description: t`Evaluator`,
            extendedDescription: t`Evaluate a student's project`,
        },
        moderatorbadge: {
            description: t`Guardian`,
            extendedDescription: t`Become a Guardian who moderates discussion posts on videos and programs`,
        },
        answertimestampreferencebadge: {
            description: t`Researcher`,
            extendedDescription: t`Reference a timestamp when answering a question on a video or program`,
        },
        questiontimestampreferencebadge: {
            description: t`Bibliographer`,
            extendedDescription: t`Reference a timestamp when asking a question on a video or program`,
        },
        posted5goodanswersbadge: {
            description: t`Excellent Teacher`,
            extendedDescription: t`Post 5 answers that earn 3+ votes`,
        },
        leveloneanswerqualitycountbadge: {
            description: t`Guru`,
            extendedDescription: t`Post 10 answers that earn 3+ votes`,
        },
        posted25goodanswersbadge: {
            description: t`Incredible Teacher`,
            extendedDescription: t`Post 25 answers that earn 3+ votes`,
        },
        posted50goodanswersbadge: {
            description: t`Sensei`,
            extendedDescription: t`Post 50 answers that earn 3+ votes`,
        },
        leveltwoanswerqualitycountbadge: {
            description: t`Oracle`,
            extendedDescription: t`Post 100 answers that earn 3+ votes`,
        },
        levelonequestionqualitycountbadge: {
            description: t`Investigator`,
            extendedDescription: t`Ask 10 questions that earn 3+ votes`,
        },
        leveltwoquestionqualitycountbadge: {
            description: t`Detective`,
            extendedDescription: t`Ask 100 questions that earn 3+ votes`,
        },
        leveloneprojectevalanswercountbadge: {
            description: t`Astute Analyzer`,
            extendedDescription: t`Evaluate 30 projects`,
        },
        leveltwoprojectevalanswercountbadge: {
            description: t`Rave Reviewer`,
            extendedDescription: t`Evaluate 150 projects`,
        },
        donatebadge: {
            description: t`Make it rain`,
            extendedDescription: t`Support Khan Academy with a donation of any size`,
        },
        crowdfundingdonationbadge: {
            description: t`Support the #KhanCampaign`,
            extendedDescription: t`Donate $3 or more to our Indiegogo crowdfunding campaign to create lessons on US government and politics`,
        },
        donatebitcoinbadge: {
            description: t`I am Satoshi Nakamoto`,
            extendedDescription: t`Support Khan Academy with a Bitcoin donation`,
        },
        donatebitcointwicebadge: {
            description: t`Double-spend Attack`,
            extendedDescription: t`Support Khan Academy with a Bitcoin donation, twice!`,
        },
        newyears2014fivedayactivitybadge: {
            description: t`New Year's Resolution 2014`,
            extendedDescription: t`Watch part of any video or work on any skill or programming challenge on 5 days in January 2014`,
        },
        yclaadvocatebadge: {
            description: t`You Can Learn Anything`,
            extendedDescription: t`You only have to know one thing -- You can learn anything. Join the movement.`,
        },
        onboardinggoalbadge: {
            description: t`Learning Goal`,
            extendedDescription: t`Complete the goal that you set when you first arrived at Khan Academy`,
        },
        rio2016bronzebadge: {
            description: t`Bronze Knowledge Games`,
            extendedDescription: t`Complete 10 exercises and/or 10 videos (any combination of the two that add up to 10).`,
        },
        rio2016silverbadge: {
            description: t`Silver Knowledge Games`,
            extendedDescription: t`Complete 50 exercises and/or 50 videos (any combination of the two that add up to 50).`,
        },
        rio2016goldbadge: {
            description: t`Gold Knowledge Games`,
            extendedDescription: t`Complete 100 exercises and/or 100 videos (any combination of the two that add up to 100).`,
        },
        rio2016elusivebadge: {
            description: t`Super Knowledge Games`,
            extendedDescription: t`Complete 200 exercises and/or 200 videos completed (any combination of the two that add up to 200).`,
        },
        lotteryticketbadge: {
            description: t`Lottery Ticket`,
            extendedDescription: t`Enter for a chance to participate in a Khan Academy experiment`,
        },
        cup1individualmasterybadge: {
            description: t`LearnStorm 2016 Cup 1: Individual Mastery Leader`,
            extendedDescription: t`Member of the Top 100 Mastery points leaderboard in Cup 1 ofLearnStorm 2016`,
        },
        cup2individualmasterybadge: {
            description: t`LearnStorm 2016 Cup 2: Individual Mastery Leader`,
            extendedDescription: t`Member of the Top 100 Mastery points leaderboard in Cup 2 ofLearnStorm 2016`,
        },
        cup3individualmasterybadge: {
            description: t`LearnStorm 2016 Cup 3: Individual Mastery Leader`,
            extendedDescription: t`Member of the Top 100 Mastery points leaderboard in Cup 3 ofLearnStorm 2016`,
        },
        cup1individualhustlebadge: {
            description: t`LearnStorm 2016 Cup 1: Individual Hustle Leader`,
            extendedDescription: t`Member of the Top 100 Hustle points leaderboard in Cup 1 ofLearnStorm 2016`,
        },
        cup2individualhustlebadge: {
            description: t`LearnStorm 2016 Cup 2: Individual Hustle Leader`,
            extendedDescription: t`Member of the Top 100 Hustle points leaderboard in Cup 2 ofLearnStorm 2016`,
        },
        cup3individualhustlebadge: {
            description: t`LearnStorm 2016 Cup 3: Individual Hustle Leader`,
            extendedDescription: t`Member of the Top 100 Hustle points leaderboard in Cup 3 ofLearnStorm 2016`,
        },
        cup1schooltotalmasterybadge: {
            description: t`LearnStorm 2016 Cup 1: School Total Mastery Leader`,
            extendedDescription: t`Member of a school on the Top 100 Total Mastery points leaderboard in Cup 1 of LearnStorm 2016`,
        },
        cup2schooltotalmasterybadge: {
            description: t`LearnStorm 2016 Cup 2: School Total Mastery Leader`,
            extendedDescription: t`Member of a school on the Top 100 Total Mastery points leaderboard in Cup 2 of LearnStorm 2016`,
        },
        cup3schooltotalmasterybadge: {
            description: t`LearnStorm 2016 Cup 3: School Total Mastery Leader`,
            extendedDescription: t`Member of a school on the Top 100 Total Mastery points leaderboard in Cup 3 of LearnStorm 2016`,
        },
        cup1schooltotalhustlebadge: {
            description: t`LearnStorm 2016 Cup 1: School Total Hustle Leader`,
            extendedDescription: t`Member of a school on the Top 100 Total Hustle points leaderboard in Cup 1 of LearnStorm 2016`,
        },
        cup2schooltotalhustlebadge: {
            description: t`LearnStorm 2016 Cup 2: School Total Hustle Leader`,
            extendedDescription: t`Member of a school on the Top 100 Total Hustle points leaderboard in Cup 2 of LearnStorm 2016`,
        },
        cup3schooltotalhustlebadge: {
            description: t`LearnStorm 2016 Cup 3: School Total Hustle Leader`,
            extendedDescription: t`Member of a school on the Top 100 Total Hustle points leaderboard in Cup 3 of LearnStorm 2016`,
        },
        cup1schoolppesmasterybadge: {
            description: t`LearnStorm 2016 Cup 1: School PPES Mastery Leader`,
            extendedDescription: t`Member of a school on the Top 100 Per-Student Mastery points leaderboard in Cup 1 of LearnStorm 2016`,
        },
        cup2schoolppesmasterybadge: {
            description: t`LearnStorm 2016 Cup 2: School PPES Mastery Leader`,
            extendedDescription: t`Member of a school on the Top 100 Per-Student Mastery points leaderboard in Cup 2 of LearnStorm 2016`,
        },
        cup3schoolppesmasterybadge: {
            description: t`LearnStorm 2016 Cup 3: School PPES Mastery Leader`,
            extendedDescription: t`Member of a school on the Top 100 Per-Student Mastery points leaderboard in Cup 3 of LearnStorm 2016`,
        },
        cup1schoolppeshustlebadge: {
            description: t`LearnStorm 2016 Cup 1: School PPES Hustle Leader`,
            extendedDescription: t`Member of a school on the Top 100 Per-Student Hustle points leaderboard in Cup 1 of LearnStorm 2016`,
        },
        cup2schoolppeshustlebadge: {
            description: t`LearnStorm 2016 Cup 2: School PPES Hustle Leader`,
            extendedDescription: t`Member of a school on the Top 100 Per-Student Hustle points leaderboard in Cup 2 of LearnStorm 2016`,
        },
        cup3schoolppeshustlebadge: {
            description: t`LearnStorm 2016 Cup 3: School PPES Hustle Leader`,
            extendedDescription: t`Member of a school on the Top 100 Per-Student Hustle points leaderboard in Cup 3 of LearnStorm 2016`,
        },
        week1mathmarathonbadge: {
            description: t`LearnStorm 2016 Math Marathon 1`,
            extendedDescription: t`Completed 1 Math Marathon in LearnStorm 2016`,
        },
        week2mathmarathonbadge: {
            description: t`LearnStorm 2016 Math Marathon 2`,
            extendedDescription: t`Completed 2 Math Marathons in LearnStorm 2016`,
        },
        week3mathmarathonbadge: {
            description: t`LearnStorm 2016 Math Marathon 3`,
            extendedDescription: t`Completed 3 Math Marathons in LearnStorm 2016`,
        },
        week4mathmarathonbadge: {
            description: t`LearnStorm 2016 Math Marathon 4`,
            extendedDescription: t`Completed 4 Math Marathons in LearnStorm 2016`,
        },
        week5mathmarathonbadge: {
            description: t`LearnStorm 2016 Math Marathon 5`,
            extendedDescription: t`Completed 5 Math Marathons in LearnStorm 2016`,
        },
        week6mathmarathonbadge: {
            description: t`LearnStorm 2016 Math Marathon 6`,
            extendedDescription: t`Completed 6 Math Marathons in LearnStorm 2016`,
        },
        allweeksmathmarathonbadge: {
            description: t`LearnStorm 2016 All Math Marathons Completed`,
            extendedDescription: t`Completed all 6 Math Marathons in LearnStorm 2016`,
        },
        week1weeklyactivitybadge: {
            description: t`LearnStorm 2016 Weekly Activity 1`,
            extendedDescription: t`Completed Weekly Activity 1 in LearnStorm 2016`,
        },
        week2weeklyactivitybadge: {
            description: t`LearnStorm 2016 Weekly Activity 2`,
            extendedDescription: t`Completed Weekly Activity 2 in LearnStorm 2016`,
        },
        week3weeklyactivitybadge: {
            description: t`LearnStorm 2016 Weekly Activity 3`,
            extendedDescription: t`Completed Weekly Activity 3 in LearnStorm 2016`,
        },
        week4weeklyactivitybadge: {
            description: t`LearnStorm 2016 Weekly Activity 4`,
            extendedDescription: t`Completed Weekly Activity 4 in LearnStorm 2016`,
        },
        week5weeklyactivitybadge: {
            description: t`LearnStorm 2016 Weekly Activity 5`,
            extendedDescription: t`Completed Weekly Activity 5 in LearnStorm 2016`,
        },
        week6weeklyactivitybadge: {
            description: t`LearnStorm 2016 Weekly Activity 6`,
            extendedDescription: t`Completed Weekly Activity 6 in LearnStorm 2016`,
        },
        week7weeklyactivitybadge: {
            description: t`LearnStorm 2016 Weekly Activity 7`,
            extendedDescription: t`Completed Weekly Activity 7 in LearnStorm 2016`,
        },
        week8weeklyactivitybadge: {
            description: t`LearnStorm 2016 Weekly Activity 8`,
            extendedDescription: t`Completed Weekly Activity 8 in LearnStorm 2016`,
        },
        week9weeklyactivitybadge: {
            description: t`LearnStorm 2016 Weekly Activity 9`,
            extendedDescription: t`Completed Weekly Activity 9 in LearnStorm 2016`,
        },
        allweeksweeklyactivitybadge: {
            description: t`LearnStorm 2016 All Weekly Activities Completed`,
            extendedDescription: t`Completed all 9 Weekly Activities in LearnStorm 2016`,
        },
        week1mindsetactivitybadge: {
            description: t`Truth about your brain`,
            extendedDescription: t`Learned about how the brain grows stronger the more you use it through Growth Mindset Activity #1 in LearnStorm.`,
        },
        week2mindsetactivitybadge: {
            description: t`Supercharge your growth`,
            extendedDescription: t`Discovered how goal-setting can help supercharge learning through Growth Mindset Activity #2 in LearnStorm.`,
        },
        week3mindsetactivitybadge: {
            description: t`Which voice?`,
            extendedDescription: t`Learned how to deal with fixed vs growth mindset self-talk through Growth Mindset Activity #3 in LearnStorm.`,
        },
        week4mindsetactivitybadge: {
            description: t`Transforming mistakes`,
            extendedDescription: t`Explored how to turn mistakes into learning opportunities through Growth Mindset Activity #4 in LearnStorm.`,
        },
        week5mindsetactivitybadge: {
            description: t`Overcoming frustration`,
            extendedDescription: t`Understood how to handle frustration through Growth Mindset Activity #5 in LearnStorm.`,
        },
        week6mindsetactivitybadge: {
            description: t`Path forward`,
            extendedDescription: t`Helped future learners strengthen their mindsets through Growth Mindset Activity #6 in LearnStorm.`,
        },
        activity1growthmindsetbadge: {
            description: t`You can do anything`,
            extendedDescription: t`A lesson of how your brain is malleable and changing when you learn`,
        },
        activity2growthmindsetbadge: {
            description: t`The growth mindset`,
            extendedDescription: t`A lesson on what the growth mindset is vs. a fixed mindset`,
        },
        activity3growthmindsetbadge: {
            description: t`Learn from mistakes`,
            extendedDescription: t`A lesson on how to shift your thinking from avoiding mistakes, but instead seeing them as opportunities`,
        },
        activity4growthmindsetbadge: {
            description: t`Overcome frustration`,
            extendedDescription: t`A lesson about how to overcome frustration and learning strategies`,
        },
        activity5growthmindsetbadge: {
            description: t`Supercharge growth`,
            extendedDescription: t`A lesson about goal-setting`,
        },
        activity6esmsgrowthmindsetbadge: {
            description: t`Supercharge goals`,
            extendedDescription: t`A lesson about setting yourself up for reaching your goal`,
        },
        activity6hsgrowthmindsetbadge: {
            description: t`My kind of cool`,
            extendedDescription: t`A lesson about social and academic belonging`,
        },
        activity7esmsgrowthmindsetbadge: {
            description: t`Growth mindset lesson`,
            extendedDescription: t`A final reflection and teaching others what you have learned`,
        },
        activity7esmsgrowthmindsetbadgev2: {
            description: t`Fostering growth mindset`,
            extendedDescription: t`A final reflection and teaching others what you have learned`,
        },
        activity7hsgrowthmindsetbadge: {
            description: t`Serendipity`,
            extendedDescription: t`A lesson about dealing with the unexpected especially in your career journey`,
        },
        activity8hsgrowthmindsetbadge: {
            description: t`Reflecting`,
            extendedDescription: t`A final reflection and teaching others what you have learned`,
        },
        learnstormclasslevel1badge: {
            description: t`LearnStorm Level 1 Class`,
            extendedDescription: t`For learning, teamwork, and persistence in a LearnStorm class.`,
        },
        learnstormclasslevel2badge: {
            description: t`LearnStorm Level 2 Class`,
            extendedDescription: t`For learning, teamwork, and persistence in a LearnStorm class.`,
        },
        learnstormclasslevel3badge: {
            description: t`LearnStorm Level 3 Class`,
            extendedDescription: t`For learning, teamwork, and persistence in a LearnStorm class.`,
        },
        learnstormclasslevel4badge: {
            description: t`LearnStorm Level 4 Class`,
            extendedDescription: t`For learning, teamwork, and persistence in a LearnStorm class.`,
        },
        learnstormclasslevel5badge: {
            description: t`LearnStorm Level 5 Class`,
            extendedDescription: t`For learning, teamwork, and persistence in a LearnStorm class.`,
        },
        learnstormclasslevel6badge: {
            description: t`LearnStorm Level 6 Class`,
            extendedDescription: t`For learning, teamwork, and persistence in a LearnStorm class.`,
        },
        fivedayconsecutiveactivitybadge: {
            description: t`Good Habits`,
            extendedDescription: t`Watch part of any video or work on any skill each day for 5 consecutive days`,
        },
        fifteendayconsecutiveactivitybadge: {
            description: t`Like Clockwork`,
            extendedDescription: t`Watch part of any video or work on any skill each day for 15 consecutive days`,
        },
        thirtydayconsecutiveactivitybadge: {
            description: t`Atomic Clockwork`,
            extendedDescription: t`Watch part of any video or work on any skill each day for 30 consecutive days`,
        },
        hundreddayconsecutiveactivitybadge: {
            description: t`10,000 Year Clock`,
            extendedDescription: t`Watch part of any video or work on any skill each day for 100 consecutive days`,
        },
        levelonearithmeticianbadge: {
            description: t`Apprentice Arithmetician (old)`,
            extendedDescription: t`Achieve proficiency in 1-digit addition, 1-digit subtraction, Multiplying 1-digit numbers, 1-digit division`,
        },
        leveltwoarithmeticianbadge: {
            description: t`Journeyman Arithmetician (old)`,
            extendedDescription: t`Achieve proficiency in 4-digit addition with carrying, 4-digit subtraction with borrowing , Multi-digit multiplication, Div. 4`,
        },
        levelthreearithmeticianbadge: {
            description: t`Artisan Arithmetician (old)`,
            extendedDescription: t`Achieve proficiency in Multiplying decimals, Dividing decimals, Multiplying fractions, Dividing fractions`,
        },
        toplevelarithmeticianbadge: {
            description: t`Master of Arithmetic`,
            extendedDescription: t`Complete the Arithmetic challenge`,
        },
        levelonetrigonometricianbadge: {
            description: t`Apprentice Trigonometrician (old)`,
            extendedDescription: t`Achieve proficiency in Angles 2, Distance formula, Pythagorean theorem`,
        },
        leveltwotrigonometricianbadge: {
            description: t`Journeyman Trigonometrician (old)`,
            extendedDescription: t`Achieve proficiency in Special right triangles, Trigonometry 1`,
        },
        levelthreetrigonometricianbadge: {
            description: t`Artisan Trigonometrician (old)`,
            extendedDescription: t`Achieve proficiency in Trigonometry 2, Graphs of sine and cosine, Inverse trig functions, Pythagorean identities, Trig+-ident`,
        },
        topleveltrigonometricianbadge: {
            description: t`Master of Trigonometry`,
            extendedDescription: t`Complete the Trigonometry challenge`,
        },
        leveloneprealgebraistbadge: {
            description: t`Apprentice Pre-algebraist (old)`,
            extendedDescription: t`Achieve proficiency in Positive and zero exponents, Adding and subtracting negative numbers, Adding and subtracting fractions`,
        },
        leveltwoprealgebraistbadge: {
            description: t`Journeyman Pre-algebraist (old)`,
            extendedDescription: t`Achieve proficiency in Negative exponents, Multiplying and dividing negative numbers, Multiplying fractions, Div. Frac.`,
        },
        levelthreeprealgebraistbadge: {
            description: t`Artisan Pre-algebraist (old)`,
            extendedDescription: t`Achieve proficiency in Fractional exponents, Order of operations, Ordering numbers, Scientific notation, Units, Simplifying radicals`,
        },
        toplevelprealgebraistbadge: {
            description: t`Master of Pre-algebra`,
            extendedDescription: t`Complete the Pre-algebra challenge`,
        },
        levelonealgebraistbadge: {
            description: t`Apprentice Algebraist (old)`,
            extendedDescription: t`Achieve proficiency in Fractional exponents, Exponent rules, Simplifying logarithms, One-step equations with multiplication, % Word 1, Functions 1`,
        },
        leveltwoalgebraistbadge: {
            description: t`Journeyman Algebraist (old)`,
            extendedDescription: t`Achieve proficiency in 2-step equations, Percentage word problems 2, Evaluating expressions with function notation, Domain fx., Even/Odd fx, Shif/Ref fx`,
        },
        levelthreealgebraistbadge: {
            description: t`Artisan I Algebraist (old)`,
            extendedDescription: t`Achieve proficiency in Equations with variables on both sides, Systems of equations, Multiplying expressions 1, Even/Odd fx, Inverse fx, Line slope, Midpoint F., Line Relat., Functions 3`,
        },
        levelfouralgebraistbadge: {
            description: t`Artisan II Algebraist (old)`,
            extendedDescription: t`Achieve proficiency in Multi-step equations, Multi-step linear inequalities, Average word problems, Finding the equation of a line, Quadr. Fac., Quad Frmula, Solving Var, Unkn Vars 1`,
        },
        levelfivealgebraistbadge: {
            description: t`Artisan III Algebraist (old)`,
            extendedDescription: t`Achieve proficiency in New operator definitions 1, New operator definitions 2, Expressions with unknown variables 2, Abs Val Eq., Rad Eq 1, Rate Prob 1`,
        },
        toplevelalgebraistbadge: {
            description: t`Master of Algebra`,
            extendedDescription: t`Complete the Algebra challenge`,
        },
        gettingstartedbadge: {
            description: t`Just Getting Started (old)`,
            extendedDescription: t`Achieve proficiency in any 3 skills`,
        },
        makingprogressbadge: {
            description: t`Making Progress (old)`,
            extendedDescription: t`Achieve proficiency in any 7 skills`,
        },
        productivebadge: {
            description: t`Productive (old)`,
            extendedDescription: t`Achieve proficiency in any 15 skills`,
        },
        hardatworkbadge: {
            description: t`Hard at Work (old)`,
            extendedDescription: t`Achieve proficiency in any 25 skills`,
        },
        workhorsebadge: {
            description: t`Work Horse (old)`,
            extendedDescription: t`Achieve proficiency in any 50 skills`,
        },
        magellanbadge: {
            description: t`Magellan (old)`,
            extendedDescription: t`Achieve proficiency in any 100 skills`,
        },
        copernicusbadge: {
            description: t`Copernicus (old)`,
            extendedDescription: t`Achieve proficiency in any 200 skills`,
        },
        keplerbadge: {
            description: t`Kepler (old)`,
            extendedDescription: t`Achieve proficiency in any 300 skills`,
        },
        newtonbadge: {
            description: t`Newton (old)`,
            extendedDescription: t`Achieve proficiency in any 400 skills`,
        },
        atlasbadge: {
            description: t`Atlas (old)`,
            extendedDescription: t`Achieve proficiency in any 5000 skills`,
            isTeaserIfUnowned: true,
        },
        levelonearithmeticianmasterybadge: {
            description: t`Apprentice Arithmetician`,
            extendedDescription: t`Achieve mastery in 1-digit addition, 1-digit subtraction, Multiplying 1-digit numbers, 1-digit division`,
        },
        leveltwoarithmeticianmasterybadge: {
            description: t`Journeyman Arithmetician`,
            extendedDescription: t`Achieve mastery in 4-digit addition with carrying, 4-digit subtraction with borrowing , Multi-digit multiplication, Div. 4`,
        },
        levelthreearithmeticianmasterybadge: {
            description: t`Artisan Arithmetician`,
            extendedDescription: t`Achieve mastery in Multiplying decimals, Dividing decimals, Multiplying fractions, Dividing fractions`,
        },
        levelonetrigonometricianmasterybadge: {
            description: t`Apprentice Trigonometrician`,
            extendedDescription: t`Achieve mastery in Angles 2, Distance formula, Pythagorean theorem`,
        },
        leveltwotrigonometricianmasterybadge: {
            description: t`Journeyman Trigonometrician`,
            extendedDescription: t`Achieve mastery in Special right triangles, Trigonometry 1`,
        },
        levelthreetrigonometricianmasterybadge: {
            description: t`Artisan Trigonometrician`,
            extendedDescription: t`Achieve mastery in Trigonometry 2, Graphs of sine and cosine, Inverse trig functions, Pythagorean identities, Trig+-ident`,
        },
        leveloneprealgebraistmasterybadge: {
            description: t`Apprentice Pre-algebraist`,
            extendedDescription: t`Achieve mastery in Positive and zero exponents, Adding and subtracting negative numbers, Adding and subtracting fractions`,
        },
        leveltwoprealgebraistmasterybadge: {
            description: t`Journeyman Pre-algebraist`,
            extendedDescription: t`Achieve mastery in Negative exponents, Multiplying and dividing negative numbers, Multiplying fractions, Div. Frac.`,
        },
        levelthreeprealgebraistmasterybadge: {
            description: t`Artisan Pre-algebraist`,
            extendedDescription: t`Achieve mastery in Fractional exponents, Order of operations, Ordering numbers, Scientific notation, Units, Simplifying radicals`,
        },
        levelonealgebraistmasterybadge: {
            description: t`Apprentice Algebraist`,
            extendedDescription: t`Achieve mastery in Fractional exponents, Exponent rules, Simplifying logarithms, One-step equations with multiplication, % Word 1, Functions 1`,
        },
        leveltwoalgebraistmasterybadge: {
            description: t`Journeyman Algebraist`,
            extendedDescription: t`Achieve mastery in 2-step equations, Percentage word problems 2, Evaluating expressions with function notation, Domain fx., Even/Odd fx, Shif/Ref fx`,
        },
        levelthreealgebraistmasterybadge: {
            description: t`Artisan I Algebraist`,
            extendedDescription: t`Achieve mastery in Equations with variables on both sides, Systems of equations, Multiplying expressions 1, Even/Odd fx, Inverse fx, Line slope, Midpoint F., Line Relat., Functions 3`,
        },
        levelfouralgebraistmasterybadge: {
            description: t`Artisan II Algebraist`,
            extendedDescription: t`Achieve mastery in Multi-step equations, Multi-step linear inequalities, Average word problems, Finding the equation of a line, Quadr. Fac., Quad Frmula, Solving Var, Unkn Vars 1`,
        },
        levelfivealgebraistmasterybadge: {
            description: t`Artisan III Algebraist`,
            extendedDescription: t`Achieve mastery in New operator definitions 1, New operator definitions 2, Expressions with unknown variables 2, Abs Val Eq., Rad Eq 1, Rate Prob 1`,
        },
        gettingstartedmasterybadge: {
            description: t`Just Getting Started`,
            extendedDescription: t`Achieve mastery in 3 unique skills`,
        },
        makingprogressmasterybadge: {
            description: t`Making Progress`,
            extendedDescription: t`Achieve mastery in 7 unique skills`,
        },
        productivemasterybadge: {
            description: t`Productive`,
            extendedDescription: t`Achieve mastery in 15 unique skills`,
        },
        hardatworkmasterybadge: {
            description: t`Hard at Work`,
            extendedDescription: t`Achieve mastery in 25 unique skills`,
        },
        workhorsemasterybadge: {
            description: t`Work Horse`,
            extendedDescription: t`Achieve mastery in 50 unique skills`,
        },
        magellanmasterybadge: {
            description: t`Magellan`,
            extendedDescription: t`Achieve mastery in 100 unique skills`,
        },
        sallyridemasterybadge: {
            description: t`Sally Ride`,
            extendedDescription: t`Achieve mastery in 150 unique skills`,
        },
        copernicusmasterybadge: {
            description: t`Copernicus`,
            extendedDescription: t`Achieve mastery in 200 unique skills`,
        },
        keplermasterybadge: {
            description: t`Kepler`,
            extendedDescription: t`Achieve mastery in 300 unique skills`,
        },
        hypatiamasterybadge: {
            description: t`Hypatia`,
            extendedDescription: t`Achieve mastery in 350 unique skills`,
        },
        newtonmasterybadge: {
            description: t`Newton`,
            extendedDescription: t`Achieve mastery in 400 unique skills`,
        },
        davincimasterybadge: {
            description: t`Da Vinci`,
            extendedDescription: t`Achieve mastery in 500 unique skills`,
        },
        atlasmasterybadge: {
            description: t`Atlas`,
            extendedDescription: t`Achieve mastery in 5000 unique skills`,
            isTeaserIfUnowned: true,
        },
        artemismasterybadge: {
            description: t`Artemis`,
            extendedDescription: t`Achieve mastery in 7500 unique skills`,
            isTeaserIfUnowned: true,
        },
        tenthousandairebadge: {
            description: t`Ten to the Fourth`,
            extendedDescription: t`Earn 10,000 energy points`,
        },
        fiftythousandairebadge: {
            description: t`Benjamin Franklin`,
            extendedDescription: t`Earn 50,000 energy points. Benjamin Franklin (1706-1790) was a self-taught American scientist, author, and political theorist who helped to found the United States. Be like Franklin and keep on learning!`,
        },
        hundredthousandairebadge: {
            description: t`Ten to the Fifth`,
            extendedDescription: t`Earn 100,000 energy points`,
        },
        twohundredfiftythousandairebadge: {
            description: t`Frederick Douglass`,
            extendedDescription: t`Earn 250,000 energy points. Frederick Douglass (c. 1818-1895) was born a slave. He taught himself to read, escaped from slavery, and became a champion of abolition and rights for African Americans throughout the nineteenth century. Be like Douglass and keep on learning!`,
        },
        fivehundredthousandairebadge: {
            description: t`Five Times Ten to the Fifth`,
            extendedDescription: t`Earn 500,000 energy points`,
        },
        sevenhundredfiftythousandairebadge: {
            description: t`Helen Keller`,
            extendedDescription: t`Earn 750,000 energy points. Helen Keller (1880-1968) was blind and deaf. With the help of her teacher Anne Sullivan, she went on to graduate from college and became an influential writer, lecturer, and activist. Be like Keller and keep on learning!`,
        },
        millionairebadge: {
            description: t`Millionaire`,
            extendedDescription: t`Earn 1,000,000 energy points`,
        },
        twomillionairebadge: {
            description: t`Ramanujan`,
            extendedDescription: t`Earn 2,000,000 energy points. Srinivasa Ramanujan (1887-1920) was a self-taught Indian mathematician. Though he had no formal education, he made many important contributions to the field of mathematics. Be like Ramanujan and keep learning!`,
        },
        tenmillionairebadge: {
            description: t`Tesla`,
            extendedDescription: t`Earn 10,000,000 energy points`,
            isTeaserIfUnowned: true,
        },
        powerfifteenminutesbadge: {
            description: t`Inspired 15 Minutes`,
            extendedDescription: t`Correctly answer 10 problems and watch 10 minutes of video in 15 minutes`,
        },
        powerhourbadge: {
            description: t`Power Hour`,
            extendedDescription: t`Correctly answer 90 problems and watch 15 minutes of video in 1 hour`,
        },
        doublepowerhourbadge: {
            description: t`Double Power Hour`,
            extendedDescription: t`Correctly answer 180 problems and watch 30 minutes of video in 2 hours`,
        },
        profilecustomizationbadge: {
            description: t`Express Yourself`,
            extendedDescription: t`Customize your profile avatar and fill up your display case`,
        },
        actonesceneonebadge: {
            description: t`Act I Scene I`,
            extendedDescription: t`Watch 20 minutes of video`,
        },
        weeklypracticebadge: {
            description: t`Geek of the week: practice`,
            extendedDescription: t`Finish 5 practice tasks in a week`,
        },
        weeklymasterybadge: {
            description: t`Geek of the week: mastery`,
            extendedDescription: t`Finish 5 mastery challenges in a week`,
        },
        mathpretestbadge: {
            description: t`Math Pretest Champion`,
            extendedDescription: t`You finished the math pretest in the learning dashboard. Good work!`,
        },
        missionpretestbadge: {
            description: t`Pretest Champion`,
            extendedDescription: t`You finished a pretest and unlocked a mission on the learning dashboard. Good work!`,
        },
        firstpracticetaskbadge: {
            description: t`Makes Perfect`,
            extendedDescription: t`You finished your first practice task.`,
        },
        fifthpracticetaskbadge: {
            description: t`Five is Alive!`,
            extendedDescription: t`Finish five practice tasks.`,
        },
        tenthpracticetaskbadge: {
            description: t`Fingers or Toes`,
            extendedDescription: t`Ten practice tasks!? Already?`,
        },
        firstmasterytaskbadge: {
            description: t`Challenge Accepted`,
            extendedDescription: t`You finished your first mastery challenge.`,
        },
        fifthmasterytaskbadge: {
            description: t`High Five`,
            extendedDescription: t`Five mastery challenges completed.`,
        },
        tenthmasterytaskbadge: {
            description: t`Hang Ten`,
            extendedDescription: t`Ten mastery challenges completed.`,
        },
        topic_exercise_x2915748a_mastery: {
            description: t`1st grade: Addition and subtraction`,
            extendedDescription: t`Achieve mastery in all skills in 1st grade: Addition and subtraction`,
        },
        topic_exercise_x2915748a: {
            description: t`1st grade: Addition and subtraction (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 1st grade: Addition and subtraction (old)`,
        },
        topic_exercise_x6d9819ab_mastery: {
            description: t`1st grade: Geometry`,
            extendedDescription: t`Achieve mastery in all skills in 1st grade: Geometry`,
        },
        topic_exercise_x6d9819ab: {
            description: t`1st grade: Geometry (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 1st grade: Geometry (old)`,
        },
        topic_exercise_xf73303d8_mastery: {
            description: t`1st grade: Measurement, data, and geometry`,
            extendedDescription: t`Achieve mastery in all skills in 1st grade: Measurement, data, and geometry`,
        },
        topic_exercise_xf73303d8: {
            description: t`1st grade: Measurement, data, and geometry (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 1st grade: Measurement, data, and geometry (old)`,
        },
        topic_exercise_xaa80d2ac_mastery: {
            description: t`1st grade: Place value`,
            extendedDescription: t`Achieve mastery in all skills in 1st grade: Place value`,
        },
        topic_exercise_xaa80d2ac: {
            description: t`1st grade: Place value (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 1st grade: Place value (old)`,
        },
        topic_exercise_x8e913210_mastery: {
            description: t`2nd grade: Addition and subtraction within 100`,
            extendedDescription: t`Achieve mastery in all skills in 2nd grade: Addition and subtraction within 100`,
        },
        topic_exercise_x8e913210: {
            description: t`2nd grade: Addition and subtraction within 100 (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 2nd grade: Addition and subtraction within 100 (old)`,
        },
        topic_exercise_x694cb622_mastery: {
            description: t`2nd grade: Addition and subtraction within 1000`,
            extendedDescription: t`Achieve mastery in all skills in 2nd grade: Addition and subtraction within 1000`,
        },
        topic_exercise_x694cb622: {
            description: t`2nd grade: Addition and subtraction within 1000 (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 2nd grade: Addition and subtraction within 1000 (old)`,
        },
        topic_exercise_x2d57d404_mastery: {
            description: t`2nd grade: Geometry`,
            extendedDescription: t`Achieve mastery in all skills in 2nd grade: Geometry`,
        },
        topic_exercise_x2d57d404: {
            description: t`2nd grade: Geometry (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 2nd grade: Geometry (old)`,
        },
        topic_exercise_x4023aec3_mastery: {
            description: t`2nd grade: Measurement, data, and geometry`,
            extendedDescription: t`Achieve mastery in all skills in 2nd grade: Measurement, data, and geometry`,
        },
        topic_exercise_x4023aec3: {
            description: t`2nd grade: Measurement, data, and geometry (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 2nd grade: Measurement, data, and geometry (old)`,
        },
        topic_exercise_x5bbdb185_mastery: {
            description: t`2nd grade: Place value`,
            extendedDescription: t`Achieve mastery in all skills in 2nd grade: Place value`,
        },
        topic_exercise_x5bbdb185: {
            description: t`2nd grade: Place value (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 2nd grade: Place value (old)`,
        },
        topic_exercise_x4d345626_mastery: {
            description: t`3rd grade (2018 edition): Addition and subtraction`,
            extendedDescription: t`Achieve mastery in all skills in 3rd grade (2018 edition): Addition and subtraction`,
        },
        topic_exercise_x4d345626: {
            description: t`3rd grade (2018 edition): Addition and subtraction (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 3rd grade (2018 edition): Addition and subtraction (old)`,
        },
        topic_exercise_x63009ec3_mastery: {
            description: t`3rd grade (2018 edition): Fractions`,
            extendedDescription: t`Achieve mastery in all skills in 3rd grade (2018 edition): Fractions`,
        },
        topic_exercise_x63009ec3: {
            description: t`3rd grade (2018 edition): Fractions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 3rd grade (2018 edition): Fractions (old)`,
        },
        topic_exercise_xb7049be87dac0f02_mastery: {
            description: t`3rd grade (2018 edition): Geometry`,
            extendedDescription: t`Achieve mastery in all skills in 3rd grade (2018 edition): Geometry`,
        },
        topic_exercise_xb7049be87dac0f02: {
            description: t`3rd grade (2018 edition): Geometry (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 3rd grade (2018 edition): Geometry (old)`,
        },
        topic_exercise_x3b2192e4_mastery: {
            description: t`3rd grade (2018 edition): Measurement and data`,
            extendedDescription: t`Achieve mastery in all skills in 3rd grade (2018 edition): Measurement and data`,
        },
        topic_exercise_x3b2192e4: {
            description: t`3rd grade (2018 edition): Measurement and data (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 3rd grade (2018 edition): Measurement and data (old)`,
        },
        topic_exercise_x149f953f_mastery: {
            description: t`3rd grade (2018 edition): Multiplication and division`,
            extendedDescription: t`Achieve mastery in all skills in 3rd grade (2018 edition): Multiplication and division`,
        },
        topic_exercise_x149f953f: {
            description: t`3rd grade (2018 edition): Multiplication and division (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 3rd grade (2018 edition): Multiplication and division (old)`,
        },
        topic_exercise_xb514f3b9_mastery: {
            description: t`3rd grade (2018 edition): Place value and rounding`,
            extendedDescription: t`Achieve mastery in all skills in 3rd grade (2018 edition): Place value and rounding`,
        },
        topic_exercise_xb514f3b9: {
            description: t`3rd grade (2018 edition): Place value and rounding (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 3rd grade (2018 edition): Place value and rounding (old)`,
        },
        topic_exercise_xe2091c9f_mastery: {
            description: t`3rd grade (Eureka Math/EngageNY): Module 1: Properties of multiplication and division and solving problems with units of 2–5 and 10`,
            extendedDescription: t`Achieve mastery in all skills in 3rd grade (Eureka Math/EngageNY): Module 1: Properties of multiplication and division and solving problems with units of 2–5 and 10`,
        },
        topic_exercise_xe2091c9f: {
            description: t`3rd grade (Eureka Math/EngageNY): Module 1: Properties of multiplication and division and solving problems with units of 2–5 and 10 (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 3rd grade (Eureka Math/EngageNY): Module 1: Properties of multiplication and division and solving problems with units of 2–5 and 10 (old)`,
        },
        topic_exercise_x1c9a2e69_mastery: {
            description: t`3rd grade (Eureka Math/EngageNY): Module 2: Place value and problem solving with units of measure `,
            extendedDescription: t`Achieve mastery in all skills in 3rd grade (Eureka Math/EngageNY): Module 2: Place value and problem solving with units of measure `,
        },
        topic_exercise_x1c9a2e69: {
            description: t`3rd grade (Eureka Math/EngageNY): Module 2: Place value and problem solving with units of measure  (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 3rd grade (Eureka Math/EngageNY): Module 2: Place value and problem solving with units of measure  (old)`,
        },
        topic_exercise_xf8c0473b_mastery: {
            description: t`3rd grade (Eureka Math/EngageNY): Module 3: Multiplication and division with units of 0, 1, 6–9, and multiples of 10`,
            extendedDescription: t`Achieve mastery in all skills in 3rd grade (Eureka Math/EngageNY): Module 3: Multiplication and division with units of 0, 1, 6–9, and multiples of 10`,
        },
        topic_exercise_xf8c0473b: {
            description: t`3rd grade (Eureka Math/EngageNY): Module 3: Multiplication and division with units of 0, 1, 6–9, and multiples of 10 (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 3rd grade (Eureka Math/EngageNY): Module 3: Multiplication and division with units of 0, 1, 6–9, and multiples of 10 (old)`,
        },
        topic_exercise_xaf27f7f4_mastery: {
            description: t`3rd grade (Eureka Math/EngageNY): Module 4: Multiplication and area`,
            extendedDescription: t`Achieve mastery in all skills in 3rd grade (Eureka Math/EngageNY): Module 4: Multiplication and area`,
        },
        topic_exercise_xaf27f7f4: {
            description: t`3rd grade (Eureka Math/EngageNY): Module 4: Multiplication and area (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 3rd grade (Eureka Math/EngageNY): Module 4: Multiplication and area (old)`,
        },
        topic_exercise_x3411424b_mastery: {
            description: t`3rd grade (Eureka Math/EngageNY): Module 5: Fractions as numbers on the number line`,
            extendedDescription: t`Achieve mastery in all skills in 3rd grade (Eureka Math/EngageNY): Module 5: Fractions as numbers on the number line`,
        },
        topic_exercise_x3411424b: {
            description: t`3rd grade (Eureka Math/EngageNY): Module 5: Fractions as numbers on the number line (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 3rd grade (Eureka Math/EngageNY): Module 5: Fractions as numbers on the number line (old)`,
        },
        topic_exercise_xa645a70b_mastery: {
            description: t`3rd grade (Eureka Math/EngageNY): Module 6: Collecting and displaying data`,
            extendedDescription: t`Achieve mastery in all skills in 3rd grade (Eureka Math/EngageNY): Module 6: Collecting and displaying data`,
        },
        topic_exercise_xa645a70b: {
            description: t`3rd grade (Eureka Math/EngageNY): Module 6: Collecting and displaying data (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 3rd grade (Eureka Math/EngageNY): Module 6: Collecting and displaying data (old)`,
        },
        topic_exercise_x30dfbb5e_mastery: {
            description: t`3rd grade (Eureka Math/EngageNY): Module 7: Geometry and measurement word problems`,
            extendedDescription: t`Achieve mastery in all skills in 3rd grade (Eureka Math/EngageNY): Module 7: Geometry and measurement word problems`,
        },
        topic_exercise_x30dfbb5e: {
            description: t`3rd grade (Eureka Math/EngageNY): Module 7: Geometry and measurement word problems (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 3rd grade (Eureka Math/EngageNY): Module 7: Geometry and measurement word problems (old)`,
        },
        topic_exercise_x79d23611_mastery: {
            description: t`3rd grade (U.S.): Expressions and patterns`,
            extendedDescription: t`Achieve mastery in all skills in 3rd grade (U.S.): Expressions and patterns`,
        },
        topic_exercise_x79d23611: {
            description: t`3rd grade (U.S.): Expressions and patterns (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 3rd grade (U.S.): Expressions and patterns (old)`,
        },
        topic_exercise_x9ae6719f9187864e_mastery: {
            description: t`3rd grade: 1-digit multiplication`,
            extendedDescription: t`Achieve mastery in all skills in 3rd grade: 1-digit multiplication`,
        },
        topic_exercise_x9ae6719f9187864e: {
            description: t`3rd grade: 1-digit multiplication (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 3rd grade: 1-digit multiplication (old)`,
        },
        topic_exercise_xc09fcb17c3dc1166_mastery: {
            description: t`3rd grade: Addition, subtraction, and estimation`,
            extendedDescription: t`Achieve mastery in all skills in 3rd grade: Addition, subtraction, and estimation`,
        },
        topic_exercise_xc09fcb17c3dc1166: {
            description: t`3rd grade: Addition, subtraction, and estimation (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 3rd grade: Addition, subtraction, and estimation (old)`,
        },
        topic_exercise_x39665ac6c597b247_mastery: {
            description: t`3rd grade: Area`,
            extendedDescription: t`Achieve mastery in all skills in 3rd grade: Area`,
        },
        topic_exercise_x39665ac6c597b247: {
            description: t`3rd grade: Area (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 3rd grade: Area (old)`,
        },
        topic_exercise_xed8af723df4fe064_mastery: {
            description: t`3rd grade: Arithmetic patterns and problem solving`,
            extendedDescription: t`Achieve mastery in all skills in 3rd grade: Arithmetic patterns and problem solving`,
        },
        topic_exercise_xed8af723df4fe064: {
            description: t`3rd grade: Arithmetic patterns and problem solving (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 3rd grade: Arithmetic patterns and problem solving (old)`,
        },
        topic_exercise_xfbbc5c38cd9efe45_mastery: {
            description: t`3rd grade: Equivalent fractions and comparing fractions`,
            extendedDescription: t`Achieve mastery in all skills in 3rd grade: Equivalent fractions and comparing fractions`,
        },
        topic_exercise_xfbbc5c38cd9efe45: {
            description: t`3rd grade: Equivalent fractions and comparing fractions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 3rd grade: Equivalent fractions and comparing fractions (old)`,
        },
        topic_exercise_x28227514254db9ab_mastery: {
            description: t`3rd grade: Intro to division`,
            extendedDescription: t`Achieve mastery in all skills in 3rd grade: Intro to division`,
        },
        topic_exercise_x28227514254db9ab: {
            description: t`3rd grade: Intro to division (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 3rd grade: Intro to division (old)`,
        },
        topic_exercise_x8f26a99d8c8a8aa7_mastery: {
            description: t`3rd grade: Intro to multiplication`,
            extendedDescription: t`Achieve mastery in all skills in 3rd grade: Intro to multiplication`,
        },
        topic_exercise_x8f26a99d8c8a8aa7: {
            description: t`3rd grade: Intro to multiplication (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 3rd grade: Intro to multiplication (old)`,
        },
        topic_exercise_x639efb3744ddc090_mastery: {
            description: t`3rd grade: Measurement`,
            extendedDescription: t`Achieve mastery in all skills in 3rd grade: Measurement`,
        },
        topic_exercise_x639efb3744ddc090: {
            description: t`3rd grade: Measurement (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 3rd grade: Measurement (old)`,
        },
        topic_exercise_x16c952affcb38cf5_mastery: {
            description: t`3rd grade: More with multiplication and division`,
            extendedDescription: t`Achieve mastery in all skills in 3rd grade: More with multiplication and division`,
        },
        topic_exercise_x16c952affcb38cf5: {
            description: t`3rd grade: More with multiplication and division (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 3rd grade: More with multiplication and division (old)`,
        },
        topic_exercise_xb5072b81340aa661_mastery: {
            description: t`3rd grade: Perimeter`,
            extendedDescription: t`Achieve mastery in all skills in 3rd grade: Perimeter`,
        },
        topic_exercise_xb5072b81340aa661: {
            description: t`3rd grade: Perimeter (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 3rd grade: Perimeter (old)`,
        },
        topic_exercise_x6048e2a14fd90a0c_mastery: {
            description: t`3rd grade: Quadrilaterals`,
            extendedDescription: t`Achieve mastery in all skills in 3rd grade: Quadrilaterals`,
        },
        topic_exercise_x6048e2a14fd90a0c: {
            description: t`3rd grade: Quadrilaterals (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 3rd grade: Quadrilaterals (old)`,
        },
        topic_exercise_x64de5f52c8283150_mastery: {
            description: t`3rd grade: Represent and interpret data`,
            extendedDescription: t`Achieve mastery in all skills in 3rd grade: Represent and interpret data`,
        },
        topic_exercise_x64de5f52c8283150: {
            description: t`3rd grade: Represent and interpret data (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 3rd grade: Represent and interpret data (old)`,
        },
        topic_exercise_x044ec8419fb3e9e3_mastery: {
            description: t`3rd grade: Time`,
            extendedDescription: t`Achieve mastery in all skills in 3rd grade: Time`,
        },
        topic_exercise_x044ec8419fb3e9e3: {
            description: t`3rd grade: Time (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 3rd grade: Time (old)`,
        },
        topic_exercise_x09f215195e706ff4_mastery: {
            description: t`3rd grade: Understand fractions`,
            extendedDescription: t`Achieve mastery in all skills in 3rd grade: Understand fractions`,
        },
        topic_exercise_x09f215195e706ff4: {
            description: t`3rd grade: Understand fractions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 3rd grade: Understand fractions (old)`,
        },
        topic_exercise_x447822a8_mastery: {
            description: t`4th grade (2018 edition): Addition and subtraction`,
            extendedDescription: t`Achieve mastery in all skills in 4th grade (2018 edition): Addition and subtraction`,
        },
        topic_exercise_x447822a8: {
            description: t`4th grade (2018 edition): Addition and subtraction (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 4th grade (2018 edition): Addition and subtraction (old)`,
        },
        topic_exercise_xcc4bb0c3_mastery: {
            description: t`4th grade (2018 edition): Decimals`,
            extendedDescription: t`Achieve mastery in all skills in 4th grade (2018 edition): Decimals`,
        },
        topic_exercise_xcc4bb0c3: {
            description: t`4th grade (2018 edition): Decimals (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 4th grade (2018 edition): Decimals (old)`,
        },
        topic_exercise_xa391e5e5_mastery: {
            description: t`4th grade (2018 edition): Factors, multiples and patterns`,
            extendedDescription: t`Achieve mastery in all skills in 4th grade (2018 edition): Factors, multiples and patterns`,
        },
        topic_exercise_xa391e5e5: {
            description: t`4th grade (2018 edition): Factors, multiples and patterns (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 4th grade (2018 edition): Factors, multiples and patterns (old)`,
        },
        topic_exercise_xfaed0f99_mastery: {
            description: t`4th grade (2018 edition): Fractions`,
            extendedDescription: t`Achieve mastery in all skills in 4th grade (2018 edition): Fractions`,
        },
        topic_exercise_xfaed0f99: {
            description: t`4th grade (2018 edition): Fractions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 4th grade (2018 edition): Fractions (old)`,
        },
        topic_exercise_xd796b5cb_mastery: {
            description: t`4th grade (2018 edition): Geometry`,
            extendedDescription: t`Achieve mastery in all skills in 4th grade (2018 edition): Geometry`,
        },
        topic_exercise_xd796b5cb: {
            description: t`4th grade (2018 edition): Geometry (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 4th grade (2018 edition): Geometry (old)`,
        },
        topic_exercise_x58fcadff_mastery: {
            description: t`4th grade (2018 edition): Measurement and data`,
            extendedDescription: t`Achieve mastery in all skills in 4th grade (2018 edition): Measurement and data`,
        },
        topic_exercise_x58fcadff: {
            description: t`4th grade (2018 edition): Measurement and data (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 4th grade (2018 edition): Measurement and data (old)`,
        },
        topic_exercise_xb55cb073_mastery: {
            description: t`4th grade (2018 edition): Multiplication and division`,
            extendedDescription: t`Achieve mastery in all skills in 4th grade (2018 edition): Multiplication and division`,
        },
        topic_exercise_xb55cb073: {
            description: t`4th grade (2018 edition): Multiplication and division (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 4th grade (2018 edition): Multiplication and division (old)`,
        },
        topic_exercise_x4d29b2d1_mastery: {
            description: t`4th grade (2018 edition): Place value and rounding`,
            extendedDescription: t`Achieve mastery in all skills in 4th grade (2018 edition): Place value and rounding`,
        },
        topic_exercise_x4d29b2d1: {
            description: t`4th grade (2018 edition): Place value and rounding (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 4th grade (2018 edition): Place value and rounding (old)`,
        },
        topic_exercise_xa9433e3b_mastery: {
            description: t`4th grade (Eureka Math/EngageNY): Module 1: Place value, rounding, and algorithms for addition and subtraction`,
            extendedDescription: t`Achieve mastery in all skills in 4th grade (Eureka Math/EngageNY): Module 1: Place value, rounding, and algorithms for addition and subtraction`,
        },
        topic_exercise_xa9433e3b: {
            description: t`4th grade (Eureka Math/EngageNY): Module 1: Place value, rounding, and algorithms for addition and subtraction (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 4th grade (Eureka Math/EngageNY): Module 1: Place value, rounding, and algorithms for addition and subtraction (old)`,
        },
        topic_exercise_xd12a86e5_mastery: {
            description: t`4th grade (Eureka Math/EngageNY): Module 2: Unit conversions and problem solving with metric measurement`,
            extendedDescription: t`Achieve mastery in all skills in 4th grade (Eureka Math/EngageNY): Module 2: Unit conversions and problem solving with metric measurement`,
        },
        topic_exercise_xd12a86e5: {
            description: t`4th grade (Eureka Math/EngageNY): Module 2: Unit conversions and problem solving with metric measurement (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 4th grade (Eureka Math/EngageNY): Module 2: Unit conversions and problem solving with metric measurement (old)`,
        },
        topic_exercise_x4f5577c4_mastery: {
            description: t`4th grade (Eureka Math/EngageNY): Module 3: Multi-digit multiplication and division`,
            extendedDescription: t`Achieve mastery in all skills in 4th grade (Eureka Math/EngageNY): Module 3: Multi-digit multiplication and division`,
        },
        topic_exercise_x4f5577c4: {
            description: t`4th grade (Eureka Math/EngageNY): Module 3: Multi-digit multiplication and division (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 4th grade (Eureka Math/EngageNY): Module 3: Multi-digit multiplication and division (old)`,
        },
        topic_exercise_xa27745c5_mastery: {
            description: t`4th grade (Eureka Math/EngageNY): Module 4: Angle measure and plane figures`,
            extendedDescription: t`Achieve mastery in all skills in 4th grade (Eureka Math/EngageNY): Module 4: Angle measure and plane figures`,
        },
        topic_exercise_xa27745c5: {
            description: t`4th grade (Eureka Math/EngageNY): Module 4: Angle measure and plane figures (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 4th grade (Eureka Math/EngageNY): Module 4: Angle measure and plane figures (old)`,
        },
        topic_exercise_x2f3c2573_mastery: {
            description: t`4th grade (Eureka Math/EngageNY): Module 5: Fraction equivalence, ordering, and operations`,
            extendedDescription: t`Achieve mastery in all skills in 4th grade (Eureka Math/EngageNY): Module 5: Fraction equivalence, ordering, and operations`,
        },
        topic_exercise_x2f3c2573: {
            description: t`4th grade (Eureka Math/EngageNY): Module 5: Fraction equivalence, ordering, and operations (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 4th grade (Eureka Math/EngageNY): Module 5: Fraction equivalence, ordering, and operations (old)`,
        },
        topic_exercise_x1b8f1ef9_mastery: {
            description: t`4th grade (Eureka Math/EngageNY): Module 6: Decimal fractions`,
            extendedDescription: t`Achieve mastery in all skills in 4th grade (Eureka Math/EngageNY): Module 6: Decimal fractions`,
        },
        topic_exercise_x1b8f1ef9: {
            description: t`4th grade (Eureka Math/EngageNY): Module 6: Decimal fractions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 4th grade (Eureka Math/EngageNY): Module 6: Decimal fractions (old)`,
        },
        topic_exercise_xdcdd6a4d_mastery: {
            description: t`4th grade (Eureka Math/EngageNY): Module 7: Exploring measurement with multiplication`,
            extendedDescription: t`Achieve mastery in all skills in 4th grade (Eureka Math/EngageNY): Module 7: Exploring measurement with multiplication`,
        },
        topic_exercise_xdcdd6a4d: {
            description: t`4th grade (Eureka Math/EngageNY): Module 7: Exploring measurement with multiplication (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 4th grade (Eureka Math/EngageNY): Module 7: Exploring measurement with multiplication (old)`,
        },
        topic_exercise_x89fde1a6_mastery: {
            description: t`4th grade (Eureka Math/EngageNY): Topic foundations (in development)`,
            extendedDescription: t`Achieve mastery in all skills in 4th grade (Eureka Math/EngageNY): Topic foundations (in development)`,
        },
        topic_exercise_x89fde1a6: {
            description: t`4th grade (Eureka Math/EngageNY): Topic foundations (in development) (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 4th grade (Eureka Math/EngageNY): Topic foundations (in development) (old)`,
        },
        topic_exercise_xf79f1c4ccf03859a_mastery: {
            description: t`4th grade: Add and subtract fractions`,
            extendedDescription: t`Achieve mastery in all skills in 4th grade: Add and subtract fractions`,
        },
        topic_exercise_xf79f1c4ccf03859a: {
            description: t`4th grade: Add and subtract fractions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 4th grade: Add and subtract fractions (old)`,
        },
        topic_exercise_x4febd3aef31e60fa_mastery: {
            description: t`4th grade: Addition, subtraction, and estimation`,
            extendedDescription: t`Achieve mastery in all skills in 4th grade: Addition, subtraction, and estimation`,
        },
        topic_exercise_x4febd3aef31e60fa: {
            description: t`4th grade: Addition, subtraction, and estimation (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 4th grade: Addition, subtraction, and estimation (old)`,
        },
        topic_exercise_xd71e72e103d6d7f3_mastery: {
            description: t`4th grade: Area and perimeter`,
            extendedDescription: t`Achieve mastery in all skills in 4th grade: Area and perimeter`,
        },
        topic_exercise_xd71e72e103d6d7f3: {
            description: t`4th grade: Area and perimeter (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 4th grade: Area and perimeter (old)`,
        },
        topic_exercise_x1ad1d91034b22aa9_mastery: {
            description: t`4th grade: Division`,
            extendedDescription: t`Achieve mastery in all skills in 4th grade: Division`,
        },
        topic_exercise_x1ad1d91034b22aa9: {
            description: t`4th grade: Division (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 4th grade: Division (old)`,
        },
        topic_exercise_xe2dd268f0b6da159_mastery: {
            description: t`4th grade: Equivalent fractions and comparing fractions`,
            extendedDescription: t`Achieve mastery in all skills in 4th grade: Equivalent fractions and comparing fractions`,
        },
        topic_exercise_xe2dd268f0b6da159: {
            description: t`4th grade: Equivalent fractions and comparing fractions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 4th grade: Equivalent fractions and comparing fractions (old)`,
        },
        topic_exercise_x78a4b34a9c701baa_mastery: {
            description: t`4th grade: Factors, multiples and patterns`,
            extendedDescription: t`Achieve mastery in all skills in 4th grade: Factors, multiples and patterns`,
        },
        topic_exercise_x78a4b34a9c701baa: {
            description: t`4th grade: Factors, multiples and patterns (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 4th grade: Factors, multiples and patterns (old)`,
        },
        topic_exercise_x3d7033fa7fcee32a_mastery: {
            description: t`4th grade: Measuring angles`,
            extendedDescription: t`Achieve mastery in all skills in 4th grade: Measuring angles`,
        },
        topic_exercise_x3d7033fa7fcee32a: {
            description: t`4th grade: Measuring angles (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 4th grade: Measuring angles (old)`,
        },
        topic_exercise_xb1989190c0f4fecd_mastery: {
            description: t`4th grade: Multiply by 1-digit numbers`,
            extendedDescription: t`Achieve mastery in all skills in 4th grade: Multiply by 1-digit numbers`,
        },
        topic_exercise_xb1989190c0f4fecd: {
            description: t`4th grade: Multiply by 1-digit numbers (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 4th grade: Multiply by 1-digit numbers (old)`,
        },
        topic_exercise_x07642e154dcbce84_mastery: {
            description: t`4th grade: Multiply by 2-digit numbers`,
            extendedDescription: t`Achieve mastery in all skills in 4th grade: Multiply by 2-digit numbers`,
        },
        topic_exercise_x07642e154dcbce84: {
            description: t`4th grade: Multiply by 2-digit numbers (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 4th grade: Multiply by 2-digit numbers (old)`,
        },
        topic_exercise_xf1742dd908ad95bb_mastery: {
            description: t`4th grade: Multiply fractions`,
            extendedDescription: t`Achieve mastery in all skills in 4th grade: Multiply fractions`,
        },
        topic_exercise_xf1742dd908ad95bb: {
            description: t`4th grade: Multiply fractions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 4th grade: Multiply fractions (old)`,
        },
        topic_exercise_x2e769ecc206ef7d3_mastery: {
            description: t`4th grade: Place value`,
            extendedDescription: t`Achieve mastery in all skills in 4th grade: Place value`,
        },
        topic_exercise_x2e769ecc206ef7d3: {
            description: t`4th grade: Place value (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 4th grade: Place value (old)`,
        },
        topic_exercise_xc6c4f75ef3941c1e_mastery: {
            description: t`4th grade: Plane figures`,
            extendedDescription: t`Achieve mastery in all skills in 4th grade: Plane figures`,
        },
        topic_exercise_xc6c4f75ef3941c1e: {
            description: t`4th grade: Plane figures (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 4th grade: Plane figures (old)`,
        },
        topic_exercise_x64dfa339e6a2a01a_mastery: {
            description: t`4th grade: Understand decimals`,
            extendedDescription: t`Achieve mastery in all skills in 4th grade: Understand decimals`,
        },
        topic_exercise_x64dfa339e6a2a01a: {
            description: t`4th grade: Understand decimals (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 4th grade: Understand decimals (old)`,
        },
        topic_exercise_x99ee046cc1e8cac7_mastery: {
            description: t`4th grade: Units of measurement`,
            extendedDescription: t`Achieve mastery in all skills in 4th grade: Units of measurement`,
        },
        topic_exercise_x99ee046cc1e8cac7: {
            description: t`4th grade: Units of measurement (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 4th grade: Units of measurement (old)`,
        },
        topic_exercise_x59c3b242_mastery: {
            description: t`5th grade (2018 edition): Addition and subtraction`,
            extendedDescription: t`Achieve mastery in all skills in 5th grade (2018 edition): Addition and subtraction`,
        },
        topic_exercise_x59c3b242: {
            description: t`5th grade (2018 edition): Addition and subtraction (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 5th grade (2018 edition): Addition and subtraction (old)`,
        },
        topic_exercise_x49226f8c_mastery: {
            description: t`5th grade (2018 edition): Algebraic thinking`,
            extendedDescription: t`Achieve mastery in all skills in 5th grade (2018 edition): Algebraic thinking`,
        },
        topic_exercise_x49226f8c: {
            description: t`5th grade (2018 edition): Algebraic thinking (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 5th grade (2018 edition): Algebraic thinking (old)`,
        },
        topic_exercise_x91cad26e_mastery: {
            description: t`5th grade (2018 edition): Fractions`,
            extendedDescription: t`Achieve mastery in all skills in 5th grade (2018 edition): Fractions`,
        },
        topic_exercise_x91cad26e: {
            description: t`5th grade (2018 edition): Fractions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 5th grade (2018 edition): Fractions (old)`,
        },
        topic_exercise_x6e6877f8_mastery: {
            description: t`5th grade (2018 edition): Geometry`,
            extendedDescription: t`Achieve mastery in all skills in 5th grade (2018 edition): Geometry`,
        },
        topic_exercise_x6e6877f8: {
            description: t`5th grade (2018 edition): Geometry (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 5th grade (2018 edition): Geometry (old)`,
        },
        topic_exercise_x0ad7497b_mastery: {
            description: t`5th grade (2018 edition): Measurement and data`,
            extendedDescription: t`Achieve mastery in all skills in 5th grade (2018 edition): Measurement and data`,
        },
        topic_exercise_x0ad7497b: {
            description: t`5th grade (2018 edition): Measurement and data (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 5th grade (2018 edition): Measurement and data (old)`,
        },
        topic_exercise_x703d600572201e55_mastery: {
            description: t`5th grade (2018 edition): Multiplication and division`,
            extendedDescription: t`Achieve mastery in all skills in 5th grade (2018 edition): Multiplication and division`,
        },
        topic_exercise_x703d600572201e55: {
            description: t`5th grade (2018 edition): Multiplication and division (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 5th grade (2018 edition): Multiplication and division (old)`,
        },
        topic_exercise_xdd840283_mastery: {
            description: t`5th grade (2018 edition): Place value and decimals`,
            extendedDescription: t`Achieve mastery in all skills in 5th grade (2018 edition): Place value and decimals`,
        },
        topic_exercise_xdd840283: {
            description: t`5th grade (2018 edition): Place value and decimals (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 5th grade (2018 edition): Place value and decimals (old)`,
        },
        topic_exercise_xcdf68057_mastery: {
            description: t`5th grade (Eureka Math/EngageNY): Module 1: Place value and decimal fractions`,
            extendedDescription: t`Achieve mastery in all skills in 5th grade (Eureka Math/EngageNY): Module 1: Place value and decimal fractions`,
        },
        topic_exercise_xcdf68057: {
            description: t`5th grade (Eureka Math/EngageNY): Module 1: Place value and decimal fractions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 5th grade (Eureka Math/EngageNY): Module 1: Place value and decimal fractions (old)`,
        },
        topic_exercise_x71db71a6_mastery: {
            description: t`5th grade (Eureka Math/EngageNY): Module 2: Multi-digit whole number and decimal fraction operations`,
            extendedDescription: t`Achieve mastery in all skills in 5th grade (Eureka Math/EngageNY): Module 2: Multi-digit whole number and decimal fraction operations`,
        },
        topic_exercise_x71db71a6: {
            description: t`5th grade (Eureka Math/EngageNY): Module 2: Multi-digit whole number and decimal fraction operations (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 5th grade (Eureka Math/EngageNY): Module 2: Multi-digit whole number and decimal fraction operations (old)`,
        },
        topic_exercise_xf8624666_mastery: {
            description: t`5th grade (Eureka Math/EngageNY): Module 3: Addition and subtractions of fractions`,
            extendedDescription: t`Achieve mastery in all skills in 5th grade (Eureka Math/EngageNY): Module 3: Addition and subtractions of fractions`,
        },
        topic_exercise_xf8624666: {
            description: t`5th grade (Eureka Math/EngageNY): Module 3: Addition and subtractions of fractions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 5th grade (Eureka Math/EngageNY): Module 3: Addition and subtractions of fractions (old)`,
        },
        topic_exercise_xfc4dc15c_mastery: {
            description: t`5th grade (Eureka Math/EngageNY): Module 4: Multiplication and division of fractions and decimal fractions`,
            extendedDescription: t`Achieve mastery in all skills in 5th grade (Eureka Math/EngageNY): Module 4: Multiplication and division of fractions and decimal fractions`,
        },
        topic_exercise_xfc4dc15c: {
            description: t`5th grade (Eureka Math/EngageNY): Module 4: Multiplication and division of fractions and decimal fractions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 5th grade (Eureka Math/EngageNY): Module 4: Multiplication and division of fractions and decimal fractions (old)`,
        },
        topic_exercise_xe08c6afb_mastery: {
            description: t`5th grade (Eureka Math/EngageNY): Module 5: Addition and multiplication with volume and area`,
            extendedDescription: t`Achieve mastery in all skills in 5th grade (Eureka Math/EngageNY): Module 5: Addition and multiplication with volume and area`,
        },
        topic_exercise_xe08c6afb: {
            description: t`5th grade (Eureka Math/EngageNY): Module 5: Addition and multiplication with volume and area (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 5th grade (Eureka Math/EngageNY): Module 5: Addition and multiplication with volume and area (old)`,
        },
        topic_exercise_xa56687a7_mastery: {
            description: t`5th grade (Eureka Math/EngageNY): Module 6: Problem solving with the coordinate plane`,
            extendedDescription: t`Achieve mastery in all skills in 5th grade (Eureka Math/EngageNY): Module 6: Problem solving with the coordinate plane`,
        },
        topic_exercise_xa56687a7: {
            description: t`5th grade (Eureka Math/EngageNY): Module 6: Problem solving with the coordinate plane (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 5th grade (Eureka Math/EngageNY): Module 6: Problem solving with the coordinate plane (old)`,
        },
        topic_exercise_x628adebe7726a7f9_mastery: {
            description: t`5th grade: Add and subtract fractions`,
            extendedDescription: t`Achieve mastery in all skills in 5th grade: Add and subtract fractions`,
        },
        topic_exercise_x628adebe7726a7f9: {
            description: t`5th grade: Add and subtract fractions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 5th grade: Add and subtract fractions (old)`,
        },
        topic_exercise_xd6b59354eae23131_mastery: {
            description: t`5th grade: Add decimals`,
            extendedDescription: t`Achieve mastery in all skills in 5th grade: Add decimals`,
        },
        topic_exercise_xd6b59354eae23131: {
            description: t`5th grade: Add decimals (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 5th grade: Add decimals (old)`,
        },
        topic_exercise_xb57c1e66dbfcf814_mastery: {
            description: t`5th grade: Algebraic thinking`,
            extendedDescription: t`Achieve mastery in all skills in 5th grade: Algebraic thinking`,
        },
        topic_exercise_xb57c1e66dbfcf814: {
            description: t`5th grade: Algebraic thinking (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 5th grade: Algebraic thinking (old)`,
        },
        topic_exercise_x089f5910b6891a89_mastery: {
            description: t`5th grade: Converting units of measure`,
            extendedDescription: t`Achieve mastery in all skills in 5th grade: Converting units of measure`,
        },
        topic_exercise_x089f5910b6891a89: {
            description: t`5th grade: Converting units of measure (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 5th grade: Converting units of measure (old)`,
        },
        topic_exercise_xfdd13d8b6ab193b1_mastery: {
            description: t`5th grade: Coordinate plane`,
            extendedDescription: t`Achieve mastery in all skills in 5th grade: Coordinate plane`,
        },
        topic_exercise_xfdd13d8b6ab193b1: {
            description: t`5th grade: Coordinate plane (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 5th grade: Coordinate plane (old)`,
        },
        topic_exercise_x3352c53c9d44393a_mastery: {
            description: t`5th grade: Decimal place value`,
            extendedDescription: t`Achieve mastery in all skills in 5th grade: Decimal place value`,
        },
        topic_exercise_x3352c53c9d44393a: {
            description: t`5th grade: Decimal place value (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 5th grade: Decimal place value (old)`,
        },
        topic_exercise_x07c8b6456e9c1c75_mastery: {
            description: t`5th grade: Divide decimals`,
            extendedDescription: t`Achieve mastery in all skills in 5th grade: Divide decimals`,
        },
        topic_exercise_x07c8b6456e9c1c75: {
            description: t`5th grade: Divide decimals (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 5th grade: Divide decimals (old)`,
        },
        topic_exercise_xaa5594d535a0a85b_mastery: {
            description: t`5th grade: Divide fractions`,
            extendedDescription: t`Achieve mastery in all skills in 5th grade: Divide fractions`,
        },
        topic_exercise_xaa5594d535a0a85b: {
            description: t`5th grade: Divide fractions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 5th grade: Divide fractions (old)`,
        },
        topic_exercise_x74347b2dc32a2bb6_mastery: {
            description: t`5th grade: Line plots`,
            extendedDescription: t`Achieve mastery in all skills in 5th grade: Line plots`,
        },
        topic_exercise_x74347b2dc32a2bb6: {
            description: t`5th grade: Line plots (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 5th grade: Line plots (old)`,
        },
        topic_exercise_x135b013a7369cdbe_mastery: {
            description: t`5th grade: Multi-digit multiplication and division`,
            extendedDescription: t`Achieve mastery in all skills in 5th grade: Multi-digit multiplication and division`,
        },
        topic_exercise_x135b013a7369cdbe: {
            description: t`5th grade: Multi-digit multiplication and division (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 5th grade: Multi-digit multiplication and division (old)`,
        },
        topic_exercise_xfc2fd5ea6fc84684_mastery: {
            description: t`5th grade: Multiply decimals`,
            extendedDescription: t`Achieve mastery in all skills in 5th grade: Multiply decimals`,
        },
        topic_exercise_xfc2fd5ea6fc84684: {
            description: t`5th grade: Multiply decimals (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 5th grade: Multiply decimals (old)`,
        },
        topic_exercise_x470ebc97c1b5374f_mastery: {
            description: t`5th grade: Multiply fractions`,
            extendedDescription: t`Achieve mastery in all skills in 5th grade: Multiply fractions`,
        },
        topic_exercise_x470ebc97c1b5374f: {
            description: t`5th grade: Multiply fractions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 5th grade: Multiply fractions (old)`,
        },
        topic_exercise_x6fd693407b7c7590_mastery: {
            description: t`5th grade: Powers of ten`,
            extendedDescription: t`Achieve mastery in all skills in 5th grade: Powers of ten`,
        },
        topic_exercise_x6fd693407b7c7590: {
            description: t`5th grade: Powers of ten (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 5th grade: Powers of ten (old)`,
        },
        topic_exercise_x72cf2593cc6c03eb_mastery: {
            description: t`5th grade: Properties of shapes`,
            extendedDescription: t`Achieve mastery in all skills in 5th grade: Properties of shapes`,
        },
        topic_exercise_x72cf2593cc6c03eb: {
            description: t`5th grade: Properties of shapes (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 5th grade: Properties of shapes (old)`,
        },
        topic_exercise_x926167d2b9a10c25_mastery: {
            description: t`5th grade: Subtract decimals`,
            extendedDescription: t`Achieve mastery in all skills in 5th grade: Subtract decimals`,
        },
        topic_exercise_x926167d2b9a10c25: {
            description: t`5th grade: Subtract decimals (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 5th grade: Subtract decimals (old)`,
        },
        topic_exercise_x494de4cd016e2847_mastery: {
            description: t`5th grade: Volume`,
            extendedDescription: t`Achieve mastery in all skills in 5th grade: Volume`,
        },
        topic_exercise_x494de4cd016e2847: {
            description: t`5th grade: Volume (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 5th grade: Volume (old)`,
        },
        topic_exercise_x2f41f428_mastery: {
            description: t`6th grade (Eureka Math/EngageNY): Module 1: Foundations`,
            extendedDescription: t`Achieve mastery in all skills in 6th grade (Eureka Math/EngageNY): Module 1: Foundations`,
        },
        topic_exercise_x2f41f428: {
            description: t`6th grade (Eureka Math/EngageNY): Module 1: Foundations (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 6th grade (Eureka Math/EngageNY): Module 1: Foundations (old)`,
        },
        topic_exercise_x2c8bd785_mastery: {
            description: t`6th grade (Eureka Math/EngageNY): Module 1: Ratios and unit rates`,
            extendedDescription: t`Achieve mastery in all skills in 6th grade (Eureka Math/EngageNY): Module 1: Ratios and unit rates`,
        },
        topic_exercise_x2c8bd785: {
            description: t`6th grade (Eureka Math/EngageNY): Module 1: Ratios and unit rates (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 6th grade (Eureka Math/EngageNY): Module 1: Ratios and unit rates (old)`,
        },
        topic_exercise_xcc6017fc_mastery: {
            description: t`6th grade (Eureka Math/EngageNY): Module 2: Arithmetic operations including dividing by a fraction`,
            extendedDescription: t`Achieve mastery in all skills in 6th grade (Eureka Math/EngageNY): Module 2: Arithmetic operations including dividing by a fraction`,
        },
        topic_exercise_xcc6017fc: {
            description: t`6th grade (Eureka Math/EngageNY): Module 2: Arithmetic operations including dividing by a fraction (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 6th grade (Eureka Math/EngageNY): Module 2: Arithmetic operations including dividing by a fraction (old)`,
        },
        topic_exercise_x979ec292_mastery: {
            description: t`6th grade (Eureka Math/EngageNY): Module 3: Rational numbers`,
            extendedDescription: t`Achieve mastery in all skills in 6th grade (Eureka Math/EngageNY): Module 3: Rational numbers`,
        },
        topic_exercise_x979ec292: {
            description: t`6th grade (Eureka Math/EngageNY): Module 3: Rational numbers (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 6th grade (Eureka Math/EngageNY): Module 3: Rational numbers (old)`,
        },
        topic_exercise_x80fafbe0_mastery: {
            description: t`6th grade (Eureka Math/EngageNY): Module 4: Expressions and equations`,
            extendedDescription: t`Achieve mastery in all skills in 6th grade (Eureka Math/EngageNY): Module 4: Expressions and equations`,
        },
        topic_exercise_x80fafbe0: {
            description: t`6th grade (Eureka Math/EngageNY): Module 4: Expressions and equations (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 6th grade (Eureka Math/EngageNY): Module 4: Expressions and equations (old)`,
        },
        topic_exercise_x5aaf9ad1_mastery: {
            description: t`6th grade (Eureka Math/EngageNY): Module 5: Area, surface area, and volume problems`,
            extendedDescription: t`Achieve mastery in all skills in 6th grade (Eureka Math/EngageNY): Module 5: Area, surface area, and volume problems`,
        },
        topic_exercise_x5aaf9ad1: {
            description: t`6th grade (Eureka Math/EngageNY): Module 5: Area, surface area, and volume problems (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 6th grade (Eureka Math/EngageNY): Module 5: Area, surface area, and volume problems (old)`,
        },
        topic_exercise_xf707feda_mastery: {
            description: t`6th grade (Eureka Math/EngageNY): Module 6: Statistics`,
            extendedDescription: t`Achieve mastery in all skills in 6th grade (Eureka Math/EngageNY): Module 6: Statistics`,
        },
        topic_exercise_xf707feda: {
            description: t`6th grade (Eureka Math/EngageNY): Module 6: Statistics (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 6th grade (Eureka Math/EngageNY): Module 6: Statistics (old)`,
        },
        topic_exercise_xf5815416_mastery: {
            description: t`6th grade: Arithmetic operations`,
            extendedDescription: t`Achieve mastery in all skills in 6th grade: Arithmetic operations`,
        },
        topic_exercise_xf5815416: {
            description: t`6th grade: Arithmetic operations (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 6th grade: Arithmetic operations (old)`,
        },
        topic_exercise_x419abcbd_mastery: {
            description: t`6th grade: Data and statistics`,
            extendedDescription: t`Achieve mastery in all skills in 6th grade: Data and statistics`,
        },
        topic_exercise_x419abcbd: {
            description: t`6th grade: Data and statistics (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 6th grade: Data and statistics (old)`,
        },
        topic_exercise_x98e0520f_mastery: {
            description: t`6th grade: Equations & inequalities introduction`,
            extendedDescription: t`Achieve mastery in all skills in 6th grade: Equations & inequalities introduction`,
        },
        topic_exercise_x98e0520f: {
            description: t`6th grade: Equations & inequalities introduction (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 6th grade: Equations & inequalities introduction (old)`,
        },
        topic_exercise_x77851161_mastery: {
            description: t`6th grade: Equivalent expressions`,
            extendedDescription: t`Achieve mastery in all skills in 6th grade: Equivalent expressions`,
        },
        topic_exercise_x77851161: {
            description: t`6th grade: Equivalent expressions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 6th grade: Equivalent expressions (old)`,
        },
        topic_exercise_xfa626edb_mastery: {
            description: t`6th grade: Geometry`,
            extendedDescription: t`Achieve mastery in all skills in 6th grade: Geometry`,
        },
        topic_exercise_xfa626edb: {
            description: t`6th grade: Geometry (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 6th grade: Geometry (old)`,
        },
        topic_exercise_x347111cf_mastery: {
            description: t`6th grade: Negative numbers`,
            extendedDescription: t`Achieve mastery in all skills in 6th grade: Negative numbers`,
        },
        topic_exercise_x347111cf: {
            description: t`6th grade: Negative numbers (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 6th grade: Negative numbers (old)`,
        },
        topic_exercise_x673b532f_mastery: {
            description: t`6th grade: Properties of numbers`,
            extendedDescription: t`Achieve mastery in all skills in 6th grade: Properties of numbers`,
        },
        topic_exercise_x673b532f: {
            description: t`6th grade: Properties of numbers (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 6th grade: Properties of numbers (old)`,
        },
        topic_exercise_x22eef7de_mastery: {
            description: t`6th grade: Ratios, rates, & percentages`,
            extendedDescription: t`Achieve mastery in all skills in 6th grade: Ratios, rates, & percentages`,
        },
        topic_exercise_x22eef7de: {
            description: t`6th grade: Ratios, rates, & percentages (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 6th grade: Ratios, rates, & percentages (old)`,
        },
        topic_exercise_x8ade30f9_mastery: {
            description: t`6th grade: Variables & expressions`,
            extendedDescription: t`Achieve mastery in all skills in 6th grade: Variables & expressions`,
        },
        topic_exercise_x8ade30f9: {
            description: t`6th grade: Variables & expressions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 6th grade: Variables & expressions (old)`,
        },
        topic_exercise_x27543407_mastery: {
            description: t`7th grade (Eureka Math/EngageNY): Module 1: Ratios and proportional relationships`,
            extendedDescription: t`Achieve mastery in all skills in 7th grade (Eureka Math/EngageNY): Module 1: Ratios and proportional relationships`,
        },
        topic_exercise_x27543407: {
            description: t`7th grade (Eureka Math/EngageNY): Module 1: Ratios and proportional relationships (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 7th grade (Eureka Math/EngageNY): Module 1: Ratios and proportional relationships (old)`,
        },
        topic_exercise_x4b63ca24_mastery: {
            description: t`7th grade (Eureka Math/EngageNY): Module 2: Rational numbers`,
            extendedDescription: t`Achieve mastery in all skills in 7th grade (Eureka Math/EngageNY): Module 2: Rational numbers`,
        },
        topic_exercise_x4b63ca24: {
            description: t`7th grade (Eureka Math/EngageNY): Module 2: Rational numbers (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 7th grade (Eureka Math/EngageNY): Module 2: Rational numbers (old)`,
        },
        topic_exercise_x1e214063_mastery: {
            description: t`7th grade (Eureka Math/EngageNY): Module 3: Expressions and equations`,
            extendedDescription: t`Achieve mastery in all skills in 7th grade (Eureka Math/EngageNY): Module 3: Expressions and equations`,
        },
        topic_exercise_x1e214063: {
            description: t`7th grade (Eureka Math/EngageNY): Module 3: Expressions and equations (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 7th grade (Eureka Math/EngageNY): Module 3: Expressions and equations (old)`,
        },
        topic_exercise_xe048f240_mastery: {
            description: t`7th grade (Eureka Math/EngageNY): Module 4: Percent and proportional relationships`,
            extendedDescription: t`Achieve mastery in all skills in 7th grade (Eureka Math/EngageNY): Module 4: Percent and proportional relationships`,
        },
        topic_exercise_xe048f240: {
            description: t`7th grade (Eureka Math/EngageNY): Module 4: Percent and proportional relationships (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 7th grade (Eureka Math/EngageNY): Module 4: Percent and proportional relationships (old)`,
        },
        topic_exercise_x83a102cb_mastery: {
            description: t`7th grade (Eureka Math/EngageNY): Module 5: Statistics and probability`,
            extendedDescription: t`Achieve mastery in all skills in 7th grade (Eureka Math/EngageNY): Module 5: Statistics and probability`,
        },
        topic_exercise_x83a102cb: {
            description: t`7th grade (Eureka Math/EngageNY): Module 5: Statistics and probability (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 7th grade (Eureka Math/EngageNY): Module 5: Statistics and probability (old)`,
        },
        topic_exercise_xb282e68b_mastery: {
            description: t`7th grade (Eureka Math/EngageNY): Module 6: Geometry`,
            extendedDescription: t`Achieve mastery in all skills in 7th grade (Eureka Math/EngageNY): Module 6: Geometry`,
        },
        topic_exercise_xb282e68b: {
            description: t`7th grade (Eureka Math/EngageNY): Module 6: Geometry (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 7th grade (Eureka Math/EngageNY): Module 6: Geometry (old)`,
        },
        topic_exercise_x0a8c9f98_mastery: {
            description: t`7th grade: Expressions, equations, & inequalities`,
            extendedDescription: t`Achieve mastery in all skills in 7th grade: Expressions, equations, & inequalities`,
        },
        topic_exercise_x0a8c9f98: {
            description: t`7th grade: Expressions, equations, & inequalities (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 7th grade: Expressions, equations, & inequalities (old)`,
        },
        topic_exercise_xbee72d33_mastery: {
            description: t`7th grade: Fractions, decimals, & percentages`,
            extendedDescription: t`Achieve mastery in all skills in 7th grade: Fractions, decimals, & percentages`,
        },
        topic_exercise_xbee72d33: {
            description: t`7th grade: Fractions, decimals, & percentages (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 7th grade: Fractions, decimals, & percentages (old)`,
        },
        topic_exercise_xc1a4d524_mastery: {
            description: t`7th grade: Geometry`,
            extendedDescription: t`Achieve mastery in all skills in 7th grade: Geometry`,
        },
        topic_exercise_xc1a4d524: {
            description: t`7th grade: Geometry (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 7th grade: Geometry (old)`,
        },
        topic_exercise_x7ef05b40_mastery: {
            description: t`7th grade: Negative numbers: addition and subtraction`,
            extendedDescription: t`Achieve mastery in all skills in 7th grade: Negative numbers: addition and subtraction`,
        },
        topic_exercise_x7ef05b40: {
            description: t`7th grade: Negative numbers: addition and subtraction (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 7th grade: Negative numbers: addition and subtraction (old)`,
        },
        topic_exercise_x4ddd8846_mastery: {
            description: t`7th grade: Negative numbers: multiplication and division`,
            extendedDescription: t`Achieve mastery in all skills in 7th grade: Negative numbers: multiplication and division`,
        },
        topic_exercise_x4ddd8846: {
            description: t`7th grade: Negative numbers: multiplication and division (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 7th grade: Negative numbers: multiplication and division (old)`,
        },
        topic_exercise_x805b3a5e_mastery: {
            description: t`7th grade: Rates & proportional relationships`,
            extendedDescription: t`Achieve mastery in all skills in 7th grade: Rates & proportional relationships`,
        },
        topic_exercise_x805b3a5e: {
            description: t`7th grade: Rates & proportional relationships (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 7th grade: Rates & proportional relationships (old)`,
        },
        topic_exercise_x657459cb_mastery: {
            description: t`7th grade: Statistics and probability`,
            extendedDescription: t`Achieve mastery in all skills in 7th grade: Statistics and probability`,
        },
        topic_exercise_x657459cb: {
            description: t`7th grade: Statistics and probability (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 7th grade: Statistics and probability (old)`,
        },
        topic_exercise_x02b767d2_mastery: {
            description: t`8th grade (Eureka Math/EngageNY): Module 1: Integer exponents and scientific notation`,
            extendedDescription: t`Achieve mastery in all skills in 8th grade (Eureka Math/EngageNY): Module 1: Integer exponents and scientific notation`,
        },
        topic_exercise_x02b767d2: {
            description: t`8th grade (Eureka Math/EngageNY): Module 1: Integer exponents and scientific notation (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 8th grade (Eureka Math/EngageNY): Module 1: Integer exponents and scientific notation (old)`,
        },
        topic_exercise_xe0191c84_mastery: {
            description: t`8th grade (Eureka Math/EngageNY): Module 2: The concept of congruence`,
            extendedDescription: t`Achieve mastery in all skills in 8th grade (Eureka Math/EngageNY): Module 2: The concept of congruence`,
        },
        topic_exercise_xe0191c84: {
            description: t`8th grade (Eureka Math/EngageNY): Module 2: The concept of congruence (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 8th grade (Eureka Math/EngageNY): Module 2: The concept of congruence (old)`,
        },
        topic_exercise_x28eabc20_mastery: {
            description: t`8th grade (Eureka Math/EngageNY): Module 3: Similarity`,
            extendedDescription: t`Achieve mastery in all skills in 8th grade (Eureka Math/EngageNY): Module 3: Similarity`,
        },
        topic_exercise_x28eabc20: {
            description: t`8th grade (Eureka Math/EngageNY): Module 3: Similarity (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 8th grade (Eureka Math/EngageNY): Module 3: Similarity (old)`,
        },
        topic_exercise_x58beebf4_mastery: {
            description: t`8th grade (Eureka Math/EngageNY): Module 4: Linear equations`,
            extendedDescription: t`Achieve mastery in all skills in 8th grade (Eureka Math/EngageNY): Module 4: Linear equations`,
        },
        topic_exercise_x58beebf4: {
            description: t`8th grade (Eureka Math/EngageNY): Module 4: Linear equations (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 8th grade (Eureka Math/EngageNY): Module 4: Linear equations (old)`,
        },
        topic_exercise_xfa80bcdc_mastery: {
            description: t`8th grade (Eureka Math/EngageNY): Module 5: Examples of functions from geometry`,
            extendedDescription: t`Achieve mastery in all skills in 8th grade (Eureka Math/EngageNY): Module 5: Examples of functions from geometry`,
        },
        topic_exercise_xfa80bcdc: {
            description: t`8th grade (Eureka Math/EngageNY): Module 5: Examples of functions from geometry (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 8th grade (Eureka Math/EngageNY): Module 5: Examples of functions from geometry (old)`,
        },
        topic_exercise_x63ea1b64_mastery: {
            description: t`8th grade (Eureka Math/EngageNY): Module 6: Linear functions`,
            extendedDescription: t`Achieve mastery in all skills in 8th grade (Eureka Math/EngageNY): Module 6: Linear functions`,
        },
        topic_exercise_x63ea1b64: {
            description: t`8th grade (Eureka Math/EngageNY): Module 6: Linear functions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 8th grade (Eureka Math/EngageNY): Module 6: Linear functions (old)`,
        },
        topic_exercise_xc7564d00_mastery: {
            description: t`8th grade (Eureka Math/EngageNY): Module 7: Introduction to irrational numbers using geometry`,
            extendedDescription: t`Achieve mastery in all skills in 8th grade (Eureka Math/EngageNY): Module 7: Introduction to irrational numbers using geometry`,
        },
        topic_exercise_xc7564d00: {
            description: t`8th grade (Eureka Math/EngageNY): Module 7: Introduction to irrational numbers using geometry (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 8th grade (Eureka Math/EngageNY): Module 7: Introduction to irrational numbers using geometry (old)`,
        },
        topic_exercise_xe83906b3_mastery: {
            description: t`8th grade: Data and modeling`,
            extendedDescription: t`Achieve mastery in all skills in 8th grade: Data and modeling`,
        },
        topic_exercise_xe83906b3: {
            description: t`8th grade: Data and modeling (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 8th grade: Data and modeling (old)`,
        },
        topic_exercise_xc8775c02c8a5d124_mastery: {
            description: t`8th grade: Geometric transformations`,
            extendedDescription: t`Achieve mastery in all skills in 8th grade: Geometric transformations`,
        },
        topic_exercise_xc8775c02c8a5d124: {
            description: t`8th grade: Geometric transformations (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 8th grade: Geometric transformations (old)`,
        },
        topic_exercise_x7306f126_mastery: {
            description: t`8th grade: Geometry`,
            extendedDescription: t`Achieve mastery in all skills in 8th grade: Geometry`,
        },
        topic_exercise_x7306f126: {
            description: t`8th grade: Geometry (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 8th grade: Geometry (old)`,
        },
        topic_exercise_xc44ef069_mastery: {
            description: t`8th grade: Linear equations and functions`,
            extendedDescription: t`Achieve mastery in all skills in 8th grade: Linear equations and functions`,
        },
        topic_exercise_xc44ef069: {
            description: t`8th grade: Linear equations and functions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 8th grade: Linear equations and functions (old)`,
        },
        topic_exercise_x1afd9461_mastery: {
            description: t`8th grade: Numbers and operations`,
            extendedDescription: t`Achieve mastery in all skills in 8th grade: Numbers and operations`,
        },
        topic_exercise_x1afd9461: {
            description: t`8th grade: Numbers and operations (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 8th grade: Numbers and operations (old)`,
        },
        topic_exercise_xdffae55c_mastery: {
            description: t`8th grade: Solving equations with one unknown`,
            extendedDescription: t`Achieve mastery in all skills in 8th grade: Solving equations with one unknown`,
        },
        topic_exercise_xdffae55c: {
            description: t`8th grade: Solving equations with one unknown (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 8th grade: Solving equations with one unknown (old)`,
        },
        topic_exercise_x71149dce_mastery: {
            description: t`8th grade: Systems of equations`,
            extendedDescription: t`Achieve mastery in all skills in 8th grade: Systems of equations`,
        },
        topic_exercise_x71149dce: {
            description: t`8th grade: Systems of equations (old)`,
            extendedDescription: t`Achieve proficiency in all skills in 8th grade: Systems of equations (old)`,
        },
        topic_exercise_x45f9dd34_mastery: {
            description: t`Addition and subtraction`,
            extendedDescription: t`Achieve mastery in all skills in Addition and subtraction`,
        },
        topic_exercise_x45f9dd34: {
            description: t`Addition and subtraction (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Addition and subtraction (old)`,
        },
        topic_exercise_x7a60fc0c_mastery: {
            description: t`Algebra basics: Algebraic expressions`,
            extendedDescription: t`Achieve mastery in all skills in Algebra basics: Algebraic expressions`,
        },
        topic_exercise_x93c46285_mastery: {
            description: t`Algebra basics: Algebraic expressions`,
            extendedDescription: t`Achieve mastery in all skills in Algebra basics: Algebraic expressions`,
        },
        topic_exercise_x7a60fc0c: {
            description: t`Algebra basics: Algebraic expressions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra basics: Algebraic expressions (old)`,
        },
        topic_exercise_x93c46285: {
            description: t`Algebra basics: Algebraic expressions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra basics: Algebraic expressions (old)`,
        },
        topic_exercise_x305b9738_mastery: {
            description: t`Algebra basics: Equations and geometry`,
            extendedDescription: t`Achieve mastery in all skills in Algebra basics: Equations and geometry`,
        },
        topic_exercise_x4a708f0f_mastery: {
            description: t`Algebra basics: Equations and geometry`,
            extendedDescription: t`Achieve mastery in all skills in Algebra basics: Equations and geometry`,
        },
        topic_exercise_x305b9738: {
            description: t`Algebra basics: Equations and geometry (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra basics: Equations and geometry (old)`,
        },
        topic_exercise_x4a708f0f: {
            description: t`Algebra basics: Equations and geometry (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra basics: Equations and geometry (old)`,
        },
        topic_exercise_x25c03557_mastery: {
            description: t`Algebra basics: Expressions with exponents`,
            extendedDescription: t`Achieve mastery in all skills in Algebra basics: Expressions with exponents`,
        },
        topic_exercise_xbaa0c0b3_mastery: {
            description: t`Algebra basics: Expressions with exponents`,
            extendedDescription: t`Achieve mastery in all skills in Algebra basics: Expressions with exponents`,
        },
        topic_exercise_x25c03557: {
            description: t`Algebra basics: Expressions with exponents (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra basics: Expressions with exponents (old)`,
        },
        topic_exercise_xbaa0c0b3: {
            description: t`Algebra basics: Expressions with exponents (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra basics: Expressions with exponents (old)`,
        },
        topic_exercise_xbe49b507_mastery: {
            description: t`Algebra basics: Foundations`,
            extendedDescription: t`Achieve mastery in all skills in Algebra basics: Foundations`,
        },
        topic_exercise_xceb0c7f3_mastery: {
            description: t`Algebra basics: Foundations`,
            extendedDescription: t`Achieve mastery in all skills in Algebra basics: Foundations`,
        },
        topic_exercise_xbe49b507: {
            description: t`Algebra basics: Foundations (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra basics: Foundations (old)`,
        },
        topic_exercise_xceb0c7f3: {
            description: t`Algebra basics: Foundations (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra basics: Foundations (old)`,
        },
        topic_exercise_x1df8fb3e_mastery: {
            description: t`Algebra basics: Graphing lines and slope`,
            extendedDescription: t`Achieve mastery in all skills in Algebra basics: Graphing lines and slope`,
        },
        topic_exercise_xf679b7f6_mastery: {
            description: t`Algebra basics: Graphing lines and slope`,
            extendedDescription: t`Achieve mastery in all skills in Algebra basics: Graphing lines and slope`,
        },
        topic_exercise_x1df8fb3e: {
            description: t`Algebra basics: Graphing lines and slope (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra basics: Graphing lines and slope (old)`,
        },
        topic_exercise_xf679b7f6: {
            description: t`Algebra basics: Graphing lines and slope (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra basics: Graphing lines and slope (old)`,
        },
        topic_exercise_x649777e8_mastery: {
            description: t`Algebra basics: Linear equations and inequalities`,
            extendedDescription: t`Achieve mastery in all skills in Algebra basics: Linear equations and inequalities`,
        },
        topic_exercise_x9d6a106d_mastery: {
            description: t`Algebra basics: Linear equations and inequalities`,
            extendedDescription: t`Achieve mastery in all skills in Algebra basics: Linear equations and inequalities`,
        },
        topic_exercise_x649777e8: {
            description: t`Algebra basics: Linear equations and inequalities (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra basics: Linear equations and inequalities (old)`,
        },
        topic_exercise_x9d6a106d: {
            description: t`Algebra basics: Linear equations and inequalities (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra basics: Linear equations and inequalities (old)`,
        },
        topic_exercise_x95928316_mastery: {
            description: t`Algebra basics: Quadratics and polynomials`,
            extendedDescription: t`Achieve mastery in all skills in Algebra basics: Quadratics and polynomials`,
        },
        topic_exercise_xa6990b91_mastery: {
            description: t`Algebra basics: Quadratics and polynomials`,
            extendedDescription: t`Achieve mastery in all skills in Algebra basics: Quadratics and polynomials`,
        },
        topic_exercise_x95928316: {
            description: t`Algebra basics: Quadratics and polynomials (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra basics: Quadratics and polynomials (old)`,
        },
        topic_exercise_xa6990b91: {
            description: t`Algebra basics: Quadratics and polynomials (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra basics: Quadratics and polynomials (old)`,
        },
        topic_exercise_x17e6e850_mastery: {
            description: t`Algebra basics: Systems of equations`,
            extendedDescription: t`Achieve mastery in all skills in Algebra basics: Systems of equations`,
        },
        topic_exercise_x1ca60c07_mastery: {
            description: t`Algebra basics: Systems of equations`,
            extendedDescription: t`Achieve mastery in all skills in Algebra basics: Systems of equations`,
        },
        topic_exercise_x17e6e850: {
            description: t`Algebra basics: Systems of equations (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra basics: Systems of equations (old)`,
        },
        topic_exercise_x1ca60c07: {
            description: t`Algebra basics: Systems of equations (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra basics: Systems of equations (old)`,
        },
        topic_exercise_x815a4357_mastery: {
            description: t`Algebra I (2018 edition): Absolute value & piecewise functions`,
            extendedDescription: t`Achieve mastery in all skills in Algebra I (2018 edition): Absolute value & piecewise functions`,
        },
        topic_exercise_x815a4357: {
            description: t`Algebra I (2018 edition): Absolute value & piecewise functions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra I (2018 edition): Absolute value & piecewise functions (old)`,
        },
        "topic_exercise_ES42PFTrnyI3qIU-b2XIjTAnTVpAdeqPWBrQXfNv_mastery": {
            description: t`Algebra I (2018 edition): Algebra foundations`,
            extendedDescription: t`Achieve mastery in all skills in Algebra I (2018 edition): Algebra foundations`,
        },
        "topic_exercise_ES42PFTrnyI3qIU-b2XIjTAnTVpAdeqPWBrQXfNv": {
            description: t`Algebra I (2018 edition): Algebra foundations (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra I (2018 edition): Algebra foundations (old)`,
        },
        topic_exercise_xd1681a90_mastery: {
            description: t`Algebra I (2018 edition): Exponential growth & decay`,
            extendedDescription: t`Achieve mastery in all skills in Algebra I (2018 edition): Exponential growth & decay`,
        },
        topic_exercise_xd1681a90: {
            description: t`Algebra I (2018 edition): Exponential growth & decay (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra I (2018 edition): Exponential growth & decay (old)`,
        },
        topic_exercise_x5b01e065_mastery: {
            description: t`Algebra I (2018 edition): Factorization`,
            extendedDescription: t`Achieve mastery in all skills in Algebra I (2018 edition): Factorization`,
        },
        topic_exercise_x5b01e065: {
            description: t`Algebra I (2018 edition): Factorization (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra I (2018 edition): Factorization (old)`,
        },
        topic_exercise_K5CAA_lSb0gdqtmMngO1hGkaLRdDAWa4JaXblBhJ_mastery: {
            description: t`Algebra I (2018 edition): Functions`,
            extendedDescription: t`Achieve mastery in all skills in Algebra I (2018 edition): Functions`,
        },
        topic_exercise_K5CAA_lSb0gdqtmMngO1hGkaLRdDAWa4JaXblBhJ: {
            description: t`Algebra I (2018 edition): Functions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra I (2018 edition): Functions (old)`,
        },
        topic_exercise_x4bd7e256_mastery: {
            description: t`Algebra I (2018 edition): Inequalities (systems & graphs)`,
            extendedDescription: t`Achieve mastery in all skills in Algebra I (2018 edition): Inequalities (systems & graphs)`,
        },
        topic_exercise_x4bd7e256: {
            description: t`Algebra I (2018 edition): Inequalities (systems & graphs) (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra I (2018 edition): Inequalities (systems & graphs) (old)`,
        },
        topic_exercise_xdd7aa21f_mastery: {
            description: t`Algebra I (2018 edition): Irrational numbers`,
            extendedDescription: t`Achieve mastery in all skills in Algebra I (2018 edition): Irrational numbers`,
        },
        topic_exercise_xdd7aa21f: {
            description: t`Algebra I (2018 edition): Irrational numbers (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra I (2018 edition): Irrational numbers (old)`,
        },
        topic_exercise_x77a78bee_mastery: {
            description: t`Algebra I (2018 edition): Linear equations & graphs`,
            extendedDescription: t`Achieve mastery in all skills in Algebra I (2018 edition): Linear equations & graphs`,
        },
        topic_exercise_x77a78bee: {
            description: t`Algebra I (2018 edition): Linear equations & graphs (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra I (2018 edition): Linear equations & graphs (old)`,
        },
        topic_exercise_xc02c967b_mastery: {
            description: t`Algebra I (2018 edition): Linear word problems`,
            extendedDescription: t`Achieve mastery in all skills in Algebra I (2018 edition): Linear word problems`,
        },
        topic_exercise_xc02c967b: {
            description: t`Algebra I (2018 edition): Linear word problems (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra I (2018 edition): Linear word problems (old)`,
        },
        topic_exercise_x474ee3e7_mastery: {
            description: t`Algebra I (2018 edition): Polynomials`,
            extendedDescription: t`Achieve mastery in all skills in Algebra I (2018 edition): Polynomials`,
        },
        topic_exercise_x474ee3e7: {
            description: t`Algebra I (2018 edition): Polynomials (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra I (2018 edition): Polynomials (old)`,
        },
        topic_exercise_y5BHNHK0E9Xa6CyfEhZaIfDRkevXobYlkPt0Pk_G_mastery: {
            description: t`Algebra I (2018 edition): Quadratics`,
            extendedDescription: t`Achieve mastery in all skills in Algebra I (2018 edition): Quadratics`,
        },
        topic_exercise_y5BHNHK0E9Xa6CyfEhZaIfDRkevXobYlkPt0Pk_G: {
            description: t`Algebra I (2018 edition): Quadratics (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra I (2018 edition): Quadratics (old)`,
        },
        topic_exercise_x24340af5_mastery: {
            description: t`Algebra I (2018 edition): Rational exponents & radicals`,
            extendedDescription: t`Achieve mastery in all skills in Algebra I (2018 edition): Rational exponents & radicals`,
        },
        topic_exercise_x24340af5: {
            description: t`Algebra I (2018 edition): Rational exponents & radicals (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra I (2018 edition): Rational exponents & radicals (old)`,
        },
        topic_exercise_xe62bd906_mastery: {
            description: t`Algebra I (2018 edition): Sequences`,
            extendedDescription: t`Achieve mastery in all skills in Algebra I (2018 edition): Sequences`,
        },
        topic_exercise_xe62bd906: {
            description: t`Algebra I (2018 edition): Sequences (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra I (2018 edition): Sequences (old)`,
        },
        topic_exercise_ZRz9FP3Oc1JYP1M_xLUezZcfX1bM8F63rnN4syNu_mastery: {
            description: t`Algebra I (2018 edition): Solving equations`,
            extendedDescription: t`Achieve mastery in all skills in Algebra I (2018 edition): Solving equations`,
        },
        topic_exercise_ZRz9FP3Oc1JYP1M_xLUezZcfX1bM8F63rnN4syNu: {
            description: t`Algebra I (2018 edition): Solving equations (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra I (2018 edition): Solving equations (old)`,
        },
        "topic_exercise_RMCbw3fiPnqa7vGD5SivBWR1gH7XmCC-Fxss6NVp_mastery": {
            description: t`Algebra I (2018 edition): Solving inequalities`,
            extendedDescription: t`Achieve mastery in all skills in Algebra I (2018 edition): Solving inequalities`,
        },
        "topic_exercise_RMCbw3fiPnqa7vGD5SivBWR1gH7XmCC-Fxss6NVp": {
            description: t`Algebra I (2018 edition): Solving inequalities (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra I (2018 edition): Solving inequalities (old)`,
        },
        "topic_exercise_iuUnywliLBQQ_Dibzrrsruwox-Wp7915SgZ2mBk6_mastery": {
            description: t`Algebra I (2018 edition): Systems of equations`,
            extendedDescription: t`Achieve mastery in all skills in Algebra I (2018 edition): Systems of equations`,
        },
        "topic_exercise_iuUnywliLBQQ_Dibzrrsruwox-Wp7915SgZ2mBk6": {
            description: t`Algebra I (2018 edition): Systems of equations (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra I (2018 edition): Systems of equations (old)`,
        },
        topic_exercise_x5fd568c4_mastery: {
            description: t`Algebra I (2018 edition): Working with units`,
            extendedDescription: t`Achieve mastery in all skills in Algebra I (2018 edition): Working with units`,
        },
        topic_exercise_x5fd568c4: {
            description: t`Algebra I (2018 edition): Working with units (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra I (2018 edition): Working with units (old)`,
        },
        topic_exercise_x5ae1951f49267d10_mastery: {
            description: t`Algebra I: Absolute value & piecewise functions`,
            extendedDescription: t`Achieve mastery in all skills in Algebra I: Absolute value & piecewise functions`,
        },
        topic_exercise_x5ae1951f49267d10: {
            description: t`Algebra I: Absolute value & piecewise functions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra I: Absolute value & piecewise functions (old)`,
        },
        topic_exercise_x9c23cad6d9661edd_mastery: {
            description: t`Algebra I: Algebra foundations`,
            extendedDescription: t`Achieve mastery in all skills in Algebra I: Algebra foundations`,
        },
        topic_exercise_x9c23cad6d9661edd: {
            description: t`Algebra I: Algebra foundations (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra I: Algebra foundations (old)`,
        },
        "topic_exercise_btJEpdEmmhhYt0pelz-5BBCZXl4ft3nGTawvnrPq_mastery": {
            description: t`Algebra I: Exponent expressions and equations`,
            extendedDescription: t`Achieve mastery in all skills in Algebra I: Exponent expressions and equations`,
        },
        "topic_exercise_btJEpdEmmhhYt0pelz-5BBCZXl4ft3nGTawvnrPq": {
            description: t`Algebra I: Exponent expressions and equations (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra I: Exponent expressions and equations (old)`,
        },
        topic_exercise_x99b99cc8049cbb15_mastery: {
            description: t`Algebra I: Exponential growth & decay`,
            extendedDescription: t`Achieve mastery in all skills in Algebra I: Exponential growth & decay`,
        },
        topic_exercise_x99b99cc8049cbb15: {
            description: t`Algebra I: Exponential growth & decay (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra I: Exponential growth & decay (old)`,
        },
        topic_exercise_x50868c0eeb0fc226_mastery: {
            description: t`Algebra I: Exponents & radicals`,
            extendedDescription: t`Achieve mastery in all skills in Algebra I: Exponents & radicals`,
        },
        topic_exercise_x50868c0eeb0fc226: {
            description: t`Algebra I: Exponents & radicals (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra I: Exponents & radicals (old)`,
        },
        topic_exercise_x75b0106c03631b81_mastery: {
            description: t`Algebra I: Forms of linear equations`,
            extendedDescription: t`Achieve mastery in all skills in Algebra I: Forms of linear equations`,
        },
        topic_exercise_x75b0106c03631b81: {
            description: t`Algebra I: Forms of linear equations (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra I: Forms of linear equations (old)`,
        },
        topic_exercise_x90009cd8ae422e33_mastery: {
            description: t`Algebra I: Functions`,
            extendedDescription: t`Achieve mastery in all skills in Algebra I: Functions`,
        },
        topic_exercise_x90009cd8ae422e33: {
            description: t`Algebra I: Functions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra I: Functions (old)`,
        },
        "topic_exercise_st2s3FGaM9_CDZZFCq1BvO8SPXzr8HZi-Je63cKP_mastery": {
            description: t`Algebra I: Graphing and analyzing linear functions`,
            extendedDescription: t`Achieve mastery in all skills in Algebra I: Graphing and analyzing linear functions`,
        },
        "topic_exercise_st2s3FGaM9_CDZZFCq1BvO8SPXzr8HZi-Je63cKP": {
            description: t`Algebra I: Graphing and analyzing linear functions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra I: Graphing and analyzing linear functions (old)`,
        },
        topic_exercise_x4c62c47c5813dbcb_mastery: {
            description: t`Algebra I: Inequalities (systems & graphs)`,
            extendedDescription: t`Achieve mastery in all skills in Algebra I: Inequalities (systems & graphs)`,
        },
        topic_exercise_x4c62c47c5813dbcb: {
            description: t`Algebra I: Inequalities (systems & graphs) (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra I: Inequalities (systems & graphs) (old)`,
        },
        topic_exercise_xb1630cb98ec4bae2_mastery: {
            description: t`Algebra I: Irrational numbers`,
            extendedDescription: t`Achieve mastery in all skills in Algebra I: Irrational numbers`,
        },
        topic_exercise_xb1630cb98ec4bae2: {
            description: t`Algebra I: Irrational numbers (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra I: Irrational numbers (old)`,
        },
        topic_exercise_xc3c3020c46550ed6_mastery: {
            description: t`Algebra I: Linear equations & graphs`,
            extendedDescription: t`Achieve mastery in all skills in Algebra I: Linear equations & graphs`,
        },
        topic_exercise_xc3c3020c46550ed6: {
            description: t`Algebra I: Linear equations & graphs (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra I: Linear equations & graphs (old)`,
        },
        topic_exercise_x49307dd1_mastery: {
            description: t`Algebra I: Miscellaneous`,
            extendedDescription: t`Achieve mastery in all skills in Algebra I: Miscellaneous`,
        },
        topic_exercise_x49307dd1: {
            description: t`Algebra I: Miscellaneous (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra I: Miscellaneous (old)`,
        },
        topic_exercise_None_mastery: {
            description: t`Algebra I: Multiplying and factoring expressions`,
            extendedDescription: t`Achieve mastery in all skills in Algebra I: Multiplying and factoring expressions`,
        },
        topic_exercise_x3686c281_mastery: {
            description: t`Algebra I: Multiplying and factoring expressions`,
            extendedDescription: t`Achieve mastery in all skills in Algebra I: Multiplying and factoring expressions`,
        },
        topic_exercise_None: {
            description: t`Algebra I: Multiplying and factoring expressions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra I: Multiplying and factoring expressions (old)`,
        },
        topic_exercise_x3686c281: {
            description: t`Algebra I: Multiplying and factoring expressions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra I: Multiplying and factoring expressions (old)`,
        },
        topic_exercise_x6dc707ed_mastery: {
            description: t`Algebra I: Old content`,
            extendedDescription: t`Achieve mastery in all skills in Algebra I: Old content`,
        },
        topic_exercise_x6dc707ed: {
            description: t`Algebra I: Old content (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra I: Old content (old)`,
        },
        topic_exercise_xb7469257365b8042_mastery: {
            description: t`Algebra I: Quadratic functions & equations`,
            extendedDescription: t`Achieve mastery in all skills in Algebra I: Quadratic functions & equations`,
        },
        topic_exercise_xb7469257365b8042: {
            description: t`Algebra I: Quadratic functions & equations (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra I: Quadratic functions & equations (old)`,
        },
        topic_exercise_x74fe17fcb435bd8c_mastery: {
            description: t`Algebra I: Quadratics: Multiplying & factoring`,
            extendedDescription: t`Achieve mastery in all skills in Algebra I: Quadratics: Multiplying & factoring`,
        },
        topic_exercise_x74fe17fcb435bd8c: {
            description: t`Algebra I: Quadratics: Multiplying & factoring (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra I: Quadratics: Multiplying & factoring (old)`,
        },
        topic_exercise_x2f8e8a53_mastery: {
            description: t`Algebra I: Seeing structure in expressions`,
            extendedDescription: t`Achieve mastery in all skills in Algebra I: Seeing structure in expressions`,
        },
        topic_exercise_x2f8e8a53: {
            description: t`Algebra I: Seeing structure in expressions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra I: Seeing structure in expressions (old)`,
        },
        topic_exercise_xb87efe63dee477ea_mastery: {
            description: t`Algebra I: Sequences`,
            extendedDescription: t`Achieve mastery in all skills in Algebra I: Sequences`,
        },
        topic_exercise_xb87efe63dee477ea: {
            description: t`Algebra I: Sequences (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra I: Sequences (old)`,
        },
        topic_exercise_xe7dfb15f5edad6c9_mastery: {
            description: t`Algebra I: Solving equations & inequalities`,
            extendedDescription: t`Achieve mastery in all skills in Algebra I: Solving equations & inequalities`,
        },
        topic_exercise_xe7dfb15f5edad6c9: {
            description: t`Algebra I: Solving equations & inequalities (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra I: Solving equations & inequalities (old)`,
        },
        topic_exercise_xa68ae1e712a48d18_mastery: {
            description: t`Algebra I: Systems of equations`,
            extendedDescription: t`Achieve mastery in all skills in Algebra I: Systems of equations`,
        },
        topic_exercise_xa68ae1e712a48d18: {
            description: t`Algebra I: Systems of equations (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra I: Systems of equations (old)`,
        },
        topic_exercise_xac480a0beb464c1b_mastery: {
            description: t`Algebra I: Working with units`,
            extendedDescription: t`Achieve mastery in all skills in Algebra I: Working with units`,
        },
        topic_exercise_xac480a0beb464c1b: {
            description: t`Algebra I: Working with units (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra I: Working with units (old)`,
        },
        topic_exercise_zfwxjShmJ1KJaukMHfnhtDiqU2b5y4K8l1Fywbi0_mastery: {
            description: t`Algebra II (2018 edition): Advanced equations & functions`,
            extendedDescription: t`Achieve mastery in all skills in Algebra II (2018 edition): Advanced equations & functions`,
        },
        topic_exercise_zfwxjShmJ1KJaukMHfnhtDiqU2b5y4K8l1Fywbi0: {
            description: t`Algebra II (2018 edition): Advanced equations & functions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra II (2018 edition): Advanced equations & functions (old)`,
        },
        topic_exercise_x69101e89_mastery: {
            description: t`Algebra II (2018 edition): Arithmetic with polynomials`,
            extendedDescription: t`Achieve mastery in all skills in Algebra II (2018 edition): Arithmetic with polynomials`,
        },
        topic_exercise_x69101e89: {
            description: t`Algebra II (2018 edition): Arithmetic with polynomials (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra II (2018 edition): Arithmetic with polynomials (old)`,
        },
        topic_exercise_xf380b814_mastery: {
            description: t`Algebra II (2018 edition): Complex numbers`,
            extendedDescription: t`Achieve mastery in all skills in Algebra II (2018 edition): Complex numbers`,
        },
        topic_exercise_xf380b814: {
            description: t`Algebra II (2018 edition): Complex numbers (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra II (2018 edition): Complex numbers (old)`,
        },
        topic_exercise_x42a0b23e_mastery: {
            description: t`Algebra II (2018 edition): Conic sections`,
            extendedDescription: t`Achieve mastery in all skills in Algebra II (2018 edition): Conic sections`,
        },
        topic_exercise_x42a0b23e: {
            description: t`Algebra II (2018 edition): Conic sections (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra II (2018 edition): Conic sections (old)`,
        },
        topic_exercise_HLMBLydsb6znJ3qqeNifVoW73vY2Jxn9MI7mJi1D_mastery: {
            description: t`Algebra II (2018 edition): Exponential growth & decay`,
            extendedDescription: t`Achieve mastery in all skills in Algebra II (2018 edition): Exponential growth & decay`,
        },
        topic_exercise_HLMBLydsb6znJ3qqeNifVoW73vY2Jxn9MI7mJi1D: {
            description: t`Algebra II (2018 edition): Exponential growth & decay (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra II (2018 edition): Exponential growth & decay (old)`,
        },
        "topic_exercise_4S2_H5HJSWRSu08x9powqth-OIb7qFUYqHHVSjyf_mastery": {
            description: t`Algebra II (2018 edition): Exponentials & logarithms`,
            extendedDescription: t`Achieve mastery in all skills in Algebra II (2018 edition): Exponentials & logarithms`,
        },
        "topic_exercise_4S2_H5HJSWRSu08x9powqth-OIb7qFUYqHHVSjyf": {
            description: t`Algebra II (2018 edition): Exponentials & logarithms (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra II (2018 edition): Exponentials & logarithms (old)`,
        },
        topic_exercise_xacce91de_mastery: {
            description: t`Algebra II (2018 edition): Functions`,
            extendedDescription: t`Achieve mastery in all skills in Algebra II (2018 edition): Functions`,
        },
        topic_exercise_xacce91de: {
            description: t`Algebra II (2018 edition): Functions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra II (2018 edition): Functions (old)`,
        },
        topic_exercise_x437fb58e_mastery: {
            description: t`Algebra II (2018 edition): Modeling`,
            extendedDescription: t`Achieve mastery in all skills in Algebra II (2018 edition): Modeling`,
        },
        topic_exercise_x437fb58e: {
            description: t`Algebra II (2018 edition): Modeling (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra II (2018 edition): Modeling (old)`,
        },
        topic_exercise_81hddm8ROeOZSH8F0D7vuQ3IVZrOx_vVZN1zq91k_mastery: {
            description: t`Algebra II (2018 edition): Polynomials`,
            extendedDescription: t`Achieve mastery in all skills in Algebra II (2018 edition): Polynomials`,
        },
        topic_exercise_81hddm8ROeOZSH8F0D7vuQ3IVZrOx_vVZN1zq91k: {
            description: t`Algebra II (2018 edition): Polynomials (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra II (2018 edition): Polynomials (old)`,
        },
        topic_exercise_x72b496f3_mastery: {
            description: t`Algebra II (2018 edition): Radical relationships`,
            extendedDescription: t`Achieve mastery in all skills in Algebra II (2018 edition): Radical relationships`,
        },
        topic_exercise_x72b496f3: {
            description: t`Algebra II (2018 edition): Radical relationships (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra II (2018 edition): Radical relationships (old)`,
        },
        "topic_exercise_N9I-7BvTgT6yidXG6MAr_bMhnKc2R6K-Xs14UWcP_mastery": {
            description: t`Algebra II (2018 edition): Rational relationships`,
            extendedDescription: t`Achieve mastery in all skills in Algebra II (2018 edition): Rational relationships`,
        },
        "topic_exercise_N9I-7BvTgT6yidXG6MAr_bMhnKc2R6K-Xs14UWcP": {
            description: t`Algebra II (2018 edition): Rational relationships (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra II (2018 edition): Rational relationships (old)`,
        },
        topic_exercise_x3ed1e1c3_mastery: {
            description: t`Algebra II (2018 edition): Series`,
            extendedDescription: t`Achieve mastery in all skills in Algebra II (2018 edition): Series`,
        },
        topic_exercise_x3ed1e1c3: {
            description: t`Algebra II (2018 edition): Series (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra II (2018 edition): Series (old)`,
        },
        topic_exercise_x2632705d_mastery: {
            description: t`Algebra II (2018 edition): Trigonometry`,
            extendedDescription: t`Achieve mastery in all skills in Algebra II (2018 edition): Trigonometry`,
        },
        topic_exercise_x2632705d: {
            description: t`Algebra II (2018 edition): Trigonometry (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra II (2018 edition): Trigonometry (old)`,
        },
        topic_exercise_x547e7af3_mastery: {
            description: t`Algebra II: Advanced equations and inequalities`,
            extendedDescription: t`Achieve mastery in all skills in Algebra II: Advanced equations and inequalities`,
        },
        topic_exercise_x547e7af3: {
            description: t`Algebra II: Advanced equations and inequalities (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra II: Advanced equations and inequalities (old)`,
        },
        topic_exercise_xdaca582eeb00c1eb_mastery: {
            description: t`Algebra II: Complex numbers`,
            extendedDescription: t`Achieve mastery in all skills in Algebra II: Complex numbers`,
        },
        topic_exercise_xdaca582eeb00c1eb: {
            description: t`Algebra II: Complex numbers (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra II: Complex numbers (old)`,
        },
        "topic_exercise_MsJQdpiM4Ij3-2PvUiVSQtTe9VfTHCD-l1Yx75Ut_mastery": {
            description: t`Algebra II: Conic sections`,
            extendedDescription: t`Achieve mastery in all skills in Algebra II: Conic sections`,
        },
        "topic_exercise_MsJQdpiM4Ij3-2PvUiVSQtTe9VfTHCD-l1Yx75Ut": {
            description: t`Algebra II: Conic sections (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra II: Conic sections (old)`,
        },
        topic_exercise_x0fc738fa9166acfa_mastery: {
            description: t`Algebra II: Equations`,
            extendedDescription: t`Achieve mastery in all skills in Algebra II: Equations`,
        },
        topic_exercise_x0fc738fa9166acfa: {
            description: t`Algebra II: Equations (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra II: Equations (old)`,
        },
        topic_exercise_x0c845901f30a6647_mastery: {
            description: t`Algebra II: Exponential models`,
            extendedDescription: t`Achieve mastery in all skills in Algebra II: Exponential models`,
        },
        topic_exercise_x0c845901f30a6647: {
            description: t`Algebra II: Exponential models (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra II: Exponential models (old)`,
        },
        topic_exercise_ZVIej4hwFhqA9Ts9_TrTr6h8LpvrF_FRWfWYADfl_mastery: {
            description: t`Algebra II: Graphing lines`,
            extendedDescription: t`Achieve mastery in all skills in Algebra II: Graphing lines`,
        },
        topic_exercise_ZVIej4hwFhqA9Ts9_TrTr6h8LpvrF_FRWfWYADfl: {
            description: t`Algebra II: Graphing lines (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra II: Graphing lines (old)`,
        },
        topic_exercise_x8b9f8cb2c51b39b3_mastery: {
            description: t`Algebra II: Logarithms`,
            extendedDescription: t`Achieve mastery in all skills in Algebra II: Logarithms`,
        },
        topic_exercise_x8b9f8cb2c51b39b3: {
            description: t`Algebra II: Logarithms (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra II: Logarithms (old)`,
        },
        topic_exercise_x67944405_mastery: {
            description: t`Algebra II: Matrices`,
            extendedDescription: t`Achieve mastery in all skills in Algebra II: Matrices`,
        },
        topic_exercise_x67944405: {
            description: t`Algebra II: Matrices (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra II: Matrices (old)`,
        },
        topic_exercise_xfaa3a3d8_mastery: {
            description: t`Algebra II: Miscellaneous`,
            extendedDescription: t`Achieve mastery in all skills in Algebra II: Miscellaneous`,
        },
        topic_exercise_xfaa3a3d8: {
            description: t`Algebra II: Miscellaneous (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra II: Miscellaneous (old)`,
        },
        topic_exercise_x73663255d45f4fbe_mastery: {
            description: t`Algebra II: Modeling`,
            extendedDescription: t`Achieve mastery in all skills in Algebra II: Modeling`,
        },
        topic_exercise_x73663255d45f4fbe: {
            description: t`Algebra II: Modeling (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra II: Modeling (old)`,
        },
        topic_exercise_xf59d482b_mastery: {
            description: t`Algebra II: Old content`,
            extendedDescription: t`Achieve mastery in all skills in Algebra II: Old content`,
        },
        topic_exercise_xf59d482b: {
            description: t`Algebra II: Old content (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra II: Old content (old)`,
        },
        topic_exercise_xbc1ac6a3b5dc07bc_mastery: {
            description: t`Algebra II: Polynomial arithmetic`,
            extendedDescription: t`Achieve mastery in all skills in Algebra II: Polynomial arithmetic`,
        },
        topic_exercise_xbc1ac6a3b5dc07bc: {
            description: t`Algebra II: Polynomial arithmetic (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra II: Polynomial arithmetic (old)`,
        },
        topic_exercise_xa050f0299770c96c_mastery: {
            description: t`Algebra II: Polynomial division`,
            extendedDescription: t`Achieve mastery in all skills in Algebra II: Polynomial division`,
        },
        topic_exercise_xa050f0299770c96c: {
            description: t`Algebra II: Polynomial division (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra II: Polynomial division (old)`,
        },
        topic_exercise_x314ac65fc1757b57_mastery: {
            description: t`Algebra II: Polynomial factorization`,
            extendedDescription: t`Achieve mastery in all skills in Algebra II: Polynomial factorization`,
        },
        topic_exercise_x314ac65fc1757b57: {
            description: t`Algebra II: Polynomial factorization (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra II: Polynomial factorization (old)`,
        },
        topic_exercise_x835a28c20041d5ae_mastery: {
            description: t`Algebra II: Polynomial graphs`,
            extendedDescription: t`Achieve mastery in all skills in Algebra II: Polynomial graphs`,
        },
        topic_exercise_x835a28c20041d5ae: {
            description: t`Algebra II: Polynomial graphs (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra II: Polynomial graphs (old)`,
        },
        topic_exercise_xd967cd7277c855c9_mastery: {
            description: t`Algebra II: Rational exponents and radicals`,
            extendedDescription: t`Achieve mastery in all skills in Algebra II: Rational exponents and radicals`,
        },
        topic_exercise_xd967cd7277c855c9: {
            description: t`Algebra II: Rational exponents and radicals (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra II: Rational exponents and radicals (old)`,
        },
        topic_exercise_x1b0d86655588216f_mastery: {
            description: t`Algebra II: Rational functions`,
            extendedDescription: t`Achieve mastery in all skills in Algebra II: Rational functions`,
        },
        topic_exercise_x1b0d86655588216f: {
            description: t`Algebra II: Rational functions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra II: Rational functions (old)`,
        },
        "topic_exercise_UBxQ9EtBXBqYiJr5UfUd1hC-64cgRqsZV8TfWhdN_mastery": {
            description: t`Algebra II: Systems of equations and inequalities`,
            extendedDescription: t`Achieve mastery in all skills in Algebra II: Systems of equations and inequalities`,
        },
        "topic_exercise_UBxQ9EtBXBqYiJr5UfUd1hC-64cgRqsZV8TfWhdN": {
            description: t`Algebra II: Systems of equations and inequalities (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra II: Systems of equations and inequalities (old)`,
        },
        topic_exercise_xb0d69a1fe3040ad2_mastery: {
            description: t`Algebra II: Transformations of functions`,
            extendedDescription: t`Achieve mastery in all skills in Algebra II: Transformations of functions`,
        },
        topic_exercise_xb0d69a1fe3040ad2: {
            description: t`Algebra II: Transformations of functions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra II: Transformations of functions (old)`,
        },
        topic_exercise_x2f2d4cfb7bc655d8_mastery: {
            description: t`Algebra II: Trigonometry`,
            extendedDescription: t`Achieve mastery in all skills in Algebra II: Trigonometry`,
        },
        topic_exercise_x2f2d4cfb7bc655d8: {
            description: t`Algebra II: Trigonometry (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra II: Trigonometry (old)`,
        },
        topic_exercise_KwnHF4txdhqHOdS868IJJuOdEkhn0CeYJxtMAyuu_mastery: {
            description: t`Algebra: Conic sections`,
            extendedDescription: t`Achieve mastery in all skills in Algebra: Conic sections`,
        },
        topic_exercise_KwnHF4txdhqHOdS868IJJuOdEkhn0CeYJxtMAyuu: {
            description: t`Algebra: Conic sections (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra: Conic sections (old)`,
        },
        "topic_exercise_iYzaSYnmicOVqDRgZ3-F6uu7_YRWkGarVgmzfjlP_mastery": {
            description: t`Algebra: Imaginary and complex numbers`,
            extendedDescription: t`Achieve mastery in all skills in Algebra: Imaginary and complex numbers`,
        },
        "topic_exercise_iYzaSYnmicOVqDRgZ3-F6uu7_YRWkGarVgmzfjlP": {
            description: t`Algebra: Imaginary and complex numbers (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Algebra: Imaginary and complex numbers (old)`,
        },
        topic_exercise_zLUoyCRdhg6AGMXI0nbaivw4kCDcw5idgn5TQmn2_mastery: {
            description: t`Angles`,
            extendedDescription: t`Achieve mastery in all skills in Angles`,
        },
        topic_exercise_zLUoyCRdhg6AGMXI0nbaivw4kCDcw5idgn5TQmn2: {
            description: t`Angles (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Angles (old)`,
        },
        topic_exercise_x6ddff038_mastery: {
            description: t`Angles and intersecting lines`,
            extendedDescription: t`Achieve mastery in all skills in Angles and intersecting lines`,
        },
        topic_exercise_x6ddff038: {
            description: t`Angles and intersecting lines (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Angles and intersecting lines (old)`,
        },
        topic_exercise_xb4b4c2fa_mastery: {
            description: t`AP Calculus AB: Advanced differentiation`,
            extendedDescription: t`Achieve mastery in all skills in AP Calculus AB: Advanced differentiation`,
        },
        topic_exercise_xb4b4c2fa: {
            description: t`AP Calculus AB: Advanced differentiation (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP Calculus AB: Advanced differentiation (old)`,
        },
        topic_exercise_xfa70e88f_mastery: {
            description: t`AP Calculus AB: Analyzing functions with calculus`,
            extendedDescription: t`Achieve mastery in all skills in AP Calculus AB: Analyzing functions with calculus`,
        },
        topic_exercise_xfa70e88f: {
            description: t`AP Calculus AB: Analyzing functions with calculus (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP Calculus AB: Analyzing functions with calculus (old)`,
        },
        topic_exercise_x848380de_mastery: {
            description: t`AP Calculus AB: Area & arc length using calculus`,
            extendedDescription: t`Achieve mastery in all skills in AP Calculus AB: Area & arc length using calculus`,
        },
        topic_exercise_x848380de: {
            description: t`AP Calculus AB: Area & arc length using calculus (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP Calculus AB: Area & arc length using calculus (old)`,
        },
        topic_exercise_x856b5234_mastery: {
            description: t`AP Calculus AB: Basic differentiation`,
            extendedDescription: t`Achieve mastery in all skills in AP Calculus AB: Basic differentiation`,
        },
        topic_exercise_x856b5234: {
            description: t`AP Calculus AB: Basic differentiation (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP Calculus AB: Basic differentiation (old)`,
        },
        topic_exercise_x2302aafd_mastery: {
            description: t`AP Calculus AB: Continuity`,
            extendedDescription: t`Achieve mastery in all skills in AP Calculus AB: Continuity`,
        },
        topic_exercise_x2302aafd: {
            description: t`AP Calculus AB: Continuity (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP Calculus AB: Continuity (old)`,
        },
        topic_exercise_x97c977b4_mastery: {
            description: t`AP Calculus AB: Definite integral evaluation`,
            extendedDescription: t`Achieve mastery in all skills in AP Calculus AB: Definite integral evaluation`,
        },
        topic_exercise_x97c977b4: {
            description: t`AP Calculus AB: Definite integral evaluation (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP Calculus AB: Definite integral evaluation (old)`,
        },
        topic_exercise_x3f6287fa_mastery: {
            description: t`AP Calculus AB: Definite integrals introduction`,
            extendedDescription: t`Achieve mastery in all skills in AP Calculus AB: Definite integrals introduction`,
        },
        topic_exercise_x3f6287fa: {
            description: t`AP Calculus AB: Definite integrals introduction (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP Calculus AB: Definite integrals introduction (old)`,
        },
        topic_exercise_xe97d2562_mastery: {
            description: t`AP Calculus AB: Derivative applications`,
            extendedDescription: t`Achieve mastery in all skills in AP Calculus AB: Derivative applications`,
        },
        topic_exercise_xe97d2562: {
            description: t`AP Calculus AB: Derivative applications (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP Calculus AB: Derivative applications (old)`,
        },
        topic_exercise_x51f8ea83_mastery: {
            description: t`AP Calculus AB: Derivative introduction`,
            extendedDescription: t`Achieve mastery in all skills in AP Calculus AB: Derivative introduction`,
        },
        topic_exercise_x51f8ea83: {
            description: t`AP Calculus AB: Derivative introduction (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP Calculus AB: Derivative introduction (old)`,
        },
        topic_exercise_xa7a03a6d_mastery: {
            description: t`AP Calculus AB: Differential equations`,
            extendedDescription: t`Achieve mastery in all skills in AP Calculus AB: Differential equations`,
        },
        topic_exercise_xa7a03a6d: {
            description: t`AP Calculus AB: Differential equations (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP Calculus AB: Differential equations (old)`,
        },
        topic_exercise_xf48853cf_mastery: {
            description: t`AP Calculus AB: Differentiating common functions`,
            extendedDescription: t`Achieve mastery in all skills in AP Calculus AB: Differentiating common functions`,
        },
        topic_exercise_xf48853cf: {
            description: t`AP Calculus AB: Differentiating common functions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP Calculus AB: Differentiating common functions (old)`,
        },
        topic_exercise_xc87e4d40_mastery: {
            description: t`AP Calculus AB: Fundamental theorem of calculus`,
            extendedDescription: t`Achieve mastery in all skills in AP Calculus AB: Fundamental theorem of calculus`,
        },
        topic_exercise_xc87e4d40: {
            description: t`AP Calculus AB: Fundamental theorem of calculus (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP Calculus AB: Fundamental theorem of calculus (old)`,
        },
        topic_exercise_x2df2c1b6_mastery: {
            description: t`AP Calculus AB: Indefinite integrals`,
            extendedDescription: t`Achieve mastery in all skills in AP Calculus AB: Indefinite integrals`,
        },
        topic_exercise_x2df2c1b6: {
            description: t`AP Calculus AB: Indefinite integrals (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP Calculus AB: Indefinite integrals (old)`,
        },
        topic_exercise_xd79c7aee_mastery: {
            description: t`AP Calculus AB: Infinite limits`,
            extendedDescription: t`Achieve mastery in all skills in AP Calculus AB: Infinite limits`,
        },
        topic_exercise_xd79c7aee: {
            description: t`AP Calculus AB: Infinite limits (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP Calculus AB: Infinite limits (old)`,
        },
        topic_exercise_xc9f27401_mastery: {
            description: t`AP Calculus AB: Integration applications`,
            extendedDescription: t`Achieve mastery in all skills in AP Calculus AB: Integration applications`,
        },
        topic_exercise_xc9f27401: {
            description: t`AP Calculus AB: Integration applications (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP Calculus AB: Integration applications (old)`,
        },
        topic_exercise_xf246e330_mastery: {
            description: t`AP Calculus AB: Integration techniques`,
            extendedDescription: t`Achieve mastery in all skills in AP Calculus AB: Integration techniques`,
        },
        topic_exercise_xf246e330: {
            description: t`AP Calculus AB: Integration techniques (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP Calculus AB: Integration techniques (old)`,
        },
        topic_exercise_xd6674733_mastery: {
            description: t`AP Calculus AB: Limits basics`,
            extendedDescription: t`Achieve mastery in all skills in AP Calculus AB: Limits basics`,
        },
        topic_exercise_xd6674733: {
            description: t`AP Calculus AB: Limits basics (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP Calculus AB: Limits basics (old)`,
        },
        topic_exercise_x0dd8e952_mastery: {
            description: t`AP Calculus AB: Limits from equations`,
            extendedDescription: t`Achieve mastery in all skills in AP Calculus AB: Limits from equations`,
        },
        topic_exercise_x0dd8e952: {
            description: t`AP Calculus AB: Limits from equations (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP Calculus AB: Limits from equations (old)`,
        },
        topic_exercise_x7d61367a_mastery: {
            description: t`AP Calculus AB: Product, quotient, & chain rules`,
            extendedDescription: t`Achieve mastery in all skills in AP Calculus AB: Product, quotient, & chain rules`,
        },
        topic_exercise_x7d61367a: {
            description: t`AP Calculus AB: Product, quotient, & chain rules (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP Calculus AB: Product, quotient, & chain rules (old)`,
        },
        topic_exercise_x42e64e4f_mastery: {
            description: t`AP Calculus AB: Riemann sums`,
            extendedDescription: t`Achieve mastery in all skills in AP Calculus AB: Riemann sums`,
        },
        topic_exercise_x42e64e4f: {
            description: t`AP Calculus AB: Riemann sums (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP Calculus AB: Riemann sums (old)`,
        },
        topic_exercise_x14bd1b9a_mastery: {
            description: t`AP Calculus AB: Volume using calculus`,
            extendedDescription: t`Achieve mastery in all skills in AP Calculus AB: Volume using calculus`,
        },
        topic_exercise_x14bd1b9a: {
            description: t`AP Calculus AB: Volume using calculus (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP Calculus AB: Volume using calculus (old)`,
        },
        topic_exercise_xd466a72b_mastery: {
            description: t`AP Calculus BC: Advanced differentiation`,
            extendedDescription: t`Achieve mastery in all skills in AP Calculus BC: Advanced differentiation`,
        },
        topic_exercise_xd466a72b: {
            description: t`AP Calculus BC: Advanced differentiation (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP Calculus BC: Advanced differentiation (old)`,
        },
        topic_exercise_xa652c8ac_mastery: {
            description: t`AP Calculus BC: Analyzing functions with calculus`,
            extendedDescription: t`Achieve mastery in all skills in AP Calculus BC: Analyzing functions with calculus`,
        },
        topic_exercise_xa652c8ac: {
            description: t`AP Calculus BC: Analyzing functions with calculus (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP Calculus BC: Analyzing functions with calculus (old)`,
        },
        topic_exercise_x317465a3_mastery: {
            description: t`AP Calculus BC: Area & arc length using calculus`,
            extendedDescription: t`Achieve mastery in all skills in AP Calculus BC: Area & arc length using calculus`,
        },
        topic_exercise_x317465a3: {
            description: t`AP Calculus BC: Area & arc length using calculus (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP Calculus BC: Area & arc length using calculus (old)`,
        },
        topic_exercise_xa06d9013_mastery: {
            description: t`AP Calculus BC: Basic differentiation`,
            extendedDescription: t`Achieve mastery in all skills in AP Calculus BC: Basic differentiation`,
        },
        topic_exercise_xa06d9013: {
            description: t`AP Calculus BC: Basic differentiation (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP Calculus BC: Basic differentiation (old)`,
        },
        topic_exercise_x95df4a82_mastery: {
            description: t`AP Calculus BC: Continuity`,
            extendedDescription: t`Achieve mastery in all skills in AP Calculus BC: Continuity`,
        },
        topic_exercise_x95df4a82: {
            description: t`AP Calculus BC: Continuity (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP Calculus BC: Continuity (old)`,
        },
        topic_exercise_xafb67134_mastery: {
            description: t`AP Calculus BC: Definite integral evaluation`,
            extendedDescription: t`Achieve mastery in all skills in AP Calculus BC: Definite integral evaluation`,
        },
        topic_exercise_xafb67134: {
            description: t`AP Calculus BC: Definite integral evaluation (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP Calculus BC: Definite integral evaluation (old)`,
        },
        topic_exercise_x4f60c4cf_mastery: {
            description: t`AP Calculus BC: Definite integrals introduction`,
            extendedDescription: t`Achieve mastery in all skills in AP Calculus BC: Definite integrals introduction`,
        },
        topic_exercise_x4f60c4cf: {
            description: t`AP Calculus BC: Definite integrals introduction (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP Calculus BC: Definite integrals introduction (old)`,
        },
        topic_exercise_xabae1ae4_mastery: {
            description: t`AP Calculus BC: Derivative applications`,
            extendedDescription: t`Achieve mastery in all skills in AP Calculus BC: Derivative applications`,
        },
        topic_exercise_xabae1ae4: {
            description: t`AP Calculus BC: Derivative applications (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP Calculus BC: Derivative applications (old)`,
        },
        topic_exercise_x5f60c8ad_mastery: {
            description: t`AP Calculus BC: Derivative introduction`,
            extendedDescription: t`Achieve mastery in all skills in AP Calculus BC: Derivative introduction`,
        },
        topic_exercise_x5f60c8ad: {
            description: t`AP Calculus BC: Derivative introduction (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP Calculus BC: Derivative introduction (old)`,
        },
        topic_exercise_x14b879eb_mastery: {
            description: t`AP Calculus BC: Differential equations`,
            extendedDescription: t`Achieve mastery in all skills in AP Calculus BC: Differential equations`,
        },
        topic_exercise_x14b879eb: {
            description: t`AP Calculus BC: Differential equations (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP Calculus BC: Differential equations (old)`,
        },
        topic_exercise_x78ae34d2_mastery: {
            description: t`AP Calculus BC: Differentiating common functions`,
            extendedDescription: t`Achieve mastery in all skills in AP Calculus BC: Differentiating common functions`,
        },
        topic_exercise_x78ae34d2: {
            description: t`AP Calculus BC: Differentiating common functions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP Calculus BC: Differentiating common functions (old)`,
        },
        topic_exercise_x793037d5_mastery: {
            description: t`AP Calculus BC: Fundamental theorem of calculus`,
            extendedDescription: t`Achieve mastery in all skills in AP Calculus BC: Fundamental theorem of calculus`,
        },
        topic_exercise_x793037d5: {
            description: t`AP Calculus BC: Fundamental theorem of calculus (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP Calculus BC: Fundamental theorem of calculus (old)`,
        },
        topic_exercise_xdb01d6b9_mastery: {
            description: t`AP Calculus BC: Indefinite integrals`,
            extendedDescription: t`Achieve mastery in all skills in AP Calculus BC: Indefinite integrals`,
        },
        topic_exercise_xdb01d6b9: {
            description: t`AP Calculus BC: Indefinite integrals (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP Calculus BC: Indefinite integrals (old)`,
        },
        topic_exercise_x155ca370_mastery: {
            description: t`AP Calculus BC: Infinite limits`,
            extendedDescription: t`Achieve mastery in all skills in AP Calculus BC: Infinite limits`,
        },
        topic_exercise_x155ca370: {
            description: t`AP Calculus BC: Infinite limits (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP Calculus BC: Infinite limits (old)`,
        },
        topic_exercise_xe7aa2764_mastery: {
            description: t`AP Calculus BC: Integration applications`,
            extendedDescription: t`Achieve mastery in all skills in AP Calculus BC: Integration applications`,
        },
        topic_exercise_xe7aa2764: {
            description: t`AP Calculus BC: Integration applications (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP Calculus BC: Integration applications (old)`,
        },
        topic_exercise_x441eb506_mastery: {
            description: t`AP Calculus BC: Integration techniques`,
            extendedDescription: t`Achieve mastery in all skills in AP Calculus BC: Integration techniques`,
        },
        topic_exercise_x441eb506: {
            description: t`AP Calculus BC: Integration techniques (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP Calculus BC: Integration techniques (old)`,
        },
        topic_exercise_x19e3c2b5_mastery: {
            description: t`AP Calculus BC: Limits basics`,
            extendedDescription: t`Achieve mastery in all skills in AP Calculus BC: Limits basics`,
        },
        topic_exercise_x19e3c2b5: {
            description: t`AP Calculus BC: Limits basics (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP Calculus BC: Limits basics (old)`,
        },
        topic_exercise_x2a1449c4_mastery: {
            description: t`AP Calculus BC: Limits from equations`,
            extendedDescription: t`Achieve mastery in all skills in AP Calculus BC: Limits from equations`,
        },
        topic_exercise_x2a1449c4: {
            description: t`AP Calculus BC: Limits from equations (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP Calculus BC: Limits from equations (old)`,
        },
        topic_exercise_x25868d94_mastery: {
            description: t`AP Calculus BC: Power series`,
            extendedDescription: t`Achieve mastery in all skills in AP Calculus BC: Power series`,
        },
        topic_exercise_x25868d94: {
            description: t`AP Calculus BC: Power series (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP Calculus BC: Power series (old)`,
        },
        topic_exercise_x88eba4c6_mastery: {
            description: t`AP Calculus BC: Product, quotient, & chain rules`,
            extendedDescription: t`Achieve mastery in all skills in AP Calculus BC: Product, quotient, & chain rules`,
        },
        topic_exercise_x88eba4c6: {
            description: t`AP Calculus BC: Product, quotient, & chain rules (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP Calculus BC: Product, quotient, & chain rules (old)`,
        },
        topic_exercise_x94dfd71d_mastery: {
            description: t`AP Calculus BC: Riemann sums`,
            extendedDescription: t`Achieve mastery in all skills in AP Calculus BC: Riemann sums`,
        },
        topic_exercise_x94dfd71d: {
            description: t`AP Calculus BC: Riemann sums (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP Calculus BC: Riemann sums (old)`,
        },
        topic_exercise_x9ffbc3b5_mastery: {
            description: t`AP Calculus BC: Sequences & series intro`,
            extendedDescription: t`Achieve mastery in all skills in AP Calculus BC: Sequences & series intro`,
        },
        topic_exercise_x9ffbc3b5: {
            description: t`AP Calculus BC: Sequences & series intro (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP Calculus BC: Sequences & series intro (old)`,
        },
        topic_exercise_xfd078264237b0d0f_mastery: {
            description: t`AP Calculus BC: Series convergence & estimation`,
            extendedDescription: t`Achieve mastery in all skills in AP Calculus BC: Series convergence & estimation`,
        },
        topic_exercise_xfd078264237b0d0f: {
            description: t`AP Calculus BC: Series convergence & estimation (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP Calculus BC: Series convergence & estimation (old)`,
        },
        topic_exercise_xb660876c_mastery: {
            description: t`AP Calculus BC: Volume using calculus`,
            extendedDescription: t`Achieve mastery in all skills in AP Calculus BC: Volume using calculus`,
        },
        topic_exercise_xb660876c: {
            description: t`AP Calculus BC: Volume using calculus (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP Calculus BC: Volume using calculus (old)`,
        },
        topic_exercise_x40852a4e280a727a_mastery: {
            description: t`AP®︎ Calculus AB: Accumulation and Riemann sums`,
            extendedDescription: t`Achieve mastery in all skills in AP®︎ Calculus AB: Accumulation and Riemann sums`,
        },
        topic_exercise_x40852a4e280a727a: {
            description: t`AP®︎ Calculus AB: Accumulation and Riemann sums (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP®︎ Calculus AB: Accumulation and Riemann sums (old)`,
        },
        topic_exercise_xd181d99d87558859_mastery: {
            description: t`AP®︎ Calculus AB: Advanced derivatives `,
            extendedDescription: t`Achieve mastery in all skills in AP®︎ Calculus AB: Advanced derivatives `,
        },
        topic_exercise_xd181d99d87558859: {
            description: t`AP®︎ Calculus AB: Advanced derivatives  (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP®︎ Calculus AB: Advanced derivatives  (old)`,
        },
        topic_exercise_x329fbeb12600eab3_mastery: {
            description: t`AP®︎ Calculus AB: Antiderivatives and the fundamental theorem of calculus`,
            extendedDescription: t`Achieve mastery in all skills in AP®︎ Calculus AB: Antiderivatives and the fundamental theorem of calculus`,
        },
        topic_exercise_x329fbeb12600eab3: {
            description: t`AP®︎ Calculus AB: Antiderivatives and the fundamental theorem of calculus (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP®︎ Calculus AB: Antiderivatives and the fundamental theorem of calculus (old)`,
        },
        topic_exercise_x296c331807879c60_mastery: {
            description: t`AP®︎ Calculus AB: Applications of definite integrals`,
            extendedDescription: t`Achieve mastery in all skills in AP®︎ Calculus AB: Applications of definite integrals`,
        },
        topic_exercise_x296c331807879c60: {
            description: t`AP®︎ Calculus AB: Applications of definite integrals (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP®︎ Calculus AB: Applications of definite integrals (old)`,
        },
        topic_exercise_x6e9cfc38846841a5_mastery: {
            description: t`AP®︎ Calculus AB: Applications of derivatives`,
            extendedDescription: t`Achieve mastery in all skills in AP®︎ Calculus AB: Applications of derivatives`,
        },
        topic_exercise_x6e9cfc38846841a5: {
            description: t`AP®︎ Calculus AB: Applications of derivatives (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP®︎ Calculus AB: Applications of derivatives (old)`,
        },
        topic_exercise_xb80ad6dc16530012_mastery: {
            description: t`AP®︎ Calculus AB: Applications of integration`,
            extendedDescription: t`Achieve mastery in all skills in AP®︎ Calculus AB: Applications of integration`,
        },
        topic_exercise_xb80ad6dc16530012: {
            description: t`AP®︎ Calculus AB: Applications of integration (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP®︎ Calculus AB: Applications of integration (old)`,
        },
        topic_exercise_xd8ffd65fe7b9701f_mastery: {
            description: t`AP®︎ Calculus AB: Applying derivatives to analyze functions `,
            extendedDescription: t`Achieve mastery in all skills in AP®︎ Calculus AB: Applying derivatives to analyze functions `,
        },
        topic_exercise_xd8ffd65fe7b9701f: {
            description: t`AP®︎ Calculus AB: Applying derivatives to analyze functions  (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP®︎ Calculus AB: Applying derivatives to analyze functions  (old)`,
        },
        topic_exercise_x90c04f514dafe6d8_mastery: {
            description: t`AP®︎ Calculus AB: Contextual applications of differentiation`,
            extendedDescription: t`Achieve mastery in all skills in AP®︎ Calculus AB: Contextual applications of differentiation`,
        },
        topic_exercise_x90c04f514dafe6d8: {
            description: t`AP®︎ Calculus AB: Contextual applications of differentiation (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP®︎ Calculus AB: Contextual applications of differentiation (old)`,
        },
        topic_exercise_x0dda522287c0aad5_mastery: {
            description: t`AP®︎ Calculus AB: Derivative rules`,
            extendedDescription: t`Achieve mastery in all skills in AP®︎ Calculus AB: Derivative rules`,
        },
        topic_exercise_x0dda522287c0aad5: {
            description: t`AP®︎ Calculus AB: Derivative rules (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP®︎ Calculus AB: Derivative rules (old)`,
        },
        topic_exercise_x803bdf2a0453c9d4_mastery: {
            description: t`AP®︎ Calculus AB: Derivatives introduction`,
            extendedDescription: t`Achieve mastery in all skills in AP®︎ Calculus AB: Derivatives introduction`,
        },
        topic_exercise_x803bdf2a0453c9d4: {
            description: t`AP®︎ Calculus AB: Derivatives introduction (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP®︎ Calculus AB: Derivatives introduction (old)`,
        },
        topic_exercise_x54560de3b6b9153b_mastery: {
            description: t`AP®︎ Calculus AB: Differential equations`,
            extendedDescription: t`Achieve mastery in all skills in AP®︎ Calculus AB: Differential equations`,
        },
        topic_exercise_xf7faa64f661a9e62_mastery: {
            description: t`AP®︎ Calculus AB: Differential equations`,
            extendedDescription: t`Achieve mastery in all skills in AP®︎ Calculus AB: Differential equations`,
        },
        topic_exercise_x54560de3b6b9153b: {
            description: t`AP®︎ Calculus AB: Differential equations (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP®︎ Calculus AB: Differential equations (old)`,
        },
        topic_exercise_xf7faa64f661a9e62: {
            description: t`AP®︎ Calculus AB: Differential equations (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP®︎ Calculus AB: Differential equations (old)`,
        },
        topic_exercise_xb1aee696f6974830_mastery: {
            description: t`AP®︎ Calculus AB: Differentiation: composite, implicit, and inverse functions`,
            extendedDescription: t`Achieve mastery in all skills in AP®︎ Calculus AB: Differentiation: composite, implicit, and inverse functions`,
        },
        topic_exercise_xb1aee696f6974830: {
            description: t`AP®︎ Calculus AB: Differentiation: composite, implicit, and inverse functions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP®︎ Calculus AB: Differentiation: composite, implicit, and inverse functions (old)`,
        },
        topic_exercise_x5432c6f7037ffefc_mastery: {
            description: t`AP®︎ Calculus AB: Differentiation: definition and basic derivative rules`,
            extendedDescription: t`Achieve mastery in all skills in AP®︎ Calculus AB: Differentiation: definition and basic derivative rules`,
        },
        topic_exercise_x5432c6f7037ffefc: {
            description: t`AP®︎ Calculus AB: Differentiation: definition and basic derivative rules (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP®︎ Calculus AB: Differentiation: definition and basic derivative rules (old)`,
        },
        topic_exercise_x11c19a12651c9465_mastery: {
            description: t`AP®︎ Calculus AB: Existence theorems`,
            extendedDescription: t`Achieve mastery in all skills in AP®︎ Calculus AB: Existence theorems`,
        },
        topic_exercise_x11c19a12651c9465: {
            description: t`AP®︎ Calculus AB: Existence theorems (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP®︎ Calculus AB: Existence theorems (old)`,
        },
        topic_exercise_x3a79bcb1ef658b56_mastery: {
            description: t`AP®︎ Calculus AB: Integration and accumulation of change`,
            extendedDescription: t`Achieve mastery in all skills in AP®︎ Calculus AB: Integration and accumulation of change`,
        },
        topic_exercise_x3a79bcb1ef658b56: {
            description: t`AP®︎ Calculus AB: Integration and accumulation of change (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP®︎ Calculus AB: Integration and accumulation of change (old)`,
        },
        topic_exercise_x516bfd83e224378b_mastery: {
            description: t`AP®︎ Calculus AB: Limits and continuity`,
            extendedDescription: t`Achieve mastery in all skills in AP®︎ Calculus AB: Limits and continuity`,
        },
        topic_exercise_xb0caa40e7a222a7c_mastery: {
            description: t`AP®︎ Calculus AB: Limits and continuity`,
            extendedDescription: t`Achieve mastery in all skills in AP®︎ Calculus AB: Limits and continuity`,
        },
        topic_exercise_x516bfd83e224378b: {
            description: t`AP®︎ Calculus AB: Limits and continuity (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP®︎ Calculus AB: Limits and continuity (old)`,
        },
        topic_exercise_xb0caa40e7a222a7c: {
            description: t`AP®︎ Calculus AB: Limits and continuity (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP®︎ Calculus AB: Limits and continuity (old)`,
        },
        topic_exercise_x0323be76af6b3445_mastery: {
            description: t`AP®︎ Calculus AB: Using derivatives to analyze functions`,
            extendedDescription: t`Achieve mastery in all skills in AP®︎ Calculus AB: Using derivatives to analyze functions`,
        },
        topic_exercise_x0323be76af6b3445: {
            description: t`AP®︎ Calculus AB: Using derivatives to analyze functions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP®︎ Calculus AB: Using derivatives to analyze functions (old)`,
        },
        topic_exercise_x0d47869c4040d8d6_mastery: {
            description: t`AP®︎ Calculus BC: Accumulation and Riemann sums`,
            extendedDescription: t`Achieve mastery in all skills in AP®︎ Calculus BC: Accumulation and Riemann sums`,
        },
        topic_exercise_x0d47869c4040d8d6: {
            description: t`AP®︎ Calculus BC: Accumulation and Riemann sums (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP®︎ Calculus BC: Accumulation and Riemann sums (old)`,
        },
        topic_exercise_xb72f96bb87e344ec_mastery: {
            description: t`AP®︎ Calculus BC: Advanced derivatives`,
            extendedDescription: t`Achieve mastery in all skills in AP®︎ Calculus BC: Advanced derivatives`,
        },
        topic_exercise_xb72f96bb87e344ec: {
            description: t`AP®︎ Calculus BC: Advanced derivatives (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP®︎ Calculus BC: Advanced derivatives (old)`,
        },
        topic_exercise_x3d30919b0b0955a0_mastery: {
            description: t`AP®︎ Calculus BC: Antiderivatives and the fundamental theorem of calculus`,
            extendedDescription: t`Achieve mastery in all skills in AP®︎ Calculus BC: Antiderivatives and the fundamental theorem of calculus`,
        },
        topic_exercise_x3d30919b0b0955a0: {
            description: t`AP®︎ Calculus BC: Antiderivatives and the fundamental theorem of calculus (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP®︎ Calculus BC: Antiderivatives and the fundamental theorem of calculus (old)`,
        },
        topic_exercise_xe396bf001f78c6d6_mastery: {
            description: t`AP®︎ Calculus BC: Applications of definite integrals`,
            extendedDescription: t`Achieve mastery in all skills in AP®︎ Calculus BC: Applications of definite integrals`,
        },
        topic_exercise_xe396bf001f78c6d6: {
            description: t`AP®︎ Calculus BC: Applications of definite integrals (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP®︎ Calculus BC: Applications of definite integrals (old)`,
        },
        topic_exercise_x77616dba817fd822_mastery: {
            description: t`AP®︎ Calculus BC: Applications of derivatives`,
            extendedDescription: t`Achieve mastery in all skills in AP®︎ Calculus BC: Applications of derivatives`,
        },
        topic_exercise_x77616dba817fd822: {
            description: t`AP®︎ Calculus BC: Applications of derivatives (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP®︎ Calculus BC: Applications of derivatives (old)`,
        },
        topic_exercise_xd9df7243d974cab1_mastery: {
            description: t`AP®︎ Calculus BC: Applications of integration`,
            extendedDescription: t`Achieve mastery in all skills in AP®︎ Calculus BC: Applications of integration`,
        },
        topic_exercise_xd9df7243d974cab1: {
            description: t`AP®︎ Calculus BC: Applications of integration (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP®︎ Calculus BC: Applications of integration (old)`,
        },
        topic_exercise_xa2935ed2b2239713_mastery: {
            description: t`AP®︎ Calculus BC: Applying derivatives to analyze functions `,
            extendedDescription: t`Achieve mastery in all skills in AP®︎ Calculus BC: Applying derivatives to analyze functions `,
        },
        topic_exercise_xa2935ed2b2239713: {
            description: t`AP®︎ Calculus BC: Applying derivatives to analyze functions  (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP®︎ Calculus BC: Applying derivatives to analyze functions  (old)`,
        },
        topic_exercise_x8844b40434e99005_mastery: {
            description: t`AP®︎ Calculus BC: Contextual applications of differentiation`,
            extendedDescription: t`Achieve mastery in all skills in AP®︎ Calculus BC: Contextual applications of differentiation`,
        },
        topic_exercise_x8844b40434e99005: {
            description: t`AP®︎ Calculus BC: Contextual applications of differentiation (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP®︎ Calculus BC: Contextual applications of differentiation (old)`,
        },
        topic_exercise_x95b9124769ac9eeb_mastery: {
            description: t`AP®︎ Calculus BC: Derivative rules`,
            extendedDescription: t`Achieve mastery in all skills in AP®︎ Calculus BC: Derivative rules`,
        },
        topic_exercise_x95b9124769ac9eeb: {
            description: t`AP®︎ Calculus BC: Derivative rules (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP®︎ Calculus BC: Derivative rules (old)`,
        },
        topic_exercise_xc006bba837466d1b_mastery: {
            description: t`AP®︎ Calculus BC: Derivatives introduction`,
            extendedDescription: t`Achieve mastery in all skills in AP®︎ Calculus BC: Derivatives introduction`,
        },
        topic_exercise_xc006bba837466d1b: {
            description: t`AP®︎ Calculus BC: Derivatives introduction (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP®︎ Calculus BC: Derivatives introduction (old)`,
        },
        topic_exercise_x33cb3edf8849db71_mastery: {
            description: t`AP®︎ Calculus BC: Differential equations`,
            extendedDescription: t`Achieve mastery in all skills in AP®︎ Calculus BC: Differential equations`,
        },
        topic_exercise_xc78b954939e9c6f7_mastery: {
            description: t`AP®︎ Calculus BC: Differential equations`,
            extendedDescription: t`Achieve mastery in all skills in AP®︎ Calculus BC: Differential equations`,
        },
        topic_exercise_x33cb3edf8849db71: {
            description: t`AP®︎ Calculus BC: Differential equations (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP®︎ Calculus BC: Differential equations (old)`,
        },
        topic_exercise_xc78b954939e9c6f7: {
            description: t`AP®︎ Calculus BC: Differential equations (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP®︎ Calculus BC: Differential equations (old)`,
        },
        topic_exercise_x7007d02797fdc125_mastery: {
            description: t`AP®︎ Calculus BC: Differentiation: composite, implicit, and inverse functions`,
            extendedDescription: t`Achieve mastery in all skills in AP®︎ Calculus BC: Differentiation: composite, implicit, and inverse functions`,
        },
        topic_exercise_x7007d02797fdc125: {
            description: t`AP®︎ Calculus BC: Differentiation: composite, implicit, and inverse functions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP®︎ Calculus BC: Differentiation: composite, implicit, and inverse functions (old)`,
        },
        topic_exercise_xd4d1aded02058874_mastery: {
            description: t`AP®︎ Calculus BC: Differentiation: definition and basic derivative rules`,
            extendedDescription: t`Achieve mastery in all skills in AP®︎ Calculus BC: Differentiation: definition and basic derivative rules`,
        },
        topic_exercise_xd4d1aded02058874: {
            description: t`AP®︎ Calculus BC: Differentiation: definition and basic derivative rules (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP®︎ Calculus BC: Differentiation: definition and basic derivative rules (old)`,
        },
        topic_exercise_xefac7a0833433b1a_mastery: {
            description: t`AP®︎ Calculus BC: Existence theorems`,
            extendedDescription: t`Achieve mastery in all skills in AP®︎ Calculus BC: Existence theorems`,
        },
        topic_exercise_xefac7a0833433b1a: {
            description: t`AP®︎ Calculus BC: Existence theorems (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP®︎ Calculus BC: Existence theorems (old)`,
        },
        topic_exercise_x5ee2b1ddfb8ed9ef_mastery: {
            description: t`AP®︎ Calculus BC: Infinite sequences and series`,
            extendedDescription: t`Achieve mastery in all skills in AP®︎ Calculus BC: Infinite sequences and series`,
        },
        topic_exercise_x5ee2b1ddfb8ed9ef: {
            description: t`AP®︎ Calculus BC: Infinite sequences and series (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP®︎ Calculus BC: Infinite sequences and series (old)`,
        },
        topic_exercise_x3033588f58805372_mastery: {
            description: t`AP®︎ Calculus BC: Integration and accumulation of change`,
            extendedDescription: t`Achieve mastery in all skills in AP®︎ Calculus BC: Integration and accumulation of change`,
        },
        topic_exercise_x3033588f58805372: {
            description: t`AP®︎ Calculus BC: Integration and accumulation of change (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP®︎ Calculus BC: Integration and accumulation of change (old)`,
        },
        topic_exercise_xa032aed2d0302f6e_mastery: {
            description: t`AP®︎ Calculus BC: Limits and continuity`,
            extendedDescription: t`Achieve mastery in all skills in AP®︎ Calculus BC: Limits and continuity`,
        },
        topic_exercise_xc36e3406a0105019_mastery: {
            description: t`AP®︎ Calculus BC: Limits and continuity`,
            extendedDescription: t`Achieve mastery in all skills in AP®︎ Calculus BC: Limits and continuity`,
        },
        topic_exercise_xa032aed2d0302f6e: {
            description: t`AP®︎ Calculus BC: Limits and continuity (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP®︎ Calculus BC: Limits and continuity (old)`,
        },
        topic_exercise_xc36e3406a0105019: {
            description: t`AP®︎ Calculus BC: Limits and continuity (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP®︎ Calculus BC: Limits and continuity (old)`,
        },
        topic_exercise_x8b1c07d3da0175a5_mastery: {
            description: t`AP®︎ Calculus BC: Parametric equations, polar coordinates, and vector-valued functions`,
            extendedDescription: t`Achieve mastery in all skills in AP®︎ Calculus BC: Parametric equations, polar coordinates, and vector-valued functions`,
        },
        topic_exercise_x8b1c07d3da0175a5: {
            description: t`AP®︎ Calculus BC: Parametric equations, polar coordinates, and vector-valued functions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP®︎ Calculus BC: Parametric equations, polar coordinates, and vector-valued functions (old)`,
        },
        topic_exercise_x201344f75c07d4ee_mastery: {
            description: t`AP®︎ Calculus BC: Series`,
            extendedDescription: t`Achieve mastery in all skills in AP®︎ Calculus BC: Series`,
        },
        topic_exercise_x201344f75c07d4ee: {
            description: t`AP®︎ Calculus BC: Series (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP®︎ Calculus BC: Series (old)`,
        },
        topic_exercise_x67c519a3c020eab0_mastery: {
            description: t`AP®︎ Calculus BC: Using derivatives to analyze functions`,
            extendedDescription: t`Achieve mastery in all skills in AP®︎ Calculus BC: Using derivatives to analyze functions`,
        },
        topic_exercise_x67c519a3c020eab0: {
            description: t`AP®︎ Calculus BC: Using derivatives to analyze functions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in AP®︎ Calculus BC: Using derivatives to analyze functions (old)`,
        },
        topic_exercise_qT3HZxt6XvuKEqczzytKCF8PQWQT_JP1VNI9UJDn_mastery: {
            description: t`Area, perimeter, and volume`,
            extendedDescription: t`Achieve mastery in all skills in Area, perimeter, and volume`,
        },
        topic_exercise_x16fb936c_mastery: {
            description: t`Area, perimeter, and volume`,
            extendedDescription: t`Achieve mastery in all skills in Area, perimeter, and volume`,
        },
        topic_exercise_qT3HZxt6XvuKEqczzytKCF8PQWQT_JP1VNI9UJDn: {
            description: t`Area, perimeter, and volume (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Area, perimeter, and volume (old)`,
        },
        topic_exercise_x16fb936c: {
            description: t`Area, perimeter, and volume (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Area, perimeter, and volume (old)`,
        },
        topic_exercise_xe3bf5942_mastery: {
            description: t`Arithmetic essentials: Decimals`,
            extendedDescription: t`Achieve mastery in all skills in Arithmetic essentials: Decimals`,
        },
        topic_exercise_xe3bf5942: {
            description: t`Arithmetic essentials: Decimals (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Arithmetic essentials: Decimals (old)`,
        },
        topic_exercise_x6a41d97e_mastery: {
            description: t`Arithmetic essentials: Fractions`,
            extendedDescription: t`Achieve mastery in all skills in Arithmetic essentials: Fractions`,
        },
        topic_exercise_x6a41d97e: {
            description: t`Arithmetic essentials: Fractions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Arithmetic essentials: Fractions (old)`,
        },
        topic_exercise_x910b651b_mastery: {
            description: t`Arithmetic properties`,
            extendedDescription: t`Achieve mastery in all skills in Arithmetic properties`,
        },
        topic_exercise_x910b651b: {
            description: t`Arithmetic properties (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Arithmetic properties (old)`,
        },
        topic_exercise_KHDySQBco4Z5ChI1U4UpyHU954YJ8QahCFcDsImA_mastery: {
            description: t`Arithmetic: Addition and subtraction`,
            extendedDescription: t`Achieve mastery in all skills in Arithmetic: Addition and subtraction`,
        },
        topic_exercise_x352f9bcb_mastery: {
            description: t`Arithmetic: Addition and subtraction`,
            extendedDescription: t`Achieve mastery in all skills in Arithmetic: Addition and subtraction`,
        },
        topic_exercise_KHDySQBco4Z5ChI1U4UpyHU954YJ8QahCFcDsImA: {
            description: t`Arithmetic: Addition and subtraction (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Arithmetic: Addition and subtraction (old)`,
        },
        topic_exercise_x352f9bcb: {
            description: t`Arithmetic: Addition and subtraction (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Arithmetic: Addition and subtraction (old)`,
        },
        topic_exercise_C0kfQ3mZSE_zBNfxY7EH4Kdwu_HaHM_oiR1BlAyW_mastery: {
            description: t`Arithmetic: Decimals`,
            extendedDescription: t`Achieve mastery in all skills in Arithmetic: Decimals`,
        },
        topic_exercise_xa869475e_mastery: {
            description: t`Arithmetic: Decimals`,
            extendedDescription: t`Achieve mastery in all skills in Arithmetic: Decimals`,
        },
        topic_exercise_C0kfQ3mZSE_zBNfxY7EH4Kdwu_HaHM_oiR1BlAyW: {
            description: t`Arithmetic: Decimals (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Arithmetic: Decimals (old)`,
        },
        topic_exercise_xa869475e: {
            description: t`Arithmetic: Decimals (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Arithmetic: Decimals (old)`,
        },
        "topic_exercise_6yXN4Yvo--fg2MGyd3mzG3MLP9ktdWa1iftIU9Ed_mastery": {
            description: t`Arithmetic: Fractions`,
            extendedDescription: t`Achieve mastery in all skills in Arithmetic: Fractions`,
        },
        topic_exercise_x4e0ba0da_mastery: {
            description: t`Arithmetic: Fractions`,
            extendedDescription: t`Achieve mastery in all skills in Arithmetic: Fractions`,
        },
        "topic_exercise_6yXN4Yvo--fg2MGyd3mzG3MLP9ktdWa1iftIU9Ed": {
            description: t`Arithmetic: Fractions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Arithmetic: Fractions (old)`,
        },
        topic_exercise_x4e0ba0da: {
            description: t`Arithmetic: Fractions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Arithmetic: Fractions (old)`,
        },
        topic_exercise_jjNw_P7DF9IrnyNAI0qQuJOPP9EygH7UKatgWVem_mastery: {
            description: t`Arithmetic: Multiplication and division`,
            extendedDescription: t`Achieve mastery in all skills in Arithmetic: Multiplication and division`,
        },
        topic_exercise_x85580c81_mastery: {
            description: t`Arithmetic: Multiplication and division`,
            extendedDescription: t`Achieve mastery in all skills in Arithmetic: Multiplication and division`,
        },
        topic_exercise_jjNw_P7DF9IrnyNAI0qQuJOPP9EygH7UKatgWVem: {
            description: t`Arithmetic: Multiplication and division (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Arithmetic: Multiplication and division (old)`,
        },
        topic_exercise_x85580c81: {
            description: t`Arithmetic: Multiplication and division (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Arithmetic: Multiplication and division (old)`,
        },
        topic_exercise_x518bed67_mastery: {
            description: t`Arithmetic: Negative numbers`,
            extendedDescription: t`Achieve mastery in all skills in Arithmetic: Negative numbers`,
        },
        topic_exercise_x518bed67: {
            description: t`Arithmetic: Negative numbers (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Arithmetic: Negative numbers (old)`,
        },
        "topic_exercise_dCbo4FwcSVKyciaY4Ok6F0a-FtFxcOcAKOILdb6q_mastery": {
            description: t`Arithmetic: Negative numbers and absolute value`,
            extendedDescription: t`Achieve mastery in all skills in Arithmetic: Negative numbers and absolute value`,
        },
        "topic_exercise_dCbo4FwcSVKyciaY4Ok6F0a-FtFxcOcAKOILdb6q": {
            description: t`Arithmetic: Negative numbers and absolute value (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Arithmetic: Negative numbers and absolute value (old)`,
        },
        topic_exercise_x60491111_mastery: {
            description: t`Arithmetic: Telling time`,
            extendedDescription: t`Achieve mastery in all skills in Arithmetic: Telling time`,
        },
        topic_exercise_x60491111: {
            description: t`Arithmetic: Telling time (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Arithmetic: Telling time (old)`,
        },
        topic_exercise_x67cb5d9c_mastery: {
            description: t`Basic geometry: Angles`,
            extendedDescription: t`Achieve mastery in all skills in Basic geometry: Angles`,
        },
        topic_exercise_x67cb5d9c: {
            description: t`Basic geometry: Angles (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Basic geometry: Angles (old)`,
        },
        topic_exercise_x073aa5c2_mastery: {
            description: t`Basic geometry: Area and perimeter`,
            extendedDescription: t`Achieve mastery in all skills in Basic geometry: Area and perimeter`,
        },
        topic_exercise_x073aa5c2: {
            description: t`Basic geometry: Area and perimeter (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Basic geometry: Area and perimeter (old)`,
        },
        topic_exercise_x0b42b472_mastery: {
            description: t`Basic geometry: Coordinate plane`,
            extendedDescription: t`Achieve mastery in all skills in Basic geometry: Coordinate plane`,
        },
        topic_exercise_x0b42b472: {
            description: t`Basic geometry: Coordinate plane (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Basic geometry: Coordinate plane (old)`,
        },
        topic_exercise_x5b855a1e_mastery: {
            description: t`Basic geometry: Lines`,
            extendedDescription: t`Achieve mastery in all skills in Basic geometry: Lines`,
        },
        topic_exercise_x5b855a1e: {
            description: t`Basic geometry: Lines (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Basic geometry: Lines (old)`,
        },
        topic_exercise_xa9c7d564_mastery: {
            description: t`Basic geometry: Pythagorean theorem`,
            extendedDescription: t`Achieve mastery in all skills in Basic geometry: Pythagorean theorem`,
        },
        topic_exercise_xa9c7d564: {
            description: t`Basic geometry: Pythagorean theorem (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Basic geometry: Pythagorean theorem (old)`,
        },
        topic_exercise_x198798e5_mastery: {
            description: t`Basic geometry: Shapes`,
            extendedDescription: t`Achieve mastery in all skills in Basic geometry: Shapes`,
        },
        topic_exercise_x198798e5: {
            description: t`Basic geometry: Shapes (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Basic geometry: Shapes (old)`,
        },
        topic_exercise_xbc33bb33_mastery: {
            description: t`Basic geometry: Transformations, congruence, and similarity`,
            extendedDescription: t`Achieve mastery in all skills in Basic geometry: Transformations, congruence, and similarity`,
        },
        topic_exercise_xbc33bb33: {
            description: t`Basic geometry: Transformations, congruence, and similarity (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Basic geometry: Transformations, congruence, and similarity (old)`,
        },
        topic_exercise_x96bca81f_mastery: {
            description: t`Basic geometry: Volume and surface area`,
            extendedDescription: t`Achieve mastery in all skills in Basic geometry: Volume and surface area`,
        },
        topic_exercise_x96bca81f: {
            description: t`Basic geometry: Volume and surface area (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Basic geometry: Volume and surface area (old)`,
        },
        topic_exercise_BL2ggmxriqndNUJ_zY3VGzTpD0jlB4i6n32sErhm_mastery: {
            description: t`Basic ratios and proportions`,
            extendedDescription: t`Achieve mastery in all skills in Basic ratios and proportions`,
        },
        topic_exercise_BL2ggmxriqndNUJ_zY3VGzTpD0jlB4i6n32sErhm: {
            description: t`Basic ratios and proportions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Basic ratios and proportions (old)`,
        },
        "topic_exercise_1fQH4dvaiy4S-o36n4_b-cyACZVHNGlb_JDOHTSk_mastery": {
            description: t`Calculus`,
            extendedDescription: t`Achieve mastery in all skills in Calculus`,
        },
        topic_exercise_x786f2022_mastery: {
            description: t`Calculus`,
            extendedDescription: t`Achieve mastery in all skills in Calculus`,
        },
        "topic_exercise_1fQH4dvaiy4S-o36n4_b-cyACZVHNGlb_JDOHTSk": {
            description: t`Calculus (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Calculus (old)`,
        },
        topic_exercise_x786f2022: {
            description: t`Calculus (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Calculus (old)`,
        },
        "topic_exercise_btmBpJOBWfBUwHDR8uXKNRvaM7B1J-Y02KlP0DPx_mastery": {
            description: t`California Standards Test: Algebra I`,
            extendedDescription: t`Achieve mastery in all skills in California Standards Test: Algebra I`,
        },
        "topic_exercise_btmBpJOBWfBUwHDR8uXKNRvaM7B1J-Y02KlP0DPx": {
            description: t`California Standards Test: Algebra I (old)`,
            extendedDescription: t`Achieve proficiency in all skills in California Standards Test: Algebra I (old)`,
        },
        topic_exercise_edNXuic6IZ9oopt6JOv2GbEdVu2mthUm_x9IRM7i_mastery: {
            description: t`California Standards Test: Algebra II`,
            extendedDescription: t`Achieve mastery in all skills in California Standards Test: Algebra II`,
        },
        topic_exercise_edNXuic6IZ9oopt6JOv2GbEdVu2mthUm_x9IRM7i: {
            description: t`California Standards Test: Algebra II (old)`,
            extendedDescription: t`Achieve proficiency in all skills in California Standards Test: Algebra II (old)`,
        },
        topic_exercise_sRgeHjYFgf7JdgVRV8g0a_7zcCwkB9LdrCvWyOuS_mastery: {
            description: t`Chemistry`,
            extendedDescription: t`Achieve mastery in all skills in Chemistry`,
        },
        topic_exercise_x822131fc_mastery: {
            description: t`Chemistry`,
            extendedDescription: t`Achieve mastery in all skills in Chemistry`,
        },
        topic_exercise_sRgeHjYFgf7JdgVRV8g0a_7zcCwkB9LdrCvWyOuS: {
            description: t`Chemistry (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Chemistry (old)`,
        },
        topic_exercise_x822131fc: {
            description: t`Chemistry (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Chemistry (old)`,
        },
        "topic_exercise_7S44AwNUape623eVyjSKwyDO830usHtTx-DGqOd__mastery": {
            description: t`Circle arcs and sectors`,
            extendedDescription: t`Achieve mastery in all skills in Circle arcs and sectors`,
        },
        "topic_exercise_7S44AwNUape623eVyjSKwyDO830usHtTx-DGqOd_": {
            description: t`Circle arcs and sectors (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Circle arcs and sectors (old)`,
        },
        topic_exercise_JM60nYoau9lv3NF5BjocJk_M1PaxAMXVmzcv_oss_mastery: {
            description: t`Circles`,
            extendedDescription: t`Achieve mastery in all skills in Circles`,
        },
        topic_exercise_x021a201c_mastery: {
            description: t`Circles`,
            extendedDescription: t`Achieve mastery in all skills in Circles`,
        },
        topic_exercise_JM60nYoau9lv3NF5BjocJk_M1PaxAMXVmzcv_oss: {
            description: t`Circles (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Circles (old)`,
        },
        topic_exercise_x021a201c: {
            description: t`Circles (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Circles (old)`,
        },
        "topic_exercise_W2DR5oRDxzv_wVlz_6K2X38wajMz-ds9a349_JmF_mastery": {
            description: t`ck12.org Algebra 1 Examples`,
            extendedDescription: t`Achieve mastery in all skills in ck12.org Algebra 1 Examples`,
        },
        "topic_exercise_W2DR5oRDxzv_wVlz_6K2X38wajMz-ds9a349_JmF": {
            description: t`ck12.org Algebra 1 Examples (old)`,
            extendedDescription: t`Achieve proficiency in all skills in ck12.org Algebra 1 Examples (old)`,
        },
        "topic_exercise_wUXIUR9Hs-zsIFnoyfcoiOBECV_GutaZu0GGZvf6_mastery": {
            description: t`Complex numbers`,
            extendedDescription: t`Achieve mastery in all skills in Complex numbers`,
        },
        topic_exercise_xd7a3ca35_mastery: {
            description: t`Complex numbers`,
            extendedDescription: t`Achieve mastery in all skills in Complex numbers`,
        },
        "topic_exercise_wUXIUR9Hs-zsIFnoyfcoiOBECV_GutaZu0GGZvf6": {
            description: t`Complex numbers (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Complex numbers (old)`,
        },
        topic_exercise_xd7a3ca35: {
            description: t`Complex numbers (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Complex numbers (old)`,
        },
        topic_exercise_x7f4d2dc1_mastery: {
            description: t`Congruent triangles`,
            extendedDescription: t`Achieve mastery in all skills in Congruent triangles`,
        },
        topic_exercise_x7f4d2dc1: {
            description: t`Congruent triangles (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Congruent triangles (old)`,
        },
        topic_exercise_2Urytk8IVv4Nieff1JBvu_IEc4shx2Lft5oed509_mastery: {
            description: t`Conic sections`,
            extendedDescription: t`Achieve mastery in all skills in Conic sections`,
        },
        topic_exercise_x18d95b5d_mastery: {
            description: t`Conic sections`,
            extendedDescription: t`Achieve mastery in all skills in Conic sections`,
        },
        topic_exercise_2Urytk8IVv4Nieff1JBvu_IEc4shx2Lft5oed509: {
            description: t`Conic sections (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Conic sections (old)`,
        },
        topic_exercise_x18d95b5d: {
            description: t`Conic sections (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Conic sections (old)`,
        },
        "topic_exercise_IxlIoae-BqeZbVR7mVSKsvdcJkgsDq_1pDB3DAzV_mastery": {
            description: t`CS Exercises`,
            extendedDescription: t`Achieve mastery in all skills in CS Exercises`,
        },
        "topic_exercise_IxlIoae-BqeZbVR7mVSKsvdcJkgsDq_1pDB3DAzV": {
            description: t`CS Exercises (old)`,
            extendedDescription: t`Achieve proficiency in all skills in CS Exercises (old)`,
        },
        topic_exercise_x2cc75188_mastery: {
            description: t`Current SAT (through January 2016): Full-length SAT`,
            extendedDescription: t`Achieve mastery in all skills in Current SAT (through January 2016): Full-length SAT`,
        },
        topic_exercise_x2cc75188: {
            description: t`Current SAT (through January 2016): Full-length SAT (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Current SAT (through January 2016): Full-length SAT (old)`,
        },
        topic_exercise_x8cb799e4_mastery: {
            description: t`Current SAT (through January 2016): SAT Math practice`,
            extendedDescription: t`Achieve mastery in all skills in Current SAT (through January 2016): SAT Math practice`,
        },
        topic_exercise_x8cb799e4: {
            description: t`Current SAT (through January 2016): SAT Math practice (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Current SAT (through January 2016): SAT Math practice (old)`,
        },
        topic_exercise_xa142ef20_mastery: {
            description: t`Current SAT (through January 2016): SAT Reading and Writing practice`,
            extendedDescription: t`Achieve mastery in all skills in Current SAT (through January 2016): SAT Reading and Writing practice`,
        },
        topic_exercise_xa142ef20: {
            description: t`Current SAT (through January 2016): SAT Reading and Writing practice (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Current SAT (through January 2016): SAT Reading and Writing practice (old)`,
        },
        topic_exercise_x80dafc21_mastery: {
            description: t`Decimals`,
            extendedDescription: t`Achieve mastery in all skills in Decimals`,
        },
        topic_exercise_x80dafc21: {
            description: t`Decimals (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Decimals (old)`,
        },
        topic_exercise_x778939c0_mastery: {
            description: t`Differential calculus: Advanced differentiation`,
            extendedDescription: t`Achieve mastery in all skills in Differential calculus: Advanced differentiation`,
        },
        topic_exercise_x778939c0: {
            description: t`Differential calculus: Advanced differentiation (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Differential calculus: Advanced differentiation (old)`,
        },
        topic_exercise_x3d7703dc19a01c46_mastery: {
            description: t`Differential Calculus: Analyzing functions `,
            extendedDescription: t`Achieve mastery in all skills in Differential Calculus: Analyzing functions `,
        },
        topic_exercise_x3d7703dc19a01c46: {
            description: t`Differential Calculus: Analyzing functions  (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Differential Calculus: Analyzing functions  (old)`,
        },
        topic_exercise_x14aabbd0_mastery: {
            description: t`Differential calculus: Analyzing functions with calculus`,
            extendedDescription: t`Achieve mastery in all skills in Differential calculus: Analyzing functions with calculus`,
        },
        topic_exercise_x14aabbd0: {
            description: t`Differential calculus: Analyzing functions with calculus (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Differential calculus: Analyzing functions with calculus (old)`,
        },
        topic_exercise_xc6d68993f5f78dd7_mastery: {
            description: t`Differential Calculus: Applications of derivatives`,
            extendedDescription: t`Achieve mastery in all skills in Differential Calculus: Applications of derivatives`,
        },
        topic_exercise_xc6d68993f5f78dd7: {
            description: t`Differential Calculus: Applications of derivatives (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Differential Calculus: Applications of derivatives (old)`,
        },
        topic_exercise_xd5874709_mastery: {
            description: t`Differential calculus: Basic differentiation`,
            extendedDescription: t`Achieve mastery in all skills in Differential calculus: Basic differentiation`,
        },
        topic_exercise_xd5874709: {
            description: t`Differential calculus: Basic differentiation (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Differential calculus: Basic differentiation (old)`,
        },
        topic_exercise_x309b509f_mastery: {
            description: t`Differential calculus: Continuity`,
            extendedDescription: t`Achieve mastery in all skills in Differential calculus: Continuity`,
        },
        topic_exercise_x309b509f: {
            description: t`Differential calculus: Continuity (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Differential calculus: Continuity (old)`,
        },
        topic_exercise_wIMjpyXXDoFfRGrDW614_IZy3N3caYFm8NrTSCpJ_mastery: {
            description: t`Differential calculus: Derivative applications`,
            extendedDescription: t`Achieve mastery in all skills in Differential calculus: Derivative applications`,
        },
        topic_exercise_x923da12d_mastery: {
            description: t`Differential calculus: Derivative applications`,
            extendedDescription: t`Achieve mastery in all skills in Differential calculus: Derivative applications`,
        },
        topic_exercise_wIMjpyXXDoFfRGrDW614_IZy3N3caYFm8NrTSCpJ: {
            description: t`Differential calculus: Derivative applications (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Differential calculus: Derivative applications (old)`,
        },
        topic_exercise_x923da12d: {
            description: t`Differential calculus: Derivative applications (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Differential calculus: Derivative applications (old)`,
        },
        topic_exercise_x5398b3b3_mastery: {
            description: t`Differential calculus: Derivative introduction`,
            extendedDescription: t`Achieve mastery in all skills in Differential calculus: Derivative introduction`,
        },
        topic_exercise_x5398b3b3: {
            description: t`Differential calculus: Derivative introduction (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Differential calculus: Derivative introduction (old)`,
        },
        topic_exercise_xab204ad888d46826_mastery: {
            description: t`Differential Calculus: Derivatives: chain rule and other advanced topics`,
            extendedDescription: t`Achieve mastery in all skills in Differential Calculus: Derivatives: chain rule and other advanced topics`,
        },
        topic_exercise_xab204ad888d46826: {
            description: t`Differential Calculus: Derivatives: chain rule and other advanced topics (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Differential Calculus: Derivatives: chain rule and other advanced topics (old)`,
        },
        topic_exercise_xbd6cd865e14ffa74_mastery: {
            description: t`Differential Calculus: Derivatives: definition and basic rules`,
            extendedDescription: t`Achieve mastery in all skills in Differential Calculus: Derivatives: definition and basic rules`,
        },
        topic_exercise_xbd6cd865e14ffa74: {
            description: t`Differential Calculus: Derivatives: definition and basic rules (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Differential Calculus: Derivatives: definition and basic rules (old)`,
        },
        topic_exercise_xca93b482_mastery: {
            description: t`Differential calculus: Differentiating common functions`,
            extendedDescription: t`Achieve mastery in all skills in Differential calculus: Differentiating common functions`,
        },
        topic_exercise_xca93b482: {
            description: t`Differential calculus: Differentiating common functions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Differential calculus: Differentiating common functions (old)`,
        },
        topic_exercise_xf734ef1c_mastery: {
            description: t`Differential calculus: Infinite limits`,
            extendedDescription: t`Achieve mastery in all skills in Differential calculus: Infinite limits`,
        },
        topic_exercise_xf734ef1c: {
            description: t`Differential calculus: Infinite limits (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Differential calculus: Infinite limits (old)`,
        },
        "topic_exercise_1QfevAgIgw4QrPvgruXft-x578bSFE7nm6_Nr08-_mastery": {
            description: t`Differential calculus: Limits`,
            extendedDescription: t`Achieve mastery in all skills in Differential calculus: Limits`,
        },
        "topic_exercise_1QfevAgIgw4QrPvgruXft-x578bSFE7nm6_Nr08-": {
            description: t`Differential calculus: Limits (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Differential calculus: Limits (old)`,
        },
        topic_exercise_x5c2512ae3554293f_mastery: {
            description: t`Differential Calculus: Limits and continuity`,
            extendedDescription: t`Achieve mastery in all skills in Differential Calculus: Limits and continuity`,
        },
        topic_exercise_x5c2512ae3554293f: {
            description: t`Differential Calculus: Limits and continuity (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Differential Calculus: Limits and continuity (old)`,
        },
        topic_exercise_x1e3477dc_mastery: {
            description: t`Differential calculus: Limits basics`,
            extendedDescription: t`Achieve mastery in all skills in Differential calculus: Limits basics`,
        },
        topic_exercise_x1e3477dc: {
            description: t`Differential calculus: Limits basics (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Differential calculus: Limits basics (old)`,
        },
        topic_exercise_xd65559c1_mastery: {
            description: t`Differential calculus: Limits from equations`,
            extendedDescription: t`Achieve mastery in all skills in Differential calculus: Limits from equations`,
        },
        topic_exercise_xd65559c1: {
            description: t`Differential calculus: Limits from equations (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Differential calculus: Limits from equations (old)`,
        },
        topic_exercise_x92c15682_mastery: {
            description: t`Differential calculus: Miscellaneous`,
            extendedDescription: t`Achieve mastery in all skills in Differential calculus: Miscellaneous`,
        },
        topic_exercise_x92c15682: {
            description: t`Differential calculus: Miscellaneous (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Differential calculus: Miscellaneous (old)`,
        },
        topic_exercise_xb7a0d2bb2c9b81f4_mastery: {
            description: t`Differential Calculus: Parametric equations, polar coordinates, and vector-valued functions`,
            extendedDescription: t`Achieve mastery in all skills in Differential Calculus: Parametric equations, polar coordinates, and vector-valued functions`,
        },
        topic_exercise_xb7a0d2bb2c9b81f4: {
            description: t`Differential Calculus: Parametric equations, polar coordinates, and vector-valued functions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Differential Calculus: Parametric equations, polar coordinates, and vector-valued functions (old)`,
        },
        topic_exercise_x32acf9ee_mastery: {
            description: t`Differential calculus: Product, quotient, & chain rules`,
            extendedDescription: t`Achieve mastery in all skills in Differential calculus: Product, quotient, & chain rules`,
        },
        topic_exercise_x32acf9ee: {
            description: t`Differential calculus: Product, quotient, & chain rules (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Differential calculus: Product, quotient, & chain rules (old)`,
        },
        topic_exercise_BoVJh13O31TOPpaa0VnADNuFos89D_bJrSRXpd_9_mastery: {
            description: t`Differential calculus: Taking derivatives`,
            extendedDescription: t`Achieve mastery in all skills in Differential calculus: Taking derivatives`,
        },
        topic_exercise_BoVJh13O31TOPpaa0VnADNuFos89D_bJrSRXpd_9: {
            description: t`Differential calculus: Taking derivatives (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Differential calculus: Taking derivatives (old)`,
        },
        topic_exercise_xd0ae8a03_mastery: {
            description: t`Early math: Addition and subtraction intro`,
            extendedDescription: t`Achieve mastery in all skills in Early math: Addition and subtraction intro`,
        },
        topic_exercise_xd0ae8a03: {
            description: t`Early math: Addition and subtraction intro (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Early math: Addition and subtraction intro (old)`,
        },
        topic_exercise_x2a262576_mastery: {
            description: t`Early math: Addition and subtraction within 100`,
            extendedDescription: t`Achieve mastery in all skills in Early math: Addition and subtraction within 100`,
        },
        topic_exercise_x2a262576: {
            description: t`Early math: Addition and subtraction within 100 (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Early math: Addition and subtraction within 100 (old)`,
        },
        topic_exercise_x4f9f5221_mastery: {
            description: t`Early math: Addition and subtraction within 1000`,
            extendedDescription: t`Achieve mastery in all skills in Early math: Addition and subtraction within 1000`,
        },
        topic_exercise_x4f9f5221: {
            description: t`Early math: Addition and subtraction within 1000 (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Early math: Addition and subtraction within 1000 (old)`,
        },
        topic_exercise_xa2993d94_mastery: {
            description: t`Early math: Addition and subtraction within 20`,
            extendedDescription: t`Achieve mastery in all skills in Early math: Addition and subtraction within 20`,
        },
        topic_exercise_xa2993d94: {
            description: t`Early math: Addition and subtraction within 20 (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Early math: Addition and subtraction within 20 (old)`,
        },
        topic_exercise_x310ffe65_mastery: {
            description: t`Early math: Counting`,
            extendedDescription: t`Achieve mastery in all skills in Early math: Counting`,
        },
        topic_exercise_x310ffe65: {
            description: t`Early math: Counting (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Early math: Counting (old)`,
        },
        topic_exercise_x54b9a662_mastery: {
            description: t`Early math: Geometry`,
            extendedDescription: t`Achieve mastery in all skills in Early math: Geometry`,
        },
        topic_exercise_x54b9a662: {
            description: t`Early math: Geometry (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Early math: Geometry (old)`,
        },
        topic_exercise_x853bca69_mastery: {
            description: t`Early math: Measurement and data`,
            extendedDescription: t`Achieve mastery in all skills in Early math: Measurement and data`,
        },
        topic_exercise_x853bca69: {
            description: t`Early math: Measurement and data (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Early math: Measurement and data (old)`,
        },
        topic_exercise_x314bd06e_mastery: {
            description: t`Early math: Place value (tens and hundreds)`,
            extendedDescription: t`Achieve mastery in all skills in Early math: Place value (tens and hundreds)`,
        },
        topic_exercise_x314bd06e: {
            description: t`Early math: Place value (tens and hundreds) (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Early math: Place value (tens and hundreds) (old)`,
        },
        topic_exercise_K62pPNvRVUW0wCVsQWqSSZDj2SUVisbA4AMNuqJe_mastery: {
            description: t`Equation of a line`,
            extendedDescription: t`Achieve mastery in all skills in Equation of a line`,
        },
        topic_exercise_czHTYtJhEUrZm4VMWWNf5pltVGJVx2TCmoXbVs1h_mastery: {
            description: t`Equation of a line`,
            extendedDescription: t`Achieve mastery in all skills in Equation of a line`,
        },
        topic_exercise_K62pPNvRVUW0wCVsQWqSSZDj2SUVisbA4AMNuqJe: {
            description: t`Equation of a line (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Equation of a line (old)`,
        },
        topic_exercise_czHTYtJhEUrZm4VMWWNf5pltVGJVx2TCmoXbVs1h: {
            description: t`Equation of a line (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Equation of a line (old)`,
        },
        topic_exercise_x900d9176_mastery: {
            description: t`Exponents, radicals, and scientific notation`,
            extendedDescription: t`Achieve mastery in all skills in Exponents, radicals, and scientific notation`,
        },
        topic_exercise_x900d9176: {
            description: t`Exponents, radicals, and scientific notation (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Exponents, radicals, and scientific notation (old)`,
        },
        topic_exercise_x3b866d76_mastery: {
            description: t`Factors and multiples`,
            extendedDescription: t`Achieve mastery in all skills in Factors and multiples`,
        },
        topic_exercise_x3b866d76: {
            description: t`Factors and multiples (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Factors and multiples (old)`,
        },
        topic_exercise_xd47ef507_mastery: {
            description: t`Fractions`,
            extendedDescription: t`Achieve mastery in all skills in Fractions`,
        },
        topic_exercise_xd47ef507: {
            description: t`Fractions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Fractions (old)`,
        },
        "topic_exercise_eMOhlYaagVEi8MLU4ALY51FkS-i6tdS6QXc5kRx6_mastery": {
            description: t`Functions`,
            extendedDescription: t`Achieve mastery in all skills in Functions`,
        },
        topic_exercise_xe8002e2d_mastery: {
            description: t`Functions`,
            extendedDescription: t`Achieve mastery in all skills in Functions`,
        },
        "topic_exercise_eMOhlYaagVEi8MLU4ALY51FkS-i6tdS6QXc5kRx6": {
            description: t`Functions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Functions (old)`,
        },
        topic_exercise_xe8002e2d: {
            description: t`Functions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Functions (old)`,
        },
        topic_exercise_xaf60b762_mastery: {
            description: t`Geometry: Analytic geometry`,
            extendedDescription: t`Achieve mastery in all skills in Geometry: Analytic geometry`,
        },
        topic_exercise_xaf60b762: {
            description: t`Geometry: Analytic geometry (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Geometry: Analytic geometry (old)`,
        },
        topic_exercise_xLyOiELVpsXCiF_JnNjxfkIXZ_1ffpiYCSP7Um3H_mastery: {
            description: t`Geometry: Angles & intersecting lines`,
            extendedDescription: t`Achieve mastery in all skills in Geometry: Angles & intersecting lines`,
        },
        topic_exercise_xLyOiELVpsXCiF_JnNjxfkIXZ_1ffpiYCSP7Um3H: {
            description: t`Geometry: Angles & intersecting lines (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Geometry: Angles & intersecting lines (old)`,
        },
        topic_exercise_x2b399649_mastery: {
            description: t`Geometry: Circles`,
            extendedDescription: t`Achieve mastery in all skills in Geometry: Circles`,
        },
        topic_exercise_x2b399649: {
            description: t`Geometry: Circles (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Geometry: Circles (old)`,
        },
        topic_exercise_xR_zAHtYLpu0FWR2TblREw3SnSwSj_kib0mhmpoP_mastery: {
            description: t`Geometry: Congruence`,
            extendedDescription: t`Achieve mastery in all skills in Geometry: Congruence`,
        },
        topic_exercise_xR_zAHtYLpu0FWR2TblREw3SnSwSj_kib0mhmpoP: {
            description: t`Geometry: Congruence (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Geometry: Congruence (old)`,
        },
        topic_exercise_x2b70434f_mastery: {
            description: t`Geometry: Geometric constructions`,
            extendedDescription: t`Achieve mastery in all skills in Geometry: Geometric constructions`,
        },
        topic_exercise_x2b70434f: {
            description: t`Geometry: Geometric constructions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Geometry: Geometric constructions (old)`,
        },
        topic_exercise_x20b641c5_mastery: {
            description: t`Geometry: Logical reasoning`,
            extendedDescription: t`Achieve mastery in all skills in Geometry: Logical reasoning`,
        },
        topic_exercise_x20b641c5: {
            description: t`Geometry: Logical reasoning (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Geometry: Logical reasoning (old)`,
        },
        topic_exercise_x82bf49e8_mastery: {
            description: t`Geometry: Miscellaneous`,
            extendedDescription: t`Achieve mastery in all skills in Geometry: Miscellaneous`,
        },
        topic_exercise_x82bf49e8: {
            description: t`Geometry: Miscellaneous (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Geometry: Miscellaneous (old)`,
        },
        topic_exercise_10MlOxExUBBQNHgviilzlgi9KIpYSd7NQ2Z1todb_mastery: {
            description: t`Geometry: Perimeter, area, and volume`,
            extendedDescription: t`Achieve mastery in all skills in Geometry: Perimeter, area, and volume`,
        },
        topic_exercise_10MlOxExUBBQNHgviilzlgi9KIpYSd7NQ2Z1todb: {
            description: t`Geometry: Perimeter, area, and volume (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Geometry: Perimeter, area, and volume (old)`,
        },
        topic_exercise_xc6b8f425_mastery: {
            description: t`Geometry: Quadrilaterals `,
            extendedDescription: t`Achieve mastery in all skills in Geometry: Quadrilaterals `,
        },
        topic_exercise_xc6b8f425: {
            description: t`Geometry: Quadrilaterals  (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Geometry: Quadrilaterals  (old)`,
        },
        topic_exercise_MkfMqpEKPS0otnKDiCeO6HIMB7MFonwHJAJJhXpL_mastery: {
            description: t`Geometry: Right triangles and trigonometry`,
            extendedDescription: t`Achieve mastery in all skills in Geometry: Right triangles and trigonometry`,
        },
        topic_exercise_MkfMqpEKPS0otnKDiCeO6HIMB7MFonwHJAJJhXpL: {
            description: t`Geometry: Right triangles and trigonometry (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Geometry: Right triangles and trigonometry (old)`,
        },
        topic_exercise_duLZoDIgppI8sWSZRcx8wKtHULQqfn5LgUEywejp_mastery: {
            description: t`Geometry: Similarity`,
            extendedDescription: t`Achieve mastery in all skills in Geometry: Similarity`,
        },
        topic_exercise_duLZoDIgppI8sWSZRcx8wKtHULQqfn5LgUEywejp: {
            description: t`Geometry: Similarity (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Geometry: Similarity (old)`,
        },
        topic_exercise_fXOzwkCI8atCpgrnlCENSSw7OL72WPD5ICY0amSd_mastery: {
            description: t`Geometry: Special properties and parts of triangles`,
            extendedDescription: t`Achieve mastery in all skills in Geometry: Special properties and parts of triangles`,
        },
        topic_exercise_fXOzwkCI8atCpgrnlCENSSw7OL72WPD5ICY0amSd: {
            description: t`Geometry: Special properties and parts of triangles (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Geometry: Special properties and parts of triangles (old)`,
        },
        topic_exercise_xd5be27be_mastery: {
            description: t`Geometry: Tools of geometry`,
            extendedDescription: t`Achieve mastery in all skills in Geometry: Tools of geometry`,
        },
        topic_exercise_xd5be27be: {
            description: t`Geometry: Tools of geometry (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Geometry: Tools of geometry (old)`,
        },
        "topic_exercise_GaFn0lA_acCcYFs3Ps2w2Ain5icHT2BF_lUmnS-W_mastery": {
            description: t`Geometry: Transformations`,
            extendedDescription: t`Achieve mastery in all skills in Geometry: Transformations`,
        },
        "topic_exercise_GaFn0lA_acCcYFs3Ps2w2Ain5icHT2BF_lUmnS-W": {
            description: t`Geometry: Transformations (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Geometry: Transformations (old)`,
        },
        "topic_exercise_ZruGtT-2SZipzijKgdpH27c3xgWtiPGA_G6JePnr_mastery": {
            description: t`Graphing points, equations and inequalities`,
            extendedDescription: t`Achieve mastery in all skills in Graphing points, equations and inequalities`,
        },
        topic_exercise_x95ee270d_mastery: {
            description: t`Graphing points, equations and inequalities`,
            extendedDescription: t`Achieve mastery in all skills in Graphing points, equations and inequalities`,
        },
        "topic_exercise_ZruGtT-2SZipzijKgdpH27c3xgWtiPGA_G6JePnr": {
            description: t`Graphing points, equations and inequalities (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Graphing points, equations and inequalities (old)`,
        },
        topic_exercise_x95ee270d: {
            description: t`Graphing points, equations and inequalities (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Graphing points, equations and inequalities (old)`,
        },
        topic_exercise_xaa176d24_mastery: {
            description: t`High school geometry: Analytic geometry`,
            extendedDescription: t`Achieve mastery in all skills in High school geometry: Analytic geometry`,
        },
        topic_exercise_xaa176d24: {
            description: t`High school geometry: Analytic geometry (old)`,
            extendedDescription: t`Achieve proficiency in all skills in High school geometry: Analytic geometry (old)`,
        },
        topic_exercise_x735339fa_mastery: {
            description: t`High school geometry: Circles`,
            extendedDescription: t`Achieve mastery in all skills in High school geometry: Circles`,
        },
        topic_exercise_x735339fa: {
            description: t`High school geometry: Circles (old)`,
            extendedDescription: t`Achieve proficiency in all skills in High school geometry: Circles (old)`,
        },
        topic_exercise_x1d999dce_mastery: {
            description: t`High school geometry: Congruence`,
            extendedDescription: t`Achieve mastery in all skills in High school geometry: Congruence`,
        },
        topic_exercise_x1d999dce: {
            description: t`High school geometry: Congruence (old)`,
            extendedDescription: t`Achieve proficiency in all skills in High school geometry: Congruence (old)`,
        },
        topic_exercise_x39dc0a7b_mastery: {
            description: t`High school geometry: Geometry foundations`,
            extendedDescription: t`Achieve mastery in all skills in High school geometry: Geometry foundations`,
        },
        topic_exercise_x39dc0a7b: {
            description: t`High school geometry: Geometry foundations (old)`,
            extendedDescription: t`Achieve proficiency in all skills in High school geometry: Geometry foundations (old)`,
        },
        topic_exercise_x7597fbbe_mastery: {
            description: t`High school geometry: Right triangles & trigonometry`,
            extendedDescription: t`Achieve mastery in all skills in High school geometry: Right triangles & trigonometry`,
        },
        topic_exercise_x7597fbbe: {
            description: t`High school geometry: Right triangles & trigonometry (old)`,
            extendedDescription: t`Achieve proficiency in all skills in High school geometry: Right triangles & trigonometry (old)`,
        },
        topic_exercise_x4192cc77_mastery: {
            description: t`High school geometry: Similarity`,
            extendedDescription: t`Achieve mastery in all skills in High school geometry: Similarity`,
        },
        topic_exercise_x4192cc77: {
            description: t`High school geometry: Similarity (old)`,
            extendedDescription: t`Achieve proficiency in all skills in High school geometry: Similarity (old)`,
        },
        topic_exercise_x9e6f6ed7_mastery: {
            description: t`High school geometry: Solid geometry`,
            extendedDescription: t`Achieve mastery in all skills in High school geometry: Solid geometry`,
        },
        topic_exercise_x9e6f6ed7: {
            description: t`High school geometry: Solid geometry (old)`,
            extendedDescription: t`Achieve proficiency in all skills in High school geometry: Solid geometry (old)`,
        },
        topic_exercise_xc244bcf0_mastery: {
            description: t`High school geometry: Transformations`,
            extendedDescription: t`Achieve mastery in all skills in High school geometry: Transformations`,
        },
        topic_exercise_xc244bcf0: {
            description: t`High school geometry: Transformations (old)`,
            extendedDescription: t`Achieve proficiency in all skills in High school geometry: Transformations (old)`,
        },
        topic_exercise_x2394bd7b_mastery: {
            description: t`High school statistics: Data distributions`,
            extendedDescription: t`Achieve mastery in all skills in High school statistics: Data distributions`,
        },
        topic_exercise_x2394bd7b: {
            description: t`High school statistics: Data distributions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in High school statistics: Data distributions (old)`,
        },
        topic_exercise_xf1304f59_mastery: {
            description: t`High school statistics: Normal distributions`,
            extendedDescription: t`Achieve mastery in all skills in High school statistics: Normal distributions`,
        },
        topic_exercise_xf1304f59: {
            description: t`High school statistics: Normal distributions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in High school statistics: Normal distributions (old)`,
        },
        topic_exercise_x8d0deee9_mastery: {
            description: t`High school statistics: Probability`,
            extendedDescription: t`Achieve mastery in all skills in High school statistics: Probability`,
        },
        topic_exercise_x8d0deee9: {
            description: t`High school statistics: Probability (old)`,
            extendedDescription: t`Achieve proficiency in all skills in High school statistics: Probability (old)`,
        },
        topic_exercise_xb488d4d2_mastery: {
            description: t`High school statistics: Scatterplots`,
            extendedDescription: t`Achieve mastery in all skills in High school statistics: Scatterplots`,
        },
        topic_exercise_xb488d4d2: {
            description: t`High school statistics: Scatterplots (old)`,
            extendedDescription: t`Achieve proficiency in all skills in High school statistics: Scatterplots (old)`,
        },
        topic_exercise_xdd704d10_mastery: {
            description: t`High school statistics: Study design`,
            extendedDescription: t`Achieve mastery in all skills in High school statistics: Study design`,
        },
        topic_exercise_xdd704d10: {
            description: t`High school statistics: Study design (old)`,
            extendedDescription: t`Achieve proficiency in all skills in High school statistics: Study design (old)`,
        },
        topic_exercise_x2143fc3d_mastery: {
            description: t`High school statistics: Two-way tables`,
            extendedDescription: t`Achieve mastery in all skills in High school statistics: Two-way tables`,
        },
        topic_exercise_x2143fc3d: {
            description: t`High school statistics: Two-way tables (old)`,
            extendedDescription: t`Achieve proficiency in all skills in High school statistics: Two-way tables (old)`,
        },
        topic_exercise_x2a3773b2_mastery: {
            description: t`Inferential statistics`,
            extendedDescription: t`Achieve mastery in all skills in Inferential statistics`,
        },
        topic_exercise_x2a3773b2: {
            description: t`Inferential statistics (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Inferential statistics (old)`,
        },
        "topic_exercise_tYEsL7MEqnPdtRfmCRh93598-kPnQ_R2xYPcsurV_mastery": {
            description: t`Integral calculus: AP Calculus practice questions`,
            extendedDescription: t`Achieve mastery in all skills in Integral calculus: AP Calculus practice questions`,
        },
        "topic_exercise_tYEsL7MEqnPdtRfmCRh93598-kPnQ_R2xYPcsurV": {
            description: t`Integral calculus: AP Calculus practice questions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Integral calculus: AP Calculus practice questions (old)`,
        },
        topic_exercise_x82029b0d22ed4f13_mastery: {
            description: t`Integral Calculus: Applications of integrals`,
            extendedDescription: t`Achieve mastery in all skills in Integral Calculus: Applications of integrals`,
        },
        topic_exercise_x82029b0d22ed4f13: {
            description: t`Integral Calculus: Applications of integrals (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Integral Calculus: Applications of integrals (old)`,
        },
        topic_exercise_x29fd4be8_mastery: {
            description: t`Integral calculus: Area & arc length using calculus`,
            extendedDescription: t`Achieve mastery in all skills in Integral calculus: Area & arc length using calculus`,
        },
        topic_exercise_x29fd4be8: {
            description: t`Integral calculus: Area & arc length using calculus (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Integral calculus: Area & arc length using calculus (old)`,
        },
        topic_exercise_xa102594a_mastery: {
            description: t`Integral calculus: Definite integral evaluation`,
            extendedDescription: t`Achieve mastery in all skills in Integral calculus: Definite integral evaluation`,
        },
        topic_exercise_xa102594a: {
            description: t`Integral calculus: Definite integral evaluation (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Integral calculus: Definite integral evaluation (old)`,
        },
        topic_exercise_xb4891bbe_mastery: {
            description: t`Integral calculus: Definite integrals introduction`,
            extendedDescription: t`Achieve mastery in all skills in Integral calculus: Definite integrals introduction`,
        },
        topic_exercise_xb4891bbe: {
            description: t`Integral calculus: Definite integrals introduction (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Integral calculus: Definite integrals introduction (old)`,
        },
        topic_exercise_x7a10a34cd2db936c_mastery: {
            description: t`Integral Calculus: Differential equations`,
            extendedDescription: t`Achieve mastery in all skills in Integral Calculus: Differential equations`,
        },
        topic_exercise_x7a10a34cd2db936c: {
            description: t`Integral Calculus: Differential equations (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Integral Calculus: Differential equations (old)`,
        },
        topic_exercise_x06e84614_mastery: {
            description: t`Integral calculus: Fundamental theorem of calculus`,
            extendedDescription: t`Achieve mastery in all skills in Integral calculus: Fundamental theorem of calculus`,
        },
        topic_exercise_x06e84614: {
            description: t`Integral calculus: Fundamental theorem of calculus (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Integral calculus: Fundamental theorem of calculus (old)`,
        },
        topic_exercise_x98b8dfdb_mastery: {
            description: t`Integral calculus: Indefinite integrals`,
            extendedDescription: t`Achieve mastery in all skills in Integral calculus: Indefinite integrals`,
        },
        topic_exercise_x98b8dfdb: {
            description: t`Integral calculus: Indefinite integrals (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Integral calculus: Indefinite integrals (old)`,
        },
        "topic_exercise_l_x-siD3AugYxWigJq052uwAG-tbnGV7wesGeBEs_mastery": {
            description: t`Integral calculus: Integrals`,
            extendedDescription: t`Achieve mastery in all skills in Integral calculus: Integrals`,
        },
        topic_exercise_xfe2424d1ddc001f9_mastery: {
            description: t`Integral Calculus: Integrals`,
            extendedDescription: t`Achieve mastery in all skills in Integral Calculus: Integrals`,
        },
        "topic_exercise_l_x-siD3AugYxWigJq052uwAG-tbnGV7wesGeBEs": {
            description: t`Integral calculus: Integrals (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Integral calculus: Integrals (old)`,
        },
        topic_exercise_xfe2424d1ddc001f9: {
            description: t`Integral Calculus: Integrals (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Integral Calculus: Integrals (old)`,
        },
        topic_exercise_rxU2Db7_9vKHwkTuoBCOlJbfkL0nwf5TW07qxZyc_mastery: {
            description: t`Integral calculus: Integration applications`,
            extendedDescription: t`Achieve mastery in all skills in Integral calculus: Integration applications`,
        },
        topic_exercise_x525fa911_mastery: {
            description: t`Integral calculus: Integration applications`,
            extendedDescription: t`Achieve mastery in all skills in Integral calculus: Integration applications`,
        },
        topic_exercise_rxU2Db7_9vKHwkTuoBCOlJbfkL0nwf5TW07qxZyc: {
            description: t`Integral calculus: Integration applications (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Integral calculus: Integration applications (old)`,
        },
        topic_exercise_x525fa911: {
            description: t`Integral calculus: Integration applications (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Integral calculus: Integration applications (old)`,
        },
        topic_exercise_x07443e9b_mastery: {
            description: t`Integral calculus: Integration techniques`,
            extendedDescription: t`Achieve mastery in all skills in Integral calculus: Integration techniques`,
        },
        topic_exercise_x1a336ce3_mastery: {
            description: t`Integral calculus: Integration techniques`,
            extendedDescription: t`Achieve mastery in all skills in Integral calculus: Integration techniques`,
        },
        topic_exercise_x07443e9b: {
            description: t`Integral calculus: Integration techniques (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Integral calculus: Integration techniques (old)`,
        },
        topic_exercise_x1a336ce3: {
            description: t`Integral calculus: Integration techniques (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Integral calculus: Integration techniques (old)`,
        },
        topic_exercise_xd4f79f5f68065103_mastery: {
            description: t`Integral Calculus: Parametric equations, polar coordinates, and vector-valued functions`,
            extendedDescription: t`Achieve mastery in all skills in Integral Calculus: Parametric equations, polar coordinates, and vector-valued functions`,
        },
        topic_exercise_xd4f79f5f68065103: {
            description: t`Integral Calculus: Parametric equations, polar coordinates, and vector-valued functions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Integral Calculus: Parametric equations, polar coordinates, and vector-valued functions (old)`,
        },
        topic_exercise_x8a9c2f0d_mastery: {
            description: t`Integral calculus: Power series`,
            extendedDescription: t`Achieve mastery in all skills in Integral calculus: Power series`,
        },
        topic_exercise_x8a9c2f0d: {
            description: t`Integral calculus: Power series (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Integral calculus: Power series (old)`,
        },
        topic_exercise_xc1a96f24_mastery: {
            description: t`Integral calculus: Riemann sums`,
            extendedDescription: t`Achieve mastery in all skills in Integral calculus: Riemann sums`,
        },
        topic_exercise_xc1a96f24: {
            description: t`Integral calculus: Riemann sums (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Integral calculus: Riemann sums (old)`,
        },
        topic_exercise_x716b9ea4_mastery: {
            description: t`Integral calculus: Sequences`,
            extendedDescription: t`Achieve mastery in all skills in Integral calculus: Sequences`,
        },
        topic_exercise_x716b9ea4: {
            description: t`Integral calculus: Sequences (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Integral calculus: Sequences (old)`,
        },
        topic_exercise_x0604b570_mastery: {
            description: t`Integral calculus: Sequences & series intro`,
            extendedDescription: t`Achieve mastery in all skills in Integral calculus: Sequences & series intro`,
        },
        topic_exercise_x0604b570: {
            description: t`Integral calculus: Sequences & series intro (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Integral calculus: Sequences & series intro (old)`,
        },
        topic_exercise_0REj2d3fcvW9Qsj2hZLuebQMAaTNaG9WTlYElYrf_mastery: {
            description: t`Integral calculus: Sequences, series, and function approximation`,
            extendedDescription: t`Achieve mastery in all skills in Integral calculus: Sequences, series, and function approximation`,
        },
        topic_exercise_0REj2d3fcvW9Qsj2hZLuebQMAaTNaG9WTlYElYrf: {
            description: t`Integral calculus: Sequences, series, and function approximation (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Integral calculus: Sequences, series, and function approximation (old)`,
        },
        topic_exercise_x53029aa2ea9ca96a_mastery: {
            description: t`Integral Calculus: Series`,
            extendedDescription: t`Achieve mastery in all skills in Integral Calculus: Series`,
        },
        topic_exercise_x53029aa2ea9ca96a: {
            description: t`Integral Calculus: Series (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Integral Calculus: Series (old)`,
        },
        topic_exercise_x86dc33b7b482e2a8_mastery: {
            description: t`Integral calculus: Series convergence & estimation`,
            extendedDescription: t`Achieve mastery in all skills in Integral calculus: Series convergence & estimation`,
        },
        topic_exercise_x86dc33b7b482e2a8: {
            description: t`Integral calculus: Series convergence & estimation (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Integral calculus: Series convergence & estimation (old)`,
        },
        topic_exercise_xeab22e1c_mastery: {
            description: t`Integral calculus: Volume using calculus`,
            extendedDescription: t`Achieve mastery in all skills in Integral calculus: Volume using calculus`,
        },
        topic_exercise_xeab22e1c: {
            description: t`Integral calculus: Volume using calculus (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Integral calculus: Volume using calculus (old)`,
        },
        topic_exercise_x88a3e8df_mastery: {
            description: t`Interpreting data`,
            extendedDescription: t`Achieve mastery in all skills in Interpreting data`,
        },
        topic_exercise_x88a3e8df: {
            description: t`Interpreting data (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Interpreting data (old)`,
        },
        topic_exercise_Pc62pWfzO9aC9NU3sksDGzeyln8ef2oSfWgoq7or_mastery: {
            description: t`Intro to Euclidean geometry`,
            extendedDescription: t`Achieve mastery in all skills in Intro to Euclidean geometry`,
        },
        topic_exercise_Pc62pWfzO9aC9NU3sksDGzeyln8ef2oSfWgoq7or: {
            description: t`Intro to Euclidean geometry (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Intro to Euclidean geometry (old)`,
        },
        topic_exercise_eKQonkWSfzdf0JUg5_iYl5xDke_y0IyUU8z0XEyJ_mastery: {
            description: t`Journey into Cryptography.`,
            extendedDescription: t`Achieve mastery in all skills in Journey into Cryptography.`,
        },
        topic_exercise_eKQonkWSfzdf0JUg5_iYl5xDke_y0IyUU8z0XEyJ: {
            description: t`Journey into Cryptography. (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Journey into Cryptography. (old)`,
        },
        topic_exercise_xe14b6218_mastery: {
            description: t`Kindergarten: Addition and subtraction`,
            extendedDescription: t`Achieve mastery in all skills in Kindergarten: Addition and subtraction`,
        },
        topic_exercise_xe14b6218: {
            description: t`Kindergarten: Addition and subtraction (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Kindergarten: Addition and subtraction (old)`,
        },
        topic_exercise_xa67251d8_mastery: {
            description: t`Kindergarten: Counting and place value`,
            extendedDescription: t`Achieve mastery in all skills in Kindergarten: Counting and place value`,
        },
        topic_exercise_xa67251d8: {
            description: t`Kindergarten: Counting and place value (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Kindergarten: Counting and place value (old)`,
        },
        topic_exercise_x5e661ee5_mastery: {
            description: t`Kindergarten: Measurement and geometry`,
            extendedDescription: t`Achieve mastery in all skills in Kindergarten: Measurement and geometry`,
        },
        topic_exercise_x5e661ee5: {
            description: t`Kindergarten: Measurement and geometry (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Kindergarten: Measurement and geometry (old)`,
        },
        topic_exercise_xWSlmnZsvEPm08ptMWdV1r4HL89_weG5SyPZY7ng_mastery: {
            description: t`Linear Algebra`,
            extendedDescription: t`Achieve mastery in all skills in Linear Algebra`,
        },
        topic_exercise_xWSlmnZsvEPm08ptMWdV1r4HL89_weG5SyPZY7ng: {
            description: t`Linear Algebra (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Linear Algebra (old)`,
        },
        topic_exercise_sEDSB7AIWcn672jS_yH_jFbDzTSgP6DuW7448517_mastery: {
            description: t`Linear equations`,
            extendedDescription: t`Achieve mastery in all skills in Linear equations`,
        },
        topic_exercise_x86a3d4b8_mastery: {
            description: t`Linear equations`,
            extendedDescription: t`Achieve mastery in all skills in Linear equations`,
        },
        topic_exercise_sEDSB7AIWcn672jS_yH_jFbDzTSgP6DuW7448517: {
            description: t`Linear equations (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Linear equations (old)`,
        },
        topic_exercise_x86a3d4b8: {
            description: t`Linear equations (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Linear equations (old)`,
        },
        topic_exercise_x468c6c9a_mastery: {
            description: t`Linear inequalities`,
            extendedDescription: t`Achieve mastery in all skills in Linear inequalities`,
        },
        topic_exercise_x468c6c9a: {
            description: t`Linear inequalities (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Linear inequalities (old)`,
        },
        topic_exercise_SJq0OBr8A24GSYMzCeBXfRQFsb3LiuMhVpm3tBBS_mastery: {
            description: t`Logical reasoning`,
            extendedDescription: t`Achieve mastery in all skills in Logical reasoning`,
        },
        topic_exercise_x3a4419c2_mastery: {
            description: t`Logical reasoning`,
            extendedDescription: t`Achieve mastery in all skills in Logical reasoning`,
        },
        topic_exercise_SJq0OBr8A24GSYMzCeBXfRQFsb3LiuMhVpm3tBBS: {
            description: t`Logical reasoning (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Logical reasoning (old)`,
        },
        topic_exercise_x3a4419c2: {
            description: t`Logical reasoning (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Logical reasoning (old)`,
        },
        "topic_exercise_AyurxP7NdpHfWEHXD47wTCe-3pTNuI3lE2OZ_fie_mastery": {
            description: t`MAP Basic`,
            extendedDescription: t`Achieve mastery in all skills in MAP Basic`,
        },
        "topic_exercise_AyurxP7NdpHfWEHXD47wTCe-3pTNuI3lE2OZ_fie": {
            description: t`MAP Basic (old)`,
            extendedDescription: t`Achieve proficiency in all skills in MAP Basic (old)`,
        },
        topic_exercise_x3cbe69b6_mastery: {
            description: t`Mathematics I (2018 edition): Analytic geometry`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics I (2018 edition): Analytic geometry`,
        },
        topic_exercise_x3cbe69b6: {
            description: t`Mathematics I (2018 edition): Analytic geometry (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics I (2018 edition): Analytic geometry (old)`,
        },
        topic_exercise_x8742bf8d_mastery: {
            description: t`Mathematics I (2018 edition): Congruence`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics I (2018 edition): Congruence`,
        },
        topic_exercise_x8742bf8d: {
            description: t`Mathematics I (2018 edition): Congruence (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics I (2018 edition): Congruence (old)`,
        },
        topic_exercise_x6bfd992a_mastery: {
            description: t`Mathematics I (2018 edition): Data distributions`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics I (2018 edition): Data distributions`,
        },
        topic_exercise_x6bfd992a: {
            description: t`Mathematics I (2018 edition): Data distributions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics I (2018 edition): Data distributions (old)`,
        },
        topic_exercise_x2298c533_mastery: {
            description: t`Mathematics I (2018 edition): Exponential growth & decay`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics I (2018 edition): Exponential growth & decay`,
        },
        topic_exercise_x2298c533: {
            description: t`Mathematics I (2018 edition): Exponential growth & decay (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics I (2018 edition): Exponential growth & decay (old)`,
        },
        topic_exercise_xef51da9a_mastery: {
            description: t`Mathematics I (2018 edition): Functions`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics I (2018 edition): Functions`,
        },
        topic_exercise_xef51da9a: {
            description: t`Mathematics I (2018 edition): Functions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics I (2018 edition): Functions (old)`,
        },
        topic_exercise_x74f33f7b_mastery: {
            description: t`Mathematics I (2018 edition): Geometry transformations`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics I (2018 edition): Geometry transformations`,
        },
        topic_exercise_x74f33f7b: {
            description: t`Mathematics I (2018 edition): Geometry transformations (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics I (2018 edition): Geometry transformations (old)`,
        },
        topic_exercise_xc2f362ae_mastery: {
            description: t`Mathematics I (2018 edition): Inequalities (systems & graphs)`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics I (2018 edition): Inequalities (systems & graphs)`,
        },
        topic_exercise_xc2f362ae: {
            description: t`Mathematics I (2018 edition): Inequalities (systems & graphs) (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics I (2018 edition): Inequalities (systems & graphs) (old)`,
        },
        topic_exercise_x7d204bab_mastery: {
            description: t`Mathematics I (2018 edition): Linear equations & graphs`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics I (2018 edition): Linear equations & graphs`,
        },
        topic_exercise_x7d204bab: {
            description: t`Mathematics I (2018 edition): Linear equations & graphs (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics I (2018 edition): Linear equations & graphs (old)`,
        },
        topic_exercise_x0f889854_mastery: {
            description: t`Mathematics I (2018 edition): Linear word problems`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics I (2018 edition): Linear word problems`,
        },
        topic_exercise_x0f889854: {
            description: t`Mathematics I (2018 edition): Linear word problems (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics I (2018 edition): Linear word problems (old)`,
        },
        topic_exercise_x06d93de3_mastery: {
            description: t`Mathematics I (2018 edition): Rational exponents & radicals`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics I (2018 edition): Rational exponents & radicals`,
        },
        topic_exercise_x06d93de3: {
            description: t`Mathematics I (2018 edition): Rational exponents & radicals (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics I (2018 edition): Rational exponents & radicals (old)`,
        },
        topic_exercise_x0ceb2563_mastery: {
            description: t`Mathematics I (2018 edition): Scatterplots`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics I (2018 edition): Scatterplots`,
        },
        topic_exercise_x0ceb2563: {
            description: t`Mathematics I (2018 edition): Scatterplots (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics I (2018 edition): Scatterplots (old)`,
        },
        topic_exercise_xd661ec71_mastery: {
            description: t`Mathematics I (2018 edition): Sequences`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics I (2018 edition): Sequences`,
        },
        topic_exercise_xd661ec71: {
            description: t`Mathematics I (2018 edition): Sequences (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics I (2018 edition): Sequences (old)`,
        },
        topic_exercise_x86004a50_mastery: {
            description: t`Mathematics I (2018 edition): Solving equations & inequalities`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics I (2018 edition): Solving equations & inequalities`,
        },
        topic_exercise_x86004a50: {
            description: t`Mathematics I (2018 edition): Solving equations & inequalities (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics I (2018 edition): Solving equations & inequalities (old)`,
        },
        topic_exercise_xf01626f4_mastery: {
            description: t`Mathematics I (2018 edition): Systems of equations`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics I (2018 edition): Systems of equations`,
        },
        topic_exercise_xf01626f4: {
            description: t`Mathematics I (2018 edition): Systems of equations (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics I (2018 edition): Systems of equations (old)`,
        },
        topic_exercise_xdfee265e_mastery: {
            description: t`Mathematics I (2018 edition): Two-way tables`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics I (2018 edition): Two-way tables`,
        },
        topic_exercise_xdfee265e: {
            description: t`Mathematics I (2018 edition): Two-way tables (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics I (2018 edition): Two-way tables (old)`,
        },
        topic_exercise_x2433bf3d_mastery: {
            description: t`Mathematics I (2018 edition): Working with units`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics I (2018 edition): Working with units`,
        },
        topic_exercise_x2433bf3d: {
            description: t`Mathematics I (2018 edition): Working with units (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics I (2018 edition): Working with units (old)`,
        },
        topic_exercise_x2548198f0005ec74_mastery: {
            description: t`Mathematics I: Algebra foundations`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics I: Algebra foundations`,
        },
        topic_exercise_x2548198f0005ec74: {
            description: t`Mathematics I: Algebra foundations (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics I: Algebra foundations (old)`,
        },
        topic_exercise_x6bf124c0f261dae3_mastery: {
            description: t`Mathematics I: Analytic geometry`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics I: Analytic geometry`,
        },
        topic_exercise_x6bf124c0f261dae3: {
            description: t`Mathematics I: Analytic geometry (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics I: Analytic geometry (old)`,
        },
        topic_exercise_xecb244817b2540b4_mastery: {
            description: t`Mathematics I: Congruence`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics I: Congruence`,
        },
        topic_exercise_xecb244817b2540b4: {
            description: t`Mathematics I: Congruence (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics I: Congruence (old)`,
        },
        topic_exercise_x8c16611a0633fc1d_mastery: {
            description: t`Mathematics I: Data distributions`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics I: Data distributions`,
        },
        topic_exercise_x8c16611a0633fc1d: {
            description: t`Mathematics I: Data distributions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics I: Data distributions (old)`,
        },
        topic_exercise_x2228c6b346ff02df_mastery: {
            description: t`Mathematics I: Exponential growth & decay`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics I: Exponential growth & decay`,
        },
        topic_exercise_x2228c6b346ff02df: {
            description: t`Mathematics I: Exponential growth & decay (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics I: Exponential growth & decay (old)`,
        },
        topic_exercise_x8ceb9fb5f9c40aaf_mastery: {
            description: t`Mathematics I: Exponents & radicals`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics I: Exponents & radicals`,
        },
        topic_exercise_x8ceb9fb5f9c40aaf: {
            description: t`Mathematics I: Exponents & radicals (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics I: Exponents & radicals (old)`,
        },
        topic_exercise_x144ad327f5e4f4e9_mastery: {
            description: t`Mathematics I: Forms of linear equations`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics I: Forms of linear equations`,
        },
        topic_exercise_x144ad327f5e4f4e9: {
            description: t`Mathematics I: Forms of linear equations (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics I: Forms of linear equations (old)`,
        },
        topic_exercise_x4c7431cdee59fade_mastery: {
            description: t`Mathematics I: Functions`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics I: Functions`,
        },
        topic_exercise_x4c7431cdee59fade: {
            description: t`Mathematics I: Functions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics I: Functions (old)`,
        },
        topic_exercise_x191e0058bae6ef53_mastery: {
            description: t`Mathematics I: Geometry transformations`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics I: Geometry transformations`,
        },
        topic_exercise_x191e0058bae6ef53: {
            description: t`Mathematics I: Geometry transformations (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics I: Geometry transformations (old)`,
        },
        topic_exercise_xfad652d5b368c7b6_mastery: {
            description: t`Mathematics I: Inequalities (systems & graphs)`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics I: Inequalities (systems & graphs)`,
        },
        topic_exercise_xfad652d5b368c7b6: {
            description: t`Mathematics I: Inequalities (systems & graphs) (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics I: Inequalities (systems & graphs) (old)`,
        },
        topic_exercise_xec3d8f107467dc53_mastery: {
            description: t`Mathematics I: Linear equations & graphs`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics I: Linear equations & graphs`,
        },
        topic_exercise_xec3d8f107467dc53: {
            description: t`Mathematics I: Linear equations & graphs (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics I: Linear equations & graphs (old)`,
        },
        topic_exercise_x58dd42e67c7c2248_mastery: {
            description: t`Mathematics I: Scatterplots`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics I: Scatterplots`,
        },
        topic_exercise_x58dd42e67c7c2248: {
            description: t`Mathematics I: Scatterplots (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics I: Scatterplots (old)`,
        },
        topic_exercise_x7523c98f_mastery: {
            description: t`Mathematics I: Seeing structure in expressions`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics I: Seeing structure in expressions`,
        },
        topic_exercise_x7523c98f: {
            description: t`Mathematics I: Seeing structure in expressions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics I: Seeing structure in expressions (old)`,
        },
        topic_exercise_x32cb60b2cd0c09d9_mastery: {
            description: t`Mathematics I: Sequences`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics I: Sequences`,
        },
        topic_exercise_x32cb60b2cd0c09d9: {
            description: t`Mathematics I: Sequences (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics I: Sequences (old)`,
        },
        topic_exercise_x67ef039f85390f69_mastery: {
            description: t`Mathematics I: Solving equations & inequalities`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics I: Solving equations & inequalities`,
        },
        topic_exercise_x67ef039f85390f69: {
            description: t`Mathematics I: Solving equations & inequalities (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics I: Solving equations & inequalities (old)`,
        },
        topic_exercise_xe8cf4168a6802ec1_mastery: {
            description: t`Mathematics I: Systems of equations`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics I: Systems of equations`,
        },
        topic_exercise_xe8cf4168a6802ec1: {
            description: t`Mathematics I: Systems of equations (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics I: Systems of equations (old)`,
        },
        topic_exercise_xd066cc4c726e4f14_mastery: {
            description: t`Mathematics I: Two-way tables`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics I: Two-way tables`,
        },
        topic_exercise_xd066cc4c726e4f14: {
            description: t`Mathematics I: Two-way tables (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics I: Two-way tables (old)`,
        },
        topic_exercise_x3fd5c72337aceff5_mastery: {
            description: t`Mathematics I: Working with units`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics I: Working with units`,
        },
        topic_exercise_x3fd5c72337aceff5: {
            description: t`Mathematics I: Working with units (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics I: Working with units (old)`,
        },
        topic_exercise_x6e38d8af_mastery: {
            description: t`Mathematics II (2018 edition): Absolute value & piecewise functions`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics II (2018 edition): Absolute value & piecewise functions`,
        },
        topic_exercise_x6e38d8af: {
            description: t`Mathematics II (2018 edition): Absolute value & piecewise functions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics II (2018 edition): Absolute value & piecewise functions (old)`,
        },
        topic_exercise_x751f3af5_mastery: {
            description: t`Mathematics II (2018 edition): Circles`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics II (2018 edition): Circles`,
        },
        topic_exercise_x751f3af5: {
            description: t`Mathematics II (2018 edition): Circles (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics II (2018 edition): Circles (old)`,
        },
        topic_exercise_xea2655a7_mastery: {
            description: t`Mathematics II (2018 edition): Complex numbers`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics II (2018 edition): Complex numbers`,
        },
        topic_exercise_xea2655a7: {
            description: t`Mathematics II (2018 edition): Complex numbers (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics II (2018 edition): Complex numbers (old)`,
        },
        topic_exercise_xfedeea5e_mastery: {
            description: t`Mathematics II (2018 edition): Conic sections`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics II (2018 edition): Conic sections`,
        },
        topic_exercise_xfedeea5e: {
            description: t`Mathematics II (2018 edition): Conic sections (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics II (2018 edition): Conic sections (old)`,
        },
        topic_exercise_x222a66cb_mastery: {
            description: t`Mathematics II (2018 edition): Exponential growth & decay`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics II (2018 edition): Exponential growth & decay`,
        },
        topic_exercise_x222a66cb: {
            description: t`Mathematics II (2018 edition): Exponential growth & decay (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics II (2018 edition): Exponential growth & decay (old)`,
        },
        topic_exercise_x0324074a_mastery: {
            description: t`Mathematics II (2018 edition): Factorization`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics II (2018 edition): Factorization`,
        },
        topic_exercise_x0324074a: {
            description: t`Mathematics II (2018 edition): Factorization (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics II (2018 edition): Factorization (old)`,
        },
        topic_exercise_x02afcefc_mastery: {
            description: t`Mathematics II (2018 edition): Irrational numbers`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics II (2018 edition): Irrational numbers`,
        },
        topic_exercise_x02afcefc: {
            description: t`Mathematics II (2018 edition): Irrational numbers (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics II (2018 edition): Irrational numbers (old)`,
        },
        topic_exercise_xf925c24f_mastery: {
            description: t`Mathematics II (2018 edition): Modeling with algebra`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics II (2018 edition): Modeling with algebra`,
        },
        topic_exercise_xf925c24f: {
            description: t`Mathematics II (2018 edition): Modeling with algebra (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics II (2018 edition): Modeling with algebra (old)`,
        },
        topic_exercise_x75f7d943_mastery: {
            description: t`Mathematics II (2018 edition): Polynomials`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics II (2018 edition): Polynomials`,
        },
        topic_exercise_x75f7d943: {
            description: t`Mathematics II (2018 edition): Polynomials (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics II (2018 edition): Polynomials (old)`,
        },
        topic_exercise_xdb324519_mastery: {
            description: t`Mathematics II (2018 edition): Probability`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics II (2018 edition): Probability`,
        },
        topic_exercise_xdb324519: {
            description: t`Mathematics II (2018 edition): Probability (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics II (2018 edition): Probability (old)`,
        },
        topic_exercise_x569f470d_mastery: {
            description: t`Mathematics II (2018 edition): Quadratics`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics II (2018 edition): Quadratics`,
        },
        topic_exercise_x569f470d: {
            description: t`Mathematics II (2018 edition): Quadratics (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics II (2018 edition): Quadratics (old)`,
        },
        topic_exercise_xdb875123_mastery: {
            description: t`Mathematics II (2018 edition): Right triangles & trigonometry`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics II (2018 edition): Right triangles & trigonometry`,
        },
        topic_exercise_xdb875123: {
            description: t`Mathematics II (2018 edition): Right triangles & trigonometry (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics II (2018 edition): Right triangles & trigonometry (old)`,
        },
        topic_exercise_xfe536775_mastery: {
            description: t`Mathematics II (2018 edition): Similarity`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics II (2018 edition): Similarity`,
        },
        topic_exercise_xfe536775: {
            description: t`Mathematics II (2018 edition): Similarity (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics II (2018 edition): Similarity (old)`,
        },
        topic_exercise_xccf7a696_mastery: {
            description: t`Mathematics II (2018 edition): Solid geometry`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics II (2018 edition): Solid geometry`,
        },
        topic_exercise_xccf7a696: {
            description: t`Mathematics II (2018 edition): Solid geometry (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics II (2018 edition): Solid geometry (old)`,
        },
        topic_exercise_xb7b79f3599a86d11_mastery: {
            description: t`Mathematics II: Absolute value & piecewise functions`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics II: Absolute value & piecewise functions`,
        },
        topic_exercise_xb7b79f3599a86d11: {
            description: t`Mathematics II: Absolute value & piecewise functions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics II: Absolute value & piecewise functions (old)`,
        },
        topic_exercise_xa0cd65ce718d67a9_mastery: {
            description: t`Mathematics II: Circles`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics II: Circles`,
        },
        topic_exercise_xa0cd65ce718d67a9: {
            description: t`Mathematics II: Circles (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics II: Circles (old)`,
        },
        topic_exercise_x5e05ab0c221d98de_mastery: {
            description: t`Mathematics II: Complex numbers`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics II: Complex numbers`,
        },
        topic_exercise_x5e05ab0c221d98de: {
            description: t`Mathematics II: Complex numbers (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics II: Complex numbers (old)`,
        },
        topic_exercise_xec0df58e93f69ce2_mastery: {
            description: t`Mathematics II: Conic sections`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics II: Conic sections`,
        },
        topic_exercise_xec0df58e93f69ce2: {
            description: t`Mathematics II: Conic sections (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics II: Conic sections (old)`,
        },
        topic_exercise_x1fc8cbee2c4ef859_mastery: {
            description: t`Mathematics II: Exponential models`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics II: Exponential models`,
        },
        topic_exercise_x1fc8cbee2c4ef859: {
            description: t`Mathematics II: Exponential models (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics II: Exponential models (old)`,
        },
        topic_exercise_xa119235a94fbe169_mastery: {
            description: t`Mathematics II: Irrational numbers`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics II: Irrational numbers`,
        },
        topic_exercise_xa119235a94fbe169: {
            description: t`Mathematics II: Irrational numbers (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics II: Irrational numbers (old)`,
        },
        topic_exercise_xb6e5d30597fbb28e_mastery: {
            description: t`Mathematics II: Probability`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics II: Probability`,
        },
        topic_exercise_xb6e5d30597fbb28e: {
            description: t`Mathematics II: Probability (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics II: Probability (old)`,
        },
        topic_exercise_xbc4f062d4b33dcbf_mastery: {
            description: t`Mathematics II: Quadratic functions & equations`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics II: Quadratic functions & equations`,
        },
        topic_exercise_xbc4f062d4b33dcbf: {
            description: t`Mathematics II: Quadratic functions & equations (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics II: Quadratic functions & equations (old)`,
        },
        topic_exercise_xf7c07f4c4a922649_mastery: {
            description: t`Mathematics II: Quadratics: Multiplying & factoring`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics II: Quadratics: Multiplying & factoring`,
        },
        topic_exercise_xf7c07f4c4a922649: {
            description: t`Mathematics II: Quadratics: Multiplying & factoring (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics II: Quadratics: Multiplying & factoring (old)`,
        },
        topic_exercise_xa721abf1d8020003_mastery: {
            description: t`Mathematics II: Rational exponents and radicals`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics II: Rational exponents and radicals`,
        },
        topic_exercise_xa721abf1d8020003: {
            description: t`Mathematics II: Rational exponents and radicals (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics II: Rational exponents and radicals (old)`,
        },
        topic_exercise_x8e670fcf8a2e44f5_mastery: {
            description: t`Mathematics II: Right triangles & trigonometry`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics II: Right triangles & trigonometry`,
        },
        topic_exercise_x8e670fcf8a2e44f5: {
            description: t`Mathematics II: Right triangles & trigonometry (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics II: Right triangles & trigonometry (old)`,
        },
        topic_exercise_xc88f7c09d4385a23_mastery: {
            description: t`Mathematics II: Similarity`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics II: Similarity`,
        },
        topic_exercise_xc88f7c09d4385a23: {
            description: t`Mathematics II: Similarity (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics II: Similarity (old)`,
        },
        topic_exercise_x0545291ac689c644_mastery: {
            description: t`Mathematics II: Solid geometry`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics II: Solid geometry`,
        },
        topic_exercise_x0545291ac689c644: {
            description: t`Mathematics II: Solid geometry (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics II: Solid geometry (old)`,
        },
        topic_exercise_xbc631b5d_mastery: {
            description: t`Mathematics III (2018 edition): Advanced equations & functions`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics III (2018 edition): Advanced equations & functions`,
        },
        topic_exercise_xbc631b5d: {
            description: t`Mathematics III (2018 edition): Advanced equations & functions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics III (2018 edition): Advanced equations & functions (old)`,
        },
        topic_exercise_xf486bed1_mastery: {
            description: t`Mathematics III (2018 edition): Exponentials & logarithms`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics III (2018 edition): Exponentials & logarithms`,
        },
        topic_exercise_xf486bed1: {
            description: t`Mathematics III (2018 edition): Exponentials & logarithms (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics III (2018 edition): Exponentials & logarithms (old)`,
        },
        topic_exercise_xefb38e83_mastery: {
            description: t`Mathematics III (2018 edition): Functions`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics III (2018 edition): Functions`,
        },
        topic_exercise_xefb38e83: {
            description: t`Mathematics III (2018 edition): Functions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics III (2018 edition): Functions (old)`,
        },
        topic_exercise_x569bc476_mastery: {
            description: t`Mathematics III (2018 edition): Normal distributions`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics III (2018 edition): Normal distributions`,
        },
        topic_exercise_x569bc476: {
            description: t`Mathematics III (2018 edition): Normal distributions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics III (2018 edition): Normal distributions (old)`,
        },
        topic_exercise_xa6c1ce5e_mastery: {
            description: t`Mathematics III (2018 edition): Polynomials`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics III (2018 edition): Polynomials`,
        },
        topic_exercise_xa6c1ce5e: {
            description: t`Mathematics III (2018 edition): Polynomials (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics III (2018 edition): Polynomials (old)`,
        },
        topic_exercise_xc464e6e6_mastery: {
            description: t`Mathematics III (2018 edition): Radical relationships`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics III (2018 edition): Radical relationships`,
        },
        topic_exercise_xc464e6e6: {
            description: t`Mathematics III (2018 edition): Radical relationships (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics III (2018 edition): Radical relationships (old)`,
        },
        topic_exercise_xaebe04f9_mastery: {
            description: t`Mathematics III (2018 edition): Rational relationships`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics III (2018 edition): Rational relationships`,
        },
        topic_exercise_xaebe04f9: {
            description: t`Mathematics III (2018 edition): Rational relationships (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics III (2018 edition): Rational relationships (old)`,
        },
        topic_exercise_xe5c48098_mastery: {
            description: t`Mathematics III (2018 edition): Series`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics III (2018 edition): Series`,
        },
        topic_exercise_xe5c48098: {
            description: t`Mathematics III (2018 edition): Series (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics III (2018 edition): Series (old)`,
        },
        topic_exercise_x2209e410_mastery: {
            description: t`Mathematics III (2018 edition): Study Design`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics III (2018 edition): Study Design`,
        },
        topic_exercise_x2209e410: {
            description: t`Mathematics III (2018 edition): Study Design (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics III (2018 edition): Study Design (old)`,
        },
        topic_exercise_x8dada038_mastery: {
            description: t`Mathematics III (2018 edition): Trigonometry`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics III (2018 edition): Trigonometry`,
        },
        topic_exercise_x8dada038: {
            description: t`Mathematics III (2018 edition): Trigonometry (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics III (2018 edition): Trigonometry (old)`,
        },
        topic_exercise_xf6f25e885978912c_mastery: {
            description: t`Mathematics III: Equations`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics III: Equations`,
        },
        topic_exercise_xf6f25e885978912c: {
            description: t`Mathematics III: Equations (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics III: Equations (old)`,
        },
        topic_exercise_xeb87b0b07d0f1509_mastery: {
            description: t`Mathematics III: Logarithms`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics III: Logarithms`,
        },
        topic_exercise_xeb87b0b07d0f1509: {
            description: t`Mathematics III: Logarithms (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics III: Logarithms (old)`,
        },
        topic_exercise_xd4f4fbf0f33dcd24_mastery: {
            description: t`Mathematics III: Modeling`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics III: Modeling`,
        },
        topic_exercise_xd4f4fbf0f33dcd24: {
            description: t`Mathematics III: Modeling (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics III: Modeling (old)`,
        },
        topic_exercise_xcbd05d4b96727054_mastery: {
            description: t`Mathematics III: Normal distributions`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics III: Normal distributions`,
        },
        topic_exercise_xcbd05d4b96727054: {
            description: t`Mathematics III: Normal distributions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics III: Normal distributions (old)`,
        },
        topic_exercise_xc32c6dc569907339_mastery: {
            description: t`Mathematics III: Polynomial arithmetic`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics III: Polynomial arithmetic`,
        },
        topic_exercise_xc32c6dc569907339: {
            description: t`Mathematics III: Polynomial arithmetic (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics III: Polynomial arithmetic (old)`,
        },
        topic_exercise_x17862b3a0e1d150e_mastery: {
            description: t`Mathematics III: Polynomial division`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics III: Polynomial division`,
        },
        topic_exercise_x17862b3a0e1d150e: {
            description: t`Mathematics III: Polynomial division (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics III: Polynomial division (old)`,
        },
        topic_exercise_x32e4ea656e28b31c_mastery: {
            description: t`Mathematics III: Polynomial factorization`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics III: Polynomial factorization`,
        },
        topic_exercise_x32e4ea656e28b31c: {
            description: t`Mathematics III: Polynomial factorization (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics III: Polynomial factorization (old)`,
        },
        topic_exercise_x64bd783b4d7b4aed_mastery: {
            description: t`Mathematics III: Polynomial graphs`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics III: Polynomial graphs`,
        },
        topic_exercise_x64bd783b4d7b4aed: {
            description: t`Mathematics III: Polynomial graphs (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics III: Polynomial graphs (old)`,
        },
        topic_exercise_x455a49ec439bd41a_mastery: {
            description: t`Mathematics III: Rational functions`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics III: Rational functions`,
        },
        topic_exercise_x455a49ec439bd41a: {
            description: t`Mathematics III: Rational functions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics III: Rational functions (old)`,
        },
        topic_exercise_x7cf4eaa2af89bc4c_mastery: {
            description: t`Mathematics III: Study Design`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics III: Study Design`,
        },
        topic_exercise_x7cf4eaa2af89bc4c: {
            description: t`Mathematics III: Study Design (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics III: Study Design (old)`,
        },
        topic_exercise_x6a5c4c39e6245744_mastery: {
            description: t`Mathematics III: Transformations of functions`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics III: Transformations of functions`,
        },
        topic_exercise_x6a5c4c39e6245744: {
            description: t`Mathematics III: Transformations of functions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics III: Transformations of functions (old)`,
        },
        topic_exercise_x1dcd590fd00daa99_mastery: {
            description: t`Mathematics III: Trigonometry`,
            extendedDescription: t`Achieve mastery in all skills in Mathematics III: Trigonometry`,
        },
        topic_exercise_x1dcd590fd00daa99: {
            description: t`Mathematics III: Trigonometry (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Mathematics III: Trigonometry (old)`,
        },
        topic_exercise_Zv8WviCc8VDcqB2RRNep_WsgtuWyb0oR4P2bFALF_mastery: {
            description: t`Matrices`,
            extendedDescription: t`Achieve mastery in all skills in Matrices`,
        },
        topic_exercise_x6db71967_mastery: {
            description: t`Matrices`,
            extendedDescription: t`Achieve mastery in all skills in Matrices`,
        },
        topic_exercise_Zv8WviCc8VDcqB2RRNep_WsgtuWyb0oR4P2bFALF: {
            description: t`Matrices (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Matrices (old)`,
        },
        topic_exercise_x6db71967: {
            description: t`Matrices (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Matrices (old)`,
        },
        topic_exercise_xd096915e_mastery: {
            description: t`Multiplication and division`,
            extendedDescription: t`Achieve mastery in all skills in Multiplication and division`,
        },
        topic_exercise_xd096915e: {
            description: t`Multiplication and division (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Multiplication and division (old)`,
        },
        "topic_exercise_41UMP8yjk1WR-E2TlWcwzJ46HPenQDyqeSCieYO8_mastery": {
            description: t`Negative numbers`,
            extendedDescription: t`Achieve mastery in all skills in Negative numbers`,
        },
        "topic_exercise_41UMP8yjk1WR-E2TlWcwzJ46HPenQDyqeSCieYO8": {
            description: t`Negative numbers (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Negative numbers (old)`,
        },
        topic_exercise_xa359f5de_mastery: {
            description: t`Negative numbers and absolute value`,
            extendedDescription: t`Achieve mastery in all skills in Negative numbers and absolute value`,
        },
        topic_exercise_xa359f5de: {
            description: t`Negative numbers and absolute value (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Negative numbers and absolute value (old)`,
        },
        "topic_exercise_serArSUyybtXT_ZAmIf_2bE-jIA6wEDwATz67H8j_mastery": {
            description: t`New Topic`,
            extendedDescription: t`Achieve mastery in all skills in New Topic`,
        },
        "topic_exercise_serArSUyybtXT_ZAmIf_2bE-jIA6wEDwATz67H8j": {
            description: t`New Topic (old)`,
            extendedDescription: t`Achieve proficiency in all skills in New Topic (old)`,
        },
        topic_exercise_MN1_eIthLBebQwHafWTS2_w0WpNFFwp8DiT7lE6l_mastery: {
            description: t`Number properties`,
            extendedDescription: t`Achieve mastery in all skills in Number properties`,
        },
        topic_exercise_MN1_eIthLBebQwHafWTS2_w0WpNFFwp8DiT7lE6l: {
            description: t`Number properties (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Number properties (old)`,
        },
        topic_exercise_E77BgovF2uX8uyzY5dIiY8ZdVXzd4Bw1WYITXvmn_mastery: {
            description: t`Percents (deprecated)`,
            extendedDescription: t`Achieve mastery in all skills in Percents (deprecated)`,
        },
        topic_exercise_E77BgovF2uX8uyzY5dIiY8ZdVXzd4Bw1WYITXvmn: {
            description: t`Percents (deprecated) (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Percents (deprecated) (old)`,
        },
        topic_exercise_x733a047e_mastery: {
            description: t`Perimeter, area and volume`,
            extendedDescription: t`Achieve mastery in all skills in Perimeter, area and volume`,
        },
        topic_exercise_x733a047e: {
            description: t`Perimeter, area and volume (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Perimeter, area and volume (old)`,
        },
        topic_exercise_5EyYE3qnXijHozyNRpHHONuybikxP0EhShMeA6z__mastery: {
            description: t`Points, lines, and planes`,
            extendedDescription: t`Achieve mastery in all skills in Points, lines, and planes`,
        },
        topic_exercise_x4bdfeb75_mastery: {
            description: t`Points, lines, and planes`,
            extendedDescription: t`Achieve mastery in all skills in Points, lines, and planes`,
        },
        topic_exercise_5EyYE3qnXijHozyNRpHHONuybikxP0EhShMeA6z_: {
            description: t`Points, lines, and planes (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Points, lines, and planes (old)`,
        },
        topic_exercise_x4bdfeb75: {
            description: t`Points, lines, and planes (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Points, lines, and planes (old)`,
        },
        "topic_exercise_v4ml7UheFl91Kmr5_XKKmmGOcFKEhL1kIp-f_yzQ_mastery": {
            description: t`Polygons, quadrilaterals, parallelograms`,
            extendedDescription: t`Achieve mastery in all skills in Polygons, quadrilaterals, parallelograms`,
        },
        "topic_exercise_v4ml7UheFl91Kmr5_XKKmmGOcFKEhL1kIp-f_yzQ": {
            description: t`Polygons, quadrilaterals, parallelograms (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Polygons, quadrilaterals, parallelograms (old)`,
        },
        "topic_exercise_3vJ8-Fd78I9nW6O0p64JfDGdtieKP2hYXRcczyZu_mastery": {
            description: t`Polynomials`,
            extendedDescription: t`Achieve mastery in all skills in Polynomials`,
        },
        topic_exercise_XPlK0iMemAN1Cs5FwRB0SWeF_d7_m0iT2l5j4bmE_mastery: {
            description: t`Polynomials`,
            extendedDescription: t`Achieve mastery in all skills in Polynomials`,
        },
        topic_exercise_x4bafbcd5_mastery: {
            description: t`Polynomials`,
            extendedDescription: t`Achieve mastery in all skills in Polynomials`,
        },
        "topic_exercise_3vJ8-Fd78I9nW6O0p64JfDGdtieKP2hYXRcczyZu": {
            description: t`Polynomials (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Polynomials (old)`,
        },
        topic_exercise_XPlK0iMemAN1Cs5FwRB0SWeF_d7_m0iT2l5j4bmE: {
            description: t`Polynomials (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Polynomials (old)`,
        },
        topic_exercise_x4bafbcd5: {
            description: t`Polynomials (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Polynomials (old)`,
        },
        topic_exercise_N5N8pHbWmakbB3XygvnJivtfHLFMPt4NE2PQgnsw_mastery: {
            description: t`Polynomials and quadratics`,
            extendedDescription: t`Achieve mastery in all skills in Polynomials and quadratics`,
        },
        topic_exercise_N5N8pHbWmakbB3XygvnJivtfHLFMPt4NE2PQgnsw: {
            description: t`Polynomials and quadratics (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Polynomials and quadratics (old)`,
        },
        "topic_exercise_RI8OP2UGDWg4yInmvxpjvPJFv8-nz_KSqdRKwLhL_mastery": {
            description: t`Pre-algebra: Applying mathematical reasoning`,
            extendedDescription: t`Achieve mastery in all skills in Pre-algebra: Applying mathematical reasoning`,
        },
        "topic_exercise_RI8OP2UGDWg4yInmvxpjvPJFv8-nz_KSqdRKwLhL": {
            description: t`Pre-algebra: Applying mathematical reasoning (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Pre-algebra: Applying mathematical reasoning (old)`,
        },
        topic_exercise_XrktPu74_wbKu_89ocp_AJFmuV0pYodt0QnFR1Ab_mastery: {
            description: t`Pre-algebra: Arithmetic properties`,
            extendedDescription: t`Achieve mastery in all skills in Pre-algebra: Arithmetic properties`,
        },
        topic_exercise_x16b067c9_mastery: {
            description: t`Pre-algebra: Arithmetic properties`,
            extendedDescription: t`Achieve mastery in all skills in Pre-algebra: Arithmetic properties`,
        },
        topic_exercise_XrktPu74_wbKu_89ocp_AJFmuV0pYodt0QnFR1Ab: {
            description: t`Pre-algebra: Arithmetic properties (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Pre-algebra: Arithmetic properties (old)`,
        },
        topic_exercise_x16b067c9: {
            description: t`Pre-algebra: Arithmetic properties (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Pre-algebra: Arithmetic properties (old)`,
        },
        topic_exercise_x76ac7fc5_mastery: {
            description: t`Pre-algebra: Decimals`,
            extendedDescription: t`Achieve mastery in all skills in Pre-algebra: Decimals`,
        },
        topic_exercise_xcd755b70_mastery: {
            description: t`Pre-algebra: Decimals`,
            extendedDescription: t`Achieve mastery in all skills in Pre-algebra: Decimals`,
        },
        topic_exercise_x76ac7fc5: {
            description: t`Pre-algebra: Decimals (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Pre-algebra: Decimals (old)`,
        },
        topic_exercise_xcd755b70: {
            description: t`Pre-algebra: Decimals (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Pre-algebra: Decimals (old)`,
        },
        topic_exercise_x04908aa2_mastery: {
            description: t`Pre-algebra: Equations, expressions, and inequalities `,
            extendedDescription: t`Achieve mastery in all skills in Pre-algebra: Equations, expressions, and inequalities `,
        },
        topic_exercise_x04908aa2: {
            description: t`Pre-algebra: Equations, expressions, and inequalities  (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Pre-algebra: Equations, expressions, and inequalities  (old)`,
        },
        topic_exercise_MPdFDRjecgRDdWiCSi0t8Nak4vCyLeZrmU8Uy1a4_mastery: {
            description: t`Pre-algebra: Exponents, radicals, and scientific notation`,
            extendedDescription: t`Achieve mastery in all skills in Pre-algebra: Exponents, radicals, and scientific notation`,
        },
        topic_exercise_x2251cb4b_mastery: {
            description: t`Pre-algebra: Exponents, radicals, and scientific notation`,
            extendedDescription: t`Achieve mastery in all skills in Pre-algebra: Exponents, radicals, and scientific notation`,
        },
        topic_exercise_MPdFDRjecgRDdWiCSi0t8Nak4vCyLeZrmU8Uy1a4: {
            description: t`Pre-algebra: Exponents, radicals, and scientific notation (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Pre-algebra: Exponents, radicals, and scientific notation (old)`,
        },
        topic_exercise_x2251cb4b: {
            description: t`Pre-algebra: Exponents, radicals, and scientific notation (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Pre-algebra: Exponents, radicals, and scientific notation (old)`,
        },
        "topic_exercise_sKjw8V-WXbRYuuomASZQ5frgIw26JwZwK9yjuMdv_mastery": {
            description: t`Pre-algebra: Factors and multiples`,
            extendedDescription: t`Achieve mastery in all skills in Pre-algebra: Factors and multiples`,
        },
        topic_exercise_xa9d6fdff_mastery: {
            description: t`Pre-algebra: Factors and multiples`,
            extendedDescription: t`Achieve mastery in all skills in Pre-algebra: Factors and multiples`,
        },
        "topic_exercise_sKjw8V-WXbRYuuomASZQ5frgIw26JwZwK9yjuMdv": {
            description: t`Pre-algebra: Factors and multiples (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Pre-algebra: Factors and multiples (old)`,
        },
        topic_exercise_xa9d6fdff: {
            description: t`Pre-algebra: Factors and multiples (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Pre-algebra: Factors and multiples (old)`,
        },
        topic_exercise_xa64600f9_mastery: {
            description: t`Pre-algebra: Fractions`,
            extendedDescription: t`Achieve mastery in all skills in Pre-algebra: Fractions`,
        },
        topic_exercise_xa64600f9: {
            description: t`Pre-algebra: Fractions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Pre-algebra: Fractions (old)`,
        },
        topic_exercise_x1d64bc3f_mastery: {
            description: t`Pre-algebra: Fractions `,
            extendedDescription: t`Achieve mastery in all skills in Pre-algebra: Fractions `,
        },
        topic_exercise_x1d64bc3f: {
            description: t`Pre-algebra: Fractions  (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Pre-algebra: Fractions  (old)`,
        },
        topic_exercise_xc850a7c9_mastery: {
            description: t`Pre-algebra: Measurement`,
            extendedDescription: t`Achieve mastery in all skills in Pre-algebra: Measurement`,
        },
        topic_exercise_xcaacb86d_mastery: {
            description: t`Pre-algebra: Measurement`,
            extendedDescription: t`Achieve mastery in all skills in Pre-algebra: Measurement`,
        },
        topic_exercise_xc850a7c9: {
            description: t`Pre-algebra: Measurement (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Pre-algebra: Measurement (old)`,
        },
        topic_exercise_xcaacb86d: {
            description: t`Pre-algebra: Measurement (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Pre-algebra: Measurement (old)`,
        },
        topic_exercise_x8fd51ad5_mastery: {
            description: t`Pre-algebra: Negative numbers and absolute value`,
            extendedDescription: t`Achieve mastery in all skills in Pre-algebra: Negative numbers and absolute value`,
        },
        topic_exercise_x8fd51ad5: {
            description: t`Pre-algebra: Negative numbers and absolute value (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Pre-algebra: Negative numbers and absolute value (old)`,
        },
        topic_exercise_x4ba15d90_mastery: {
            description: t`Pre-algebra: Negative numbers and coordinate plane `,
            extendedDescription: t`Achieve mastery in all skills in Pre-algebra: Negative numbers and coordinate plane `,
        },
        topic_exercise_x4ba15d90: {
            description: t`Pre-algebra: Negative numbers and coordinate plane  (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Pre-algebra: Negative numbers and coordinate plane  (old)`,
        },
        topic_exercise_LjZH9OiVLkOOeF4QDuyKlI1QzI8U9dRelqF81GWH_mastery: {
            description: t`Pre-algebra: Ratios, proportions, units, and rates`,
            extendedDescription: t`Achieve mastery in all skills in Pre-algebra: Ratios, proportions, units, and rates`,
        },
        topic_exercise_LjZH9OiVLkOOeF4QDuyKlI1QzI8U9dRelqF81GWH: {
            description: t`Pre-algebra: Ratios, proportions, units, and rates (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Pre-algebra: Ratios, proportions, units, and rates (old)`,
        },
        topic_exercise_x17923675_mastery: {
            description: t`Pre-algebra: Ratios, rates, proportions`,
            extendedDescription: t`Achieve mastery in all skills in Pre-algebra: Ratios, rates, proportions`,
        },
        topic_exercise_x17923675: {
            description: t`Pre-algebra: Ratios, rates, proportions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Pre-algebra: Ratios, rates, proportions (old)`,
        },
        topic_exercise_x1f72b5ec_mastery: {
            description: t`Pre-algebra: Reading and interpreting data`,
            extendedDescription: t`Achieve mastery in all skills in Pre-algebra: Reading and interpreting data`,
        },
        topic_exercise_x1f72b5ec: {
            description: t`Pre-algebra: Reading and interpreting data (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Pre-algebra: Reading and interpreting data (old)`,
        },
        "topic_exercise_aVZ2rq1MaoC4-dqU3QmWQhIBAPNXERZd-94dzIZb_mastery": {
            description: t`Precalculus`,
            extendedDescription: t`Achieve mastery in all skills in Precalculus`,
        },
        "topic_exercise_aVZ2rq1MaoC4-dqU3QmWQhIBAPNXERZd-94dzIZb": {
            description: t`Precalculus (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Precalculus (old)`,
        },
        topic_exercise_x1dd60c20_mastery: {
            description: t`Precalculus (2018 edition): Complex numbers`,
            extendedDescription: t`Achieve mastery in all skills in Precalculus (2018 edition): Complex numbers`,
        },
        topic_exercise_x1dd60c20: {
            description: t`Precalculus (2018 edition): Complex numbers (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Precalculus (2018 edition): Complex numbers (old)`,
        },
        topic_exercise_xb61c639c_mastery: {
            description: t`Precalculus (2018 edition): Conic sections`,
            extendedDescription: t`Achieve mastery in all skills in Precalculus (2018 edition): Conic sections`,
        },
        topic_exercise_xb61c639c: {
            description: t`Precalculus (2018 edition): Conic sections (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Precalculus (2018 edition): Conic sections (old)`,
        },
        topic_exercise_6bC0m9ja2A2HkigamOt2wtvNjs_t257wXPPNFEs8_mastery: {
            description: t`Precalculus (2018 edition): Matrices`,
            extendedDescription: t`Achieve mastery in all skills in Precalculus (2018 edition): Matrices`,
        },
        topic_exercise_6bC0m9ja2A2HkigamOt2wtvNjs_t257wXPPNFEs8: {
            description: t`Precalculus (2018 edition): Matrices (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Precalculus (2018 edition): Matrices (old)`,
        },
        topic_exercise_x1af1e2a6_mastery: {
            description: t`Precalculus (2018 edition): Probability and combinatorics`,
            extendedDescription: t`Achieve mastery in all skills in Precalculus (2018 edition): Probability and combinatorics`,
        },
        topic_exercise_x1af1e2a6: {
            description: t`Precalculus (2018 edition): Probability and combinatorics (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Precalculus (2018 edition): Probability and combinatorics (old)`,
        },
        topic_exercise_xef1dc391_mastery: {
            description: t`Precalculus (2018 edition): Series`,
            extendedDescription: t`Achieve mastery in all skills in Precalculus (2018 edition): Series`,
        },
        topic_exercise_xef1dc391: {
            description: t`Precalculus (2018 edition): Series (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Precalculus (2018 edition): Series (old)`,
        },
        topic_exercise_xb7335d47_mastery: {
            description: t`Precalculus (2018 edition): Trigonometry`,
            extendedDescription: t`Achieve mastery in all skills in Precalculus (2018 edition): Trigonometry`,
        },
        topic_exercise_xb7335d47: {
            description: t`Precalculus (2018 edition): Trigonometry (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Precalculus (2018 edition): Trigonometry (old)`,
        },
        topic_exercise_x8dd62d07_mastery: {
            description: t`Precalculus (2018 edition): Vectors`,
            extendedDescription: t`Achieve mastery in all skills in Precalculus (2018 edition): Vectors`,
        },
        topic_exercise_x8dd62d07: {
            description: t`Precalculus (2018 edition): Vectors (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Precalculus (2018 edition): Vectors (old)`,
        },
        topic_exercise_x2eac05a991f3daf7_mastery: {
            description: t`Precalculus: Complex numbers`,
            extendedDescription: t`Achieve mastery in all skills in Precalculus: Complex numbers`,
        },
        topic_exercise_x2eac05a991f3daf7: {
            description: t`Precalculus: Complex numbers (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Precalculus: Complex numbers (old)`,
        },
        topic_exercise_x73a692e3fa3a7e21_mastery: {
            description: t`Precalculus: Composite functions`,
            extendedDescription: t`Achieve mastery in all skills in Precalculus: Composite functions`,
        },
        topic_exercise_x73a692e3fa3a7e21: {
            description: t`Precalculus: Composite functions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Precalculus: Composite functions (old)`,
        },
        topic_exercise_x1b174b48ff8c5152_mastery: {
            description: t`Precalculus: Conic sections`,
            extendedDescription: t`Achieve mastery in all skills in Precalculus: Conic sections`,
        },
        topic_exercise_x1b174b48ff8c5152: {
            description: t`Precalculus: Conic sections (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Precalculus: Conic sections (old)`,
        },
        topic_exercise_x3f5028ed_mastery: {
            description: t`Precalculus: Hyperbolic functions`,
            extendedDescription: t`Achieve mastery in all skills in Precalculus: Hyperbolic functions`,
        },
        topic_exercise_x3f5028ed: {
            description: t`Precalculus: Hyperbolic functions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Precalculus: Hyperbolic functions (old)`,
        },
        topic_exercise_xccdba2de_mastery: {
            description: t`Precalculus: Limits`,
            extendedDescription: t`Achieve mastery in all skills in Precalculus: Limits`,
        },
        topic_exercise_xccdba2de: {
            description: t`Precalculus: Limits (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Precalculus: Limits (old)`,
        },
        topic_exercise_xf3359483e23b2c11_mastery: {
            description: t`Precalculus: Matrices`,
            extendedDescription: t`Achieve mastery in all skills in Precalculus: Matrices`,
        },
        topic_exercise_xf3359483e23b2c11: {
            description: t`Precalculus: Matrices (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Precalculus: Matrices (old)`,
        },
        topic_exercise_x73a93038_mastery: {
            description: t`Precalculus: Miscellaneous`,
            extendedDescription: t`Achieve mastery in all skills in Precalculus: Miscellaneous`,
        },
        topic_exercise_x73a93038: {
            description: t`Precalculus: Miscellaneous (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Precalculus: Miscellaneous (old)`,
        },
        topic_exercise_x565a9cde_mastery: {
            description: t`Precalculus: Old content`,
            extendedDescription: t`Achieve mastery in all skills in Precalculus: Old content`,
        },
        topic_exercise_x565a9cde: {
            description: t`Precalculus: Old content (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Precalculus: Old content (old)`,
        },
        topic_exercise_x2f0599c0_mastery: {
            description: t`Precalculus: Parametric equations and polar coordinates`,
            extendedDescription: t`Achieve mastery in all skills in Precalculus: Parametric equations and polar coordinates`,
        },
        topic_exercise_x2f0599c0: {
            description: t`Precalculus: Parametric equations and polar coordinates (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Precalculus: Parametric equations and polar coordinates (old)`,
        },
        topic_exercise_x16d5efc0_mastery: {
            description: t`Precalculus: Partial fraction expansion`,
            extendedDescription: t`Achieve mastery in all skills in Precalculus: Partial fraction expansion`,
        },
        topic_exercise_x16d5efc0: {
            description: t`Precalculus: Partial fraction expansion (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Precalculus: Partial fraction expansion (old)`,
        },
        topic_exercise_xe5e4a94e5fae32e4_mastery: {
            description: t`Precalculus: Polynomials`,
            extendedDescription: t`Achieve mastery in all skills in Precalculus: Polynomials`,
        },
        topic_exercise_xe5e4a94e5fae32e4: {
            description: t`Precalculus: Polynomials (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Precalculus: Polynomials (old)`,
        },
        topic_exercise_xfdf2af743c0d3e11_mastery: {
            description: t`Precalculus: Probability and combinatorics`,
            extendedDescription: t`Achieve mastery in all skills in Precalculus: Probability and combinatorics`,
        },
        topic_exercise_xfdf2af743c0d3e11: {
            description: t`Precalculus: Probability and combinatorics (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Precalculus: Probability and combinatorics (old)`,
        },
        topic_exercise_x5cb908fc82fc0822_mastery: {
            description: t`Precalculus: Series`,
            extendedDescription: t`Achieve mastery in all skills in Precalculus: Series`,
        },
        topic_exercise_x5cb908fc82fc0822: {
            description: t`Precalculus: Series (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Precalculus: Series (old)`,
        },
        topic_exercise_x19857b64d324594c_mastery: {
            description: t`Precalculus: Trigonometry`,
            extendedDescription: t`Achieve mastery in all skills in Precalculus: Trigonometry`,
        },
        topic_exercise_x19857b64d324594c: {
            description: t`Precalculus: Trigonometry (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Precalculus: Trigonometry (old)`,
        },
        topic_exercise_x82a94acb1662e168_mastery: {
            description: t`Precalculus: Vectors`,
            extendedDescription: t`Achieve mastery in all skills in Precalculus: Vectors`,
        },
        topic_exercise_x82a94acb1662e168: {
            description: t`Precalculus: Vectors (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Precalculus: Vectors (old)`,
        },
        topic_exercise_XQlJ7xotRQg3QeW9VCiED2Jt7T7VmIkAoQP03zq9_mastery: {
            description: t`Probability and statistics`,
            extendedDescription: t`Achieve mastery in all skills in Probability and statistics`,
        },
        topic_exercise_xa88397b6_mastery: {
            description: t`Probability and statistics`,
            extendedDescription: t`Achieve mastery in all skills in Probability and statistics`,
        },
        topic_exercise_XQlJ7xotRQg3QeW9VCiED2Jt7T7VmIkAoQP03zq9: {
            description: t`Probability and statistics (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Probability and statistics (old)`,
        },
        topic_exercise_xa88397b6: {
            description: t`Probability and statistics (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Probability and statistics (old)`,
        },
        topic_exercise_F6HMxt5WIsTwuZg55JwqD8vSeWOzgL7KXF6gwb_L_mastery: {
            description: t`Probability and statistics: Descriptive statistics`,
            extendedDescription: t`Achieve mastery in all skills in Probability and statistics: Descriptive statistics`,
        },
        topic_exercise_F6HMxt5WIsTwuZg55JwqD8vSeWOzgL7KXF6gwb_L: {
            description: t`Probability and statistics: Descriptive statistics (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Probability and statistics: Descriptive statistics (old)`,
        },
        "topic_exercise_tf9_KxxFyk3PZL_H-TI737zm9F79wgqa9CpUwM0z_mastery": {
            description: t`Probability and statistics: Independent and dependent events`,
            extendedDescription: t`Achieve mastery in all skills in Probability and statistics: Independent and dependent events`,
        },
        "topic_exercise_tf9_KxxFyk3PZL_H-TI737zm9F79wgqa9CpUwM0z": {
            description: t`Probability and statistics: Independent and dependent events (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Probability and statistics: Independent and dependent events (old)`,
        },
        topic_exercise_a11EYuB8JELuSLuK70DfUGQlRMEKtVAxQdu1UtVK_mastery: {
            description: t`Probability and statistics: Inferential statistics`,
            extendedDescription: t`Achieve mastery in all skills in Probability and statistics: Inferential statistics`,
        },
        topic_exercise_a11EYuB8JELuSLuK70DfUGQlRMEKtVAxQdu1UtVK: {
            description: t`Probability and statistics: Inferential statistics (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Probability and statistics: Inferential statistics (old)`,
        },
        topic_exercise_x1dbb4462_mastery: {
            description: t`Probability and statistics: Miscellaneous`,
            extendedDescription: t`Achieve mastery in all skills in Probability and statistics: Miscellaneous`,
        },
        topic_exercise_x1dbb4462: {
            description: t`Probability and statistics: Miscellaneous (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Probability and statistics: Miscellaneous (old)`,
        },
        "topic_exercise_pFqSEsww-CMNvFtzI8zZ4ToUpyftBXFOWbdnypdU_mastery": {
            description: t`Probability and statistics: Probability and combinatorics`,
            extendedDescription: t`Achieve mastery in all skills in Probability and statistics: Probability and combinatorics`,
        },
        "topic_exercise_pFqSEsww-CMNvFtzI8zZ4ToUpyftBXFOWbdnypdU": {
            description: t`Probability and statistics: Probability and combinatorics (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Probability and statistics: Probability and combinatorics (old)`,
        },
        "topic_exercise_yJft0qf5s2n5Ie4UEx4OL8sPACeQLJAAv-Zox2pF_mastery": {
            description: t`Probability and statistics: Random variables and probability distributions`,
            extendedDescription: t`Achieve mastery in all skills in Probability and statistics: Random variables and probability distributions`,
        },
        "topic_exercise_yJft0qf5s2n5Ie4UEx4OL8sPACeQLJAAv-Zox2pF": {
            description: t`Probability and statistics: Random variables and probability distributions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Probability and statistics: Random variables and probability distributions (old)`,
        },
        "topic_exercise_waVh_4BIz7-iGpkl6jbWXq2dWIWTs53Gi1mb37rt_mastery": {
            description: t`Probability and statistics: Regression`,
            extendedDescription: t`Achieve mastery in all skills in Probability and statistics: Regression`,
        },
        "topic_exercise_waVh_4BIz7-iGpkl6jbWXq2dWIWTs53Gi1mb37rt": {
            description: t`Probability and statistics: Regression (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Probability and statistics: Regression (old)`,
        },
        topic_exercise_x9f54cbb4_mastery: {
            description: t`Probability and statistics: Statistical studies`,
            extendedDescription: t`Achieve mastery in all skills in Probability and statistics: Statistical studies`,
        },
        topic_exercise_x9f54cbb4: {
            description: t`Probability and statistics: Statistical studies (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Probability and statistics: Statistical studies (old)`,
        },
        "topic_exercise_LG71-yDGhJGaSWe3sQ99vsMq92PyzTsZY7AyG5Fh_mastery": {
            description: t`Pythagorean theorem`,
            extendedDescription: t`Achieve mastery in all skills in Pythagorean theorem`,
        },
        "topic_exercise_w1X8V1pSn57woJx6mOdgiLDPUywqjbnRauWC-8eJ_mastery": {
            description: t`Pythagorean theorem`,
            extendedDescription: t`Achieve mastery in all skills in Pythagorean theorem`,
        },
        topic_exercise_x0beaeb78_mastery: {
            description: t`Pythagorean theorem`,
            extendedDescription: t`Achieve mastery in all skills in Pythagorean theorem`,
        },
        "topic_exercise_LG71-yDGhJGaSWe3sQ99vsMq92PyzTsZY7AyG5Fh": {
            description: t`Pythagorean theorem (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Pythagorean theorem (old)`,
        },
        "topic_exercise_w1X8V1pSn57woJx6mOdgiLDPUywqjbnRauWC-8eJ": {
            description: t`Pythagorean theorem (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Pythagorean theorem (old)`,
        },
        topic_exercise_x0beaeb78: {
            description: t`Pythagorean theorem (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Pythagorean theorem (old)`,
        },
        topic_exercise_kz15elGdHU5z7CL_XQ6NFSDiNIO53imCH8WzTXdU_mastery: {
            description: t`Quadratics`,
            extendedDescription: t`Achieve mastery in all skills in Quadratics`,
        },
        topic_exercise_x46068850_mastery: {
            description: t`Quadratics`,
            extendedDescription: t`Achieve mastery in all skills in Quadratics`,
        },
        topic_exercise_kz15elGdHU5z7CL_XQ6NFSDiNIO53imCH8WzTXdU: {
            description: t`Quadratics (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Quadratics (old)`,
        },
        topic_exercise_x46068850: {
            description: t`Quadratics (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Quadratics (old)`,
        },
        topic_exercise_3ZiWU1FbU06Aa4imWPVWEN7PV9Um7yXF04CvA8lB_mastery: {
            description: t`Quadrilaterals`,
            extendedDescription: t`Achieve mastery in all skills in Quadrilaterals`,
        },
        topic_exercise_xbb01769c_mastery: {
            description: t`Quadrilaterals`,
            extendedDescription: t`Achieve mastery in all skills in Quadrilaterals`,
        },
        topic_exercise_3ZiWU1FbU06Aa4imWPVWEN7PV9Um7yXF04CvA8lB: {
            description: t`Quadrilaterals (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Quadrilaterals (old)`,
        },
        topic_exercise_xbb01769c: {
            description: t`Quadrilaterals (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Quadrilaterals (old)`,
        },
        topic_exercise_x596e2fc5_mastery: {
            description: t`Rates and ratios`,
            extendedDescription: t`Achieve mastery in all skills in Rates and ratios`,
        },
        topic_exercise_x596e2fc5: {
            description: t`Rates and ratios (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Rates and ratios (old)`,
        },
        topic_exercise_x7db461ca_mastery: {
            description: t`Ratios and rational expressions`,
            extendedDescription: t`Achieve mastery in all skills in Ratios and rational expressions`,
        },
        topic_exercise_x7db461ca: {
            description: t`Ratios and rational expressions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Ratios and rational expressions (old)`,
        },
        topic_exercise_x3941da99_mastery: {
            description: t`Similarity`,
            extendedDescription: t`Achieve mastery in all skills in Similarity`,
        },
        topic_exercise_x3941da99: {
            description: t`Similarity (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Similarity (old)`,
        },
        topic_exercise_ILt5d1Z2xEqnprlB9XmUJbSNo0ohUPP76LrrFvB6_mastery: {
            description: t`Solving linear equations`,
            extendedDescription: t`Achieve mastery in all skills in Solving linear equations`,
        },
        topic_exercise_ILt5d1Z2xEqnprlB9XmUJbSNo0ohUPP76LrrFvB6: {
            description: t`Solving linear equations (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Solving linear equations (old)`,
        },
        topic_exercise_DuLefpBxwlxngjFEyfv72bpJZW4P8QsmidG_gQ6y_mastery: {
            description: t`Solving linear inequalities`,
            extendedDescription: t`Achieve mastery in all skills in Solving linear inequalities`,
        },
        topic_exercise_DuLefpBxwlxngjFEyfv72bpJZW4P8QsmidG_gQ6y: {
            description: t`Solving linear inequalities (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Solving linear inequalities (old)`,
        },
        topic_exercise_x7ca5999e_mastery: {
            description: t`Special properties and parts of triangles`,
            extendedDescription: t`Achieve mastery in all skills in Special properties and parts of triangles`,
        },
        topic_exercise_x7ca5999e: {
            description: t`Special properties and parts of triangles (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Special properties and parts of triangles (old)`,
        },
        "topic_exercise_C5GdZgup3Y_Qk3hGPmVgMF-hWmqg3MSuxxwu2cDS_mastery": {
            description: t`Spider Bot`,
            extendedDescription: t`Achieve mastery in all skills in Spider Bot`,
        },
        "topic_exercise_C5GdZgup3Y_Qk3hGPmVgMF-hWmqg3MSuxxwu2cDS": {
            description: t`Spider Bot (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Spider Bot (old)`,
        },
        "topic_exercise_-W--Na3eGtpCVc0kCIqbg0LE8GHDVDPHBykkU3gj_mastery": {
            description: t`Systems of equations and inequalities`,
            extendedDescription: t`Achieve mastery in all skills in Systems of equations and inequalities`,
        },
        topic_exercise_xd6035bab_mastery: {
            description: t`Systems of equations and inequalities`,
            extendedDescription: t`Achieve mastery in all skills in Systems of equations and inequalities`,
        },
        "topic_exercise_-W--Na3eGtpCVc0kCIqbg0LE8GHDVDPHBykkU3gj": {
            description: t`Systems of equations and inequalities (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Systems of equations and inequalities (old)`,
        },
        topic_exercise_xd6035bab: {
            description: t`Systems of equations and inequalities (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Systems of equations and inequalities (old)`,
        },
        "topic_exercise_uE6pzc4wW0sC9WfpeFF493N6oi7w_e4pZ-alrrG6_mastery": {
            description: t`Telling time`,
            extendedDescription: t`Achieve mastery in all skills in Telling time`,
        },
        topic_exercise_xa6bcd72f_mastery: {
            description: t`Telling time`,
            extendedDescription: t`Achieve mastery in all skills in Telling time`,
        },
        "topic_exercise_uE6pzc4wW0sC9WfpeFF493N6oi7w_e4pZ-alrrG6": {
            description: t`Telling time (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Telling time (old)`,
        },
        topic_exercise_xa6bcd72f: {
            description: t`Telling time (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Telling time (old)`,
        },
        topic_exercise_xc8e66653_mastery: {
            description: t`Transformations`,
            extendedDescription: t`Achieve mastery in all skills in Transformations`,
        },
        topic_exercise_xc8e66653: {
            description: t`Transformations (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Transformations (old)`,
        },
        "topic_exercise_poP8_dlXseXQhxTvqjWcLxX-MbJ4LI2ezxgFTtFT_mastery": {
            description: t`Triangles`,
            extendedDescription: t`Achieve mastery in all skills in Triangles`,
        },
        "topic_exercise_poP8_dlXseXQhxTvqjWcLxX-MbJ4LI2ezxgFTtFT": {
            description: t`Triangles (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Triangles (old)`,
        },
        topic_exercise_i9cU2Edaq1iebOqo9moc9Nmd7pd8k9yg60m4gSMh_mastery: {
            description: t`Trigonometry and precalculus`,
            extendedDescription: t`Achieve mastery in all skills in Trigonometry and precalculus`,
        },
        topic_exercise_xfefa5515_mastery: {
            description: t`Trigonometry and precalculus`,
            extendedDescription: t`Achieve mastery in all skills in Trigonometry and precalculus`,
        },
        topic_exercise_i9cU2Edaq1iebOqo9moc9Nmd7pd8k9yg60m4gSMh: {
            description: t`Trigonometry and precalculus (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Trigonometry and precalculus (old)`,
        },
        topic_exercise_xfefa5515: {
            description: t`Trigonometry and precalculus (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Trigonometry and precalculus (old)`,
        },
        topic_exercise_xb1166488_mastery: {
            description: t`Trigonometry: Graphs of trigonometric functions`,
            extendedDescription: t`Achieve mastery in all skills in Trigonometry: Graphs of trigonometric functions`,
        },
        topic_exercise_xb1166488: {
            description: t`Trigonometry: Graphs of trigonometric functions (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Trigonometry: Graphs of trigonometric functions (old)`,
        },
        topic_exercise_xeada9044_mastery: {
            description: t`Trigonometry: Miscellaneous`,
            extendedDescription: t`Achieve mastery in all skills in Trigonometry: Miscellaneous`,
        },
        topic_exercise_xeada9044: {
            description: t`Trigonometry: Miscellaneous (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Trigonometry: Miscellaneous (old)`,
        },
        topic_exercise_x281ace3f_mastery: {
            description: t`Trigonometry: Old content`,
            extendedDescription: t`Achieve mastery in all skills in Trigonometry: Old content`,
        },
        topic_exercise_x281ace3f: {
            description: t`Trigonometry: Old content (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Trigonometry: Old content (old)`,
        },
        topic_exercise_x36c957e4_mastery: {
            description: t`Trigonometry: The unit circle definition of sine, cosine, and tangent`,
            extendedDescription: t`Achieve mastery in all skills in Trigonometry: The unit circle definition of sine, cosine, and tangent`,
        },
        topic_exercise_x36c957e4: {
            description: t`Trigonometry: The unit circle definition of sine, cosine, and tangent (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Trigonometry: The unit circle definition of sine, cosine, and tangent (old)`,
        },
        "topic_exercise_1cma_FaxmfJzuGtkwR93uwPA-wOqlh4W69Wafn26_mastery": {
            description: t`Trigonometry: Trigonometric equations and identities`,
            extendedDescription: t`Achieve mastery in all skills in Trigonometry: Trigonometric equations and identities`,
        },
        "topic_exercise_1cma_FaxmfJzuGtkwR93uwPA-wOqlh4W69Wafn26": {
            description: t`Trigonometry: Trigonometric equations and identities (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Trigonometry: Trigonometric equations and identities (old)`,
        },
        topic_exercise_x3f4bb451_mastery: {
            description: t`Trigonometry: Trigonometry with general triangles`,
            extendedDescription: t`Achieve mastery in all skills in Trigonometry: Trigonometry with general triangles`,
        },
        topic_exercise_x3f4bb451: {
            description: t`Trigonometry: Trigonometry with general triangles (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Trigonometry: Trigonometry with general triangles (old)`,
        },
        "topic_exercise_wis13EsT4u0aOUkKUPVvMoUW1ILCoo-U0e3qRWgh_mastery": {
            description: t`Trigonometry: Trigonometry with right triangles`,
            extendedDescription: t`Achieve mastery in all skills in Trigonometry: Trigonometry with right triangles`,
        },
        "topic_exercise_wis13EsT4u0aOUkKUPVvMoUW1ILCoo-U0e3qRWgh": {
            description: t`Trigonometry: Trigonometry with right triangles (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Trigonometry: Trigonometry with right triangles (old)`,
        },
        "topic_exercise_Fkikjl1_3u8ZRTtjWHEiibzfK4Z_y5yvgYs-PlCy_mastery": {
            description: t`Variables`,
            extendedDescription: t`Achieve mastery in all skills in Variables`,
        },
        "topic_exercise_Fkikjl1_3u8ZRTtjWHEiibzfK4Z_y5yvgYs-PlCy": {
            description: t`Variables (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Variables (old)`,
        },
        "topic_exercise_t4B-w8_x_OAaX1N6RNH_7Pessb4vRhqDR-jge3sr_mastery": {
            description: t`Vectors`,
            extendedDescription: t`Achieve mastery in all skills in Vectors`,
        },
        topic_exercise_x7291eb9f_mastery: {
            description: t`Vectors`,
            extendedDescription: t`Achieve mastery in all skills in Vectors`,
        },
        "topic_exercise_t4B-w8_x_OAaX1N6RNH_7Pessb4vRhqDR-jge3sr": {
            description: t`Vectors (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Vectors (old)`,
        },
        topic_exercise_x7291eb9f: {
            description: t`Vectors (old)`,
            extendedDescription: t`Achieve proficiency in all skills in Vectors (old)`,
        },
        creatednewscratchpadbadge: {
            description: t`Apprentice Programmer`,
            extendedDescription: t`Create a program from scratch`,
        },
        forkedofficialscratchpadbadge: {
            description: t`Mad Scientist`,
            extendedDescription: t`Make changes to an official program`,
        },
        forkeduserscratchpadbadge: {
            description: t`Collaborator`,
            extendedDescription: t`Make changes to another user's program`,
        },
        getforkedoncebadge: {
            description: t`Inspiration`,
            extendedDescription: t`Another user created a program based on one of yours`,
        },
        getforkedtentimesbadge: {
            description: t`Good Inspiration`,
            extendedDescription: t`Other users created 10 programs based on one of yours`,
        },
        getforkedtwentyfivetimesbadge: {
            description: t`Great Inspiration`,
            extendedDescription: t`Other users created 25 programs based on one of yours`,
        },
        getforkedfiftytimesbadge: {
            description: t`Incredible Inspiration`,
            extendedDescription: t`Other users created 50 programs based on one of yours`,
        },
        sharedscratchpadbadge: {
            description: t`Virus`,
            extendedDescription: t`Share a program you've created via Facebook, Twitter, or email`,
        },
        scratchpadtinkererbadge: {
            description: t`Tinkerer`,
            extendedDescription: t`Pause a talk-through and tinker with the code`,
        },
        watchedscratchpadplaybackbadge: {
            description: t`Programming Scholar`,
            extendedDescription: t`Finish watching a computer programming talk-through`,
        },
        completechallengebadge: {
            description: t`Challenger`,
            extendedDescription: t`Complete a coding challenge`,
        },
        kelvinbadge: {
            description: t`1000 Kelvin`,
            extendedDescription: t`Have a red-hot program at the top of the Community Programs list`,
        },
        documentationdoctorbadge: {
            description: t`Documentation Doctor`,
            extendedDescription: t`Create documentation for our programming courses`,
        },
        trustedtesterbadge: {
            description: t`Trusted Tester`,
            extendedDescription: t`Review our programming courses before we release them`,
        },
        drawinganimationmasterybadge: {
            description: t`Intro to JS: Drawing & Animation Mastery`,
            extendedDescription: t`Complete all the 'Intro to JS: Drawing & Animation' challenges.`,
        },
        naturalsimulationsmasterybadge: {
            description: t`Advanced JS: Natural Simulations`,
            extendedDescription: t`Complete all the 'Advanced JS: Natural Simulations' challenges.`,
        },
        htmlcssmasterybadge: {
            description: t`HTML/CSS: Making webpages`,
            extendedDescription: t`Complete all the 'HTML/CSS: Making webpages' challenges.`,
        },
        htmlcssjsmasterybadge: {
            description: t`HTML/JS: Making webpages interactive`,
            extendedDescription: t`Complete all the 'HTML/JS: Making webpages interactive' challenges.`,
        },
        sqlmasterybadge: {
            description: t`Intro to SQL: Querying and managing data`,
            extendedDescription: t`Complete all the 'Intro to SQL' challenges.`,
        },
        jquerymasterybadge: {
            description: t`HTML/JS: Making webpages interactive with jQuery`,
            extendedDescription: t`Complete all the jQuery challenges.`,
        },
        hourofdrawingbadge: {
            description: t`Hour of Drawing with Code`,
            extendedDescription: t`Complete the Hour of Drawing with Code for Hour of Code!`,
        },
        hourofdrawing2015badge: {
            description: t`Hour of Drawing with Code`,
            extendedDescription: t`Complete the Hour of Drawing with Code for Hour of Code!`,
        },
        hourofdrawingblocksbadge: {
            description: t`Hour of Drawing with Code Blocks`,
            extendedDescription: t`Complete the Hour of Drawing with Blocks for Hour of Code!`,
        },
        hourofdatabasesbadge: {
            description: t`Hour of Databases`,
            extendedDescription: t`Complete the Hour of Databases for Hour of Code!`,
        },
        hourofwebpagesbadge: {
            description: t`Hour of Webpages`,
            extendedDescription: t`Complete the Hour of Webpages for Hour of Code!`,
        },
        jsdrawingbadge: {
            description: t`JS: Drawing`,
            extendedDescription: t`Complete the drawing tutorial in Intro to JS`,
        },
        jscoloringbadge: {
            description: t`JS: Coloring`,
            extendedDescription: t`Complete the coloring tutorial in Intro to JS`,
        },
        jsvariablesbadge: {
            description: t`JS: Variables`,
            extendedDescription: t`Complete the variables tutorial in Intro to JS`,
        },
        jsanimationbadge: {
            description: t`JS: Animation`,
            extendedDescription: t`Complete the animation tutorial in Intro to JS`,
        },
        jsinteractionbadge: {
            description: t`JS: Interactive programs`,
            extendedDescription: t`Complete the interactive programs tutorial in Intro to JS`,
        },
        jsresizingvariablesbadge: {
            description: t`JS: Resizing with variables`,
            extendedDescription: t`Complete the resizing with variables tutorial in Intro to JS`,
        },
        jstextbadge: {
            description: t`JS: Text and strings`,
            extendedDescription: t`Complete the text and strings tutorial in Intro to JS`,
        },
        jsfunctionsbadge: {
            description: t`JS: Functions`,
            extendedDescription: t`Complete the functions tutorial in Intro to JS`,
        },
        jslogicbadge: {
            description: t`JS: Logic and if statements`,
            extendedDescription: t`Complete the logic and if statements tutorial in Intro to JS`,
        },
        jsloopingbadge: {
            description: t`JS: Looping`,
            extendedDescription: t`Complete the looping tutorial in Intro to JS`,
        },
        jsarraysbadge: {
            description: t`JS: Arrays`,
            extendedDescription: t`Complete the arrays tutorial in Intro to JS`,
        },
        jsobjectsbadge: {
            description: t`JS: Objects`,
            extendedDescription: t`Complete the objects tutorial in Intro to JS`,
        },
        jsoobadge: {
            description: t`JS: Object-Oriented Design`,
            extendedDescription: t`Complete the OO design tutorial in Intro to JS`,
        },
        "100weekstreakbadge": {
            description: t`Phoenix`,
            extendedDescription: t`Rising to new heights like a phoenix—nearly two years of unwavering dedication!`,
        },
        "75weekstreakbadge": {
            description: t`Forge`,
            extendedDescription: t`Forging ahead! Nearly a year and a half of shaping your knowledge!`,
        },
        "50weekstreakbadge": {
            description: t`Furnace`,
            extendedDescription: t`Fueled by determination, you've kept the furnace burning for nearly an entire year!`,
        },
        "25weekstreakbadge": {
            description: t`Bonfire`,
            extendedDescription: t`Your passion is a bonfire—nearly half a year of uninterrupted learning!`,
        },
        "15weekstreakbadge": {
            description: t`Torch`,
            extendedDescription: t`Illuminating progress! You've carried the torch for over 3 months!`,
        },
        "10weekstreakbadge": {
            description: t`Flame`,
            extendedDescription: t`Your flame of knowledge burns bright with over 2 months of learning!`,
        },
        "5weekstreakbadge": {
            description: t`Spark`,
            extendedDescription: t`Your learning journey has sparked over 1 month of continuous dedication!`,
        },
        "1weekstreakbadge": {
            description: t`1-week streak`,
            extendedDescription: t`Your learning journey has sparked over 1 month of continuous dedication!`,
        },
        proficiencylevel5badge: {
            description: t`Droplet`,
            extendedDescription: t`Every great journey begins with a single droplet! You've learned 10 skills to reach Level 5!`,
        },
        proficiencylevel10badge: {
            description: t`Ripple`,
            extendedDescription: t`Your efforts are growing—a significant ripple in your learning! With 45 skills under your belt, you've achieved Level 10!`,
        },
        proficiencylevel15badge: {
            description: t`Wave`,
            extendedDescription: t`Riding the wave of knowledge towards success! You've conquered 105 skills to reach Level 15!`,
        },
        proficiencylevel25badge: {
            description: t`Torrent`,
            extendedDescription: t`Your progress flows like a powerful torrent! Learning 300 skills has brought you to Level 25!`,
        },
        proficiencylevel50badge: {
            description: t`Cascade`,
            extendedDescription: t`Your achievements cascade magnificently! Reaching Level 50 means you've learned 1,225 skills!`,
        },
        proficiencylevel75badge: {
            description: t`Tempest`,
            extendedDescription: t`An unstoppable force! Your learning is a raging tempest of knowledge! With 2,775 skills completed, you've achieved Level 75!`,
        },
        proficiencylevel100badge: {
            description: t`Maelstrom`,
            extendedDescription: t`You've become a monumental maelstrom of wisdom! By learning 4,950 skills, you've achieved Level 100!`,
        },
    }),
);
